/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    my_video_shorts: 'ကျွန်ုပ်၏ ဗီဒီယိုရှော့များ',
    see_more: 'နောက်ထပ်ကြည့်ရန်',
    no_shorts_found: 'ရှော့များ မတွေ့ပါ',
    shorts: 'ရှော့များ',
    general_information: 'အထွေထွေ အချက်အလက်',
    gamification: 'ဂိမ်းပြိုင်ဆိုင်မှု',
    click_to_select_files: 'ဖိုင်များကို ရွေးရန် နှိပ်ပါ',
    selected_files: 'ရွေးချယ်ထားသောဖိုင်များ',
    uploaded: 'အပ်လုပ်ပြီး',
    failed: 'မအောင်မြင်ပါ',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'စနစ်သည် သင်၏အဖွဲ့အစည်း၏ စာကြည့်တိုက်မှ အကြောင်းအရာလိုအပ်ချက်အပေါ် အခြေခံ၍ အကျိုးရှိဆုံးစာရွက်များကို အလိုအလျောက် သုံးသပ်ပြီး ရွေးချယ်ပါမည်။',
    select_from_library: 'စာကြည့်တိုက်မှ ရွေးပါ',
    search_document: 'စာရွက်ကို ရှာပါ...',
    selected: 'ရွေးချယ်ထားသည်',
    loading_documents: 'စာရွက်များကို loading လုပ်နေသည်...',
    review_generated_content: 'ထုတ်လုပ်ထားသော အကြောင်းအရာကို ပြန်လည်သုံးသပ်ပါ',
    confirm_and_replace_content: 'အကြောင်းအရာကို အတည်ပြု၍ အစားထိုးပါ',
    the_generate_content_will_replace:
      'ထုတ်လုပ်ထားသောအကြောင်းအရာသည် ရွေးချယ်ထားသော စာမျက်နှာများပေါ်ရှိ ယခင်စာသားကို အစားထိုးမည်။ သင်သည် ဤပြောင်းလဲမှုများကို မအသုံးချလိုပါက ယခင်အဆင့်သို့ ပြန်သွားနိုင်ပါသည်။',
    pages_to_be_updated: 'အပ်ဒိတ်လုပ်ရန် စာမျက်နှာများ',
    generated_revisions: 'ထုတ်လုပ်ထားသော ပြင်ဆင်မှုများ',
    lesson_preview: 'သင်ခန်းစာ ကြိုကြည့်မည်',
    create_new_folder: 'ဖိုလ်ဒါအသစ် ဖန်တီးမည်',
    rename_item: 'အရာအမည်ပြောင်းမည်',
    enter_folder_name: 'ဖိုလ်ဒါအမည် ရိုက်ထည့်ပါ:',
    enter_new_name: 'အမည်အသစ် ရိုက်ထည့်ပါ:',
    folder_name: 'ဖိုလ်ဒါအမည်:',
    new_name: 'အမည်အသစ်',
    move_items: 'အရာများကိုရွှေ့မည်',
    copy_items: 'အရာများကို ကူးယူမည်',
    move_here: 'ဤနေရာသို့ ရွှေ့မည်',
    copy_here: 'ဤနေရာသို့ ကူးယူမည်',
    select_destination_library_and_folder:
      'လွှဲပြောင်းမည့် စာကြည့်တိုက်နှင့် ဖိုလ်ဒါကို ရွေးပါ:',
    items_selected: 'ရွေးချယ်ထားသော အရာများ',
    version: 'ဗားရှင်း',
    modified_by: 'ပြင်ဆင်သူ',
    size: 'အရွယ်အစား',
    restore: 'ပြန်လည်ထည့်သွင်းမည်',
    are_you_sure_you_want_to_restore_this_version:
      'ဤဗားရှင်းကို ပြန်လည်ထည့်သွင်းလိုသလား?',
    this_will_replce_the_current_version_with_the_selected_one:
      'ယခင်ဗားရှင်းကို ရွေးချယ်ထားသည့်ဗားရှင်းဖြင့် အစားထိုးမည်။',
    restore_this_version: 'ဤဗားရှင်းကို ပြန်လည်ထည့်သွင်းမည်',
    restore_not_available: 'ပြန်လည်ထည့်သွင်းရန် မရနိုင်ပါ',
    version_history: 'ဗားရှင်းသမိုင်း:',
    by_making_items_public:
      'အရာများကို အများသုံးနိုင်အောင် ပြုလုပ်ပါက အားလုံးမြင်နိုင်မည်။ ကျေးဇူးပြုပြီး စည်းမျဉ်းများကို ကြည့်ပါ။',
    the_selected_items_will_be_copied:
      'ရွေးချယ်ထားသောအရာများသည် သင့်ပုဂ္ဂိုလ်ရေးစာကြည့်တိုက်သို့ ကူးယူပြီး အားလုံးမြင်နိုင်မည်။',
    the_selected_items_will_be_copied_to_org:
      'ရွေးချယ်ထားသောအရာများသည် သင့်အဖွဲ့အစည်းစာကြည့်တိုက်သို့ ကူးယူပြီး အဖွဲ့သားအားလုံးမြင်နိုင်မည်။',
    the_selected_items_will_be_copied_to_your_private:
      'ရွေးချယ်ထားသောအရာများသည် သင့်ပုဂ္ဂိုလ်ရေးစာကြည့်တိုက်သို့ ကူးယူပြီး သင်တစ်ယောက်သာ မြင်နိုင်မည်။',
    loading_organization: 'အဖွဲ့အစည်းအသုံးပြုသူများကို loading လုပ်နေသည်...',
    click_download_to_view: 'ကြည့်ရန် download ကို နှိပ်ပါ',
    archive_file: 'စာရွက်သိုလှောင်ရန်',
    no_preview_available: 'ကြိုကြည့်မှု မရနိုင်ပါ',
    audit_report: 'စစ်ဆေးမှုအစီရင်ခံစာ',
    audit_type: 'လှုပ်ရှားမှုအမျိုးအစား',
    i_agree_to_the_terms_and_conditions:
      'စည်းမျဉ်းနှင့်စည်းကမ်းများနှင့် သဘောတူသည်',
    this_file_is_indexed_for_ai: 'ဤဖိုင်ကို AI အတွက် စာရင်းသွင်းထားသည်',
    file_is_not_indexed_for_ai: 'ဖိုင်ကို AI အတွက် စာရင်းသွင်းထားခြင်း မရှိပါ',
    no_users_found: 'အသုံးပြုသူ မတွေ့ပါ',
    no_users_available: 'အသုံးပြုသူ မရှိပါ',
    add_people: 'လူများထည့်မည်',
    people: 'လူများ',
    access_type: 'အောက်စီရက်စ်အမျိုးအစား',
    no_group_found: 'အုပ်စု မတွေ့ပါ',
    add_group: 'အုပ်စု ထည့်မည်',
    groups: 'အုပ်စုများ',
    users_top: 'အသုံးပြုသူများ',
    confirm_delete: 'ဖျက်ရန် အတည်ပြုပါ',
    do_you_want_remove: 'ဖျက်ချင်ပါသလား',
    form_this_documents_permissions: 'ဤစာရွက်၏ ခွင့်များမှ?',
    no_users_found_in_this_group: 'ဤအုပ်စုတွင် အသုံးပြုသူ မတွေ့ပါ',
    add_selected_users: 'ရွေးချယ်ထားသော အသုံးပြုသူများ ထည့်မည်',
    choose_users_from_the_list: 'စာရင်းမှ အသုံးပြုသူများကို ရွေးပါ',
    selected_users: 'ရွေးချယ်ထားသော အသုံးပြုသူများ',
    archived: 'သိုလှောင်ပြီး',
    request_approval: 'အတည်ပြုချက် တောင်းရန်',
    document_in_review: 'စာရွက်ကို သုံးသပ်နေသည်',
    approve: 'အတည်ပြု',
    reject: 'ငြင်းပယ်',
    comment: 'မှတ်ချက်:',
    enter_your_commit: 'သင့်မှတ်ချက်ထည့်ပါ...',
    confirm_cancel: 'ပယ်ဖျက်ရန် အတည်ပြုပါ',
    upload_3d_zip: '3D Zip ကို အပ်လုပ်မည်',
    delete_items: 'အရာများ ဖျက်မည်',
    video_upload_request: 'ဗီဒီယို အပ်လုပ်ရန် အမိန့်',
    reject_video: 'ဗီဒီယိုကို ငြင်းပယ်မည်',
    enter_rejection_reason: 'ငြင်းပယ်ရန် အကြောင်းရင်းထည့်ပါ...',
    please_provide_a_reason_for_reejection_this_video:
      'ဤဗီဒီယိုကို ငြင်းပယ်ရန် အကြောင်းရင်း ရိုက်ထည့်ပါ:',
    generate_trivia_with_ai: 'AI ဖြင့် Trivia ဖန်တီးပါ',
    select_category: 'အမျိုးအစား ရွေးပါ:',
    number_of_question: 'မေးခွန်းအရေအတွက်',
    generated_questions: 'ထုတ်လုပ်ထားသောမေးခွန်းများ',
    this_will_clear_all_generate_question:
      'ဤသည်သည် ထုတ်လုပ်ထားသောမေးခွန်းအားလုံးကို ဖျက်မည်။ ဆက်လုပ်မည်လား?',
    sure_delete: 'ဖျက်ရန် သေချာပါသလား?',
    delete_this_question: 'ဤမေးခွန်းကို ဖျက်ရန် သေချာပါသလား?',
    loading_quiz: 'မေးခွန်းစာရင်းကို loading လုပ်နေသည်...',
    creteing_file: 'ဖိုင် ဖန်တီးနေသည်',
    opening_desktop_app: 'Desktop အက်ပ် ဖွင့်နေသည်',
    this_folder_is_empty: 'ဤဖိုလ်ဒါသည် လွတ်နေသည်',
    select_a_competition: 'ပြိုင်ပွဲကို ရွေးပါ...',
    activity_badges: 'လှုပ်ရှားမှုဘတ်ချ်များ',
    awarded_every_badges:
      'လော့ဂ်အင် 4, 8, 16, 32, 64, 128, 256, 512 အားလုံးကို ဆုချီးမြှင့်မည်',
    learning_badges: 'သင်ယူမှုဘတ်ချ်များ',
    awarded_every_courses:
      'ပြီးဆုံးသည့် သင်တန်း 1, 4, 8, 16, 32, 64, 128 အားလုံးကို ဆုချီးမြှင့်မည်',
    test_badges: 'စမ်းသပ်မှုဘတ်ချ်များ',
    awarded_every_passes_tests:
      'ဖြေသင့်သည့် စမ်းသပ်မှု 2, 4, 8, 16, 32, 64, 128, 256 အားလုံးကို ဆုချီးမြှင့်မည်',
    assignment_badges: 'တာဝန်သတ်မှတ်မှုဘတ်ချ်များ',
    awarded_every_passed_assignments:
      'ပြီးဆုံးသည့် တာဝန်သတ်မှတ်မှု 1, 2, 4, 8, 16, 32, 64, 128 အားလုံးကို ဆုချီးမြှင့်မည်',
    perfectionism_badges: 'ကြပ်မတ်မှုဘတ်ချ်များ',
    awarded_every_assignments_with_scrore:
      '90%+ အမှတ်ဖြင့် အစီအစဉ်များ သို့မဟုတ် တာဝန်သတ်မှတ်မှု 1, 2, 4, 8, 16, 32, 64, 128 အားလုံးကို ဆုချီးမြှင့်မည်',
    communication_badges: 'ဆက်သွယ်ရေးဘတ်ချ်များ',
    awarded_every_topics_or_comments:
      'ခေါင်းစဉ်များ သို့မဟုတ် မှတ်ချက်များ 2, 4, 8, 16, 32, 64, 128, 256 အားလုံးကို ဆုချီးမြှင့်မည်',
    certification_badges: 'လက်မှတ်ဘတ်ချ်များ',
    awarded_every_certificates:
      'လက်မှတ် 1, 2, 4, 8, 16, 32, 64, 128 အားလုံးကို ဆုချီးမြှင့်မည်',
    level_name: 'အဆင့်အမည်',
    delete_competition: 'ပြိုင်ပွဲ ဖျက်မည်',
    this_week: 'ဤအပတ်',
    this_year: 'ဤနှစ်',
    make_organization: 'အဖွဲ့အစည်း ဖန်တီးမည်',
    no_results_found: 'ရလဒ် မတွေ့ပါ',
    no_items_available: 'အရာ မရှိပါ',
    help_video: 'အကူအညီဗီဒီယို',
    select_a_video_from_the_list: 'သင်ယူရန် စာရင်းမှ ဗီဒီယိုကို ရွေးပါ'
  },
  v4: {
    drop_files: 'ဖိုင်တွေကို ဒရပ်ထားပြီး တင်ပါ၊ နှင့် သတ်မှတ်ချက်ရွေးပါ။',
    duplicate_lessoon: 'ဒီသင်ခန်းစာကို သင်ခန်းစာအတွင်းမှာ ရှိပြီးသားဖြစ်ပါတယ်',
    skill_rule_title: 'ကျေးဇူးပြု၍ Skill Journey ခေါင်းစဉ်ရေးပါ',
    imageCreatorTitle: 'ပုံဖန်တီးသူ',
    isTranslated: 'ဘာသာပြန်ပြီး',
    translationCourseDesc:
      'ဤသင်တန်း၏ ဘာသာပြန်မှုသည် အချိန်ယူနိုင်ပါသည်။ သည်းခံမှုအတွက် ကျေးဇူးတင်ပါသည်။',
    translateCourseTip:
      'မူလသင်တန်းမှ လွတ်လပ်စွာ ပြုပြင်ရန် ဘာသာပြန်သင်တန်းကို ဖန်တီးမည်ဖြစ်သည်။ သင်ခန်းစာနှင့် စာမျက်နှာများအားလုံး ပါဝင်ပါမည်။',
    translateModalBtn: 'ဘာသာပြန်ပါ',
    translationSuccess: '“<0/>” သင်တန်းကို အောင်မြင်စွာ ဘာသာပြန်ပြီးပါပြီ!',
    translatingCourse: 'သင်တန်းကို ဘာသာပြန်နေပါသည်...',
    translateModalTitle: 'သင်တန်း ဘာသာပြန်ပါ',
    translateSelectLang: 'ဘာသာစကား ရွေးပါ',
    fileDeleteconfirm:
      'ဒီဖိုင်ကို ဖျက်မှာ သေချာပါသလား? ဒီအလုပ်မှာ ပြန်လည်မပြောင်းလဲနိုင်ပါ။',
    fileDeleteMessage: 'ဖိုင်ကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ။',
    fileDeleteFailedMessage: 'ဖိုင်ဖျက်ရန် မအောင်မြင်ပါ!',
    fileDelete: 'ဒီဖိုင်ကို ဖျက်ပါ။',
    certificate_save_btn: 'အထောက်အထားထည့်ပါ',
    maze_path_info: 'ဂရပ်ထဲတွင် လမ်းကြောင်းမတွေ့ပါ!',
    file_size_mb: 'ဖိုင်အရွယ်အစားသည် ၂၅ မက်ဘီထက်နည်းရပါမည်!',
    reports: {
      products: 'ထုတ်ကုန်များ',
      users: 'အသုံးပြုသူများ',
      ph_username: 'အသုံးပြုသူအမည် ရှာဖွေပါ',
      ph_id: 'အသုံးပြုသူ ID နံပါတ် ရှာဖွေပါ',
      ph_email: 'အသုံးပြုသူအီးမေးလ် ရှာဖွေပါ'
    },
    select_upload_section_id: 'ဖိုင်အပိုင်းရွေးချယ်ခြင်းလိုအပ်သည်',
    tags_all: 'အားလုံး',
    delete_file_confirm: 'ဒီဖိုင်ကို ဖျက်မှာ သေချာပါသလား?',
    delete_file_title: 'ဖိုင်ဖျက်ပါ',
    tooltip_publish: 'ရွေးထားသော ရွေးချယ်မှုဖြင့် သင်တန်းကို ထုတ်ပြန်ပါ',
    tooltip_save: 'လက်ရှိပြင်ဆင်မှုများနှင့် သင်တန်းကို သိမ်းဆည်းပါ',
    tooltip_next: 'နောက်တစ်ဆင့် သင်တန်းဆက်တင်သို့ သွားပါ',
    tooltip_finish: 'လက်ရှိ ပြင်ဆင်မှုများကို ပြီးဆုံးပြီး သိမ်းဆည်းပါ',
    stories_modal: {
      title_upload: 'ပုံပြင်တင်ပါ',
      title_update: 'ပုံပြင်အပ်ဒိတ်လုပ်ပါ',
      title_audio: 'ပုံပြင်အသံဖိုင်',
      btn_upload: 'တင်ပါ',
      btn_update: 'အပ်ဒိတ်လုပ်ပါ',
      btn_close: 'ပိတ်ပါ',
      btn_cancel: 'မလုပ်တော့ပါ',
      lbl_cover: 'ပုံပြင်အဖုံးပုံ',
      rule_cover: 'ပုံပြင်အသံအဖုံးကို တင်ပါ!',
      lbl_title: 'ပုံပြင်အသံခေါင်းစဉ်',
      rule_title: 'ပုံပြင်အသံခေါင်းစဉ်ရေးပါ!',
      lbl_description: 'ပုံပြင်အသံဖော်ပြချက်',
      rule_description: 'ပုံပြင်အသံဖော်ပြချက်ရေးပါ!',
      lbl_file: 'ပုံပြင်အသံဖိုင်တင်ပါ',
      rule_file: 'ပုံပြင်အသံဖိုင်တင်ပါ!',
      rule_file_type: 'တရားဝင်ပုံပြင်အသံဖိုင်တင်ပါ!',
      lbl_select_file: 'ပုံပြင်အသံဖိုင် ရွေးပါ',
      msg_valid_file: 'တရားဝင် ပုံပြင်အသံဖိုင် ရွေးပါ!',
      msg_success: 'ပုံပြင်အသံဖိုင် အောင်မြင်စွာ တင်ပြီးပါပြီ',
      msg_failed: 'မီဒီယာ ဒေတာ ချိန်ညှိမှု မအောင်မြင်ပါ!',
      msg_error: 'ဖိုင်တင်ခြင်းတွင် အမှားဖြစ်ပွားသည်!'
    },
    audio_modal: {
      title_upload: 'တင်ပါ',
      title_update: 'အပ်ဒိတ်လုပ်ပါ',
      title_audio: 'အသံဖိုင်',
      btn_upload: 'တင်ပါ',
      btn_update: 'အပ်ဒိတ်လုပ်ပါ',
      btn_close: 'ပိတ်ပါ',
      btn_cancel: 'မလုပ်တော့ပါ',
      lbl_cover: 'အသံအဖုံး',
      rule_cover: 'အသံအဖုံး တင်ပါ!',
      lbl_title: 'အသံခေါင်းစဉ်',
      rule_title: 'အသံခေါင်းစဉ်ရေးပါ!',
      lbl_description: 'အသံဖော်ပြချက်',
      rule_description: 'အသံဖော်ပြချက်ရေးပါ!',
      lbl_file: 'အသံဖိုင် တင်ပါ',
      rule_file: 'အသံဖိုင် တင်ပါ!',
      rule_file_type: 'တရားဝင်အသံဖိုင် တင်ပါ!',
      lbl_select_file: 'အသံဖိုင် ရွေးပါ',
      msg_valid_file: 'တရားဝင် အသံဖိုင် ရွေးပါ!',
      msg_success: 'အသံဖိုင် အောင်မြင်စွာ တင်ပြီးပါပြီ',
      msg_failed: 'မီဒီယာ ဒေတာ ချိန်ညှိမှု မအောင်မြင်ပါ!',
      msg_error: 'ဖိုင်တင်ခြင်းတွင် အမှားဖြစ်ပွားသည်!'
    },
    info_episode: 'အပိုင်းဖုံးပုံ။',
    btn_delete_episode: 'ဤ Podcast အပိုင်းကို ဖျက်ပါ။',
    btn_edit_marketplace: 'စျေးကွက်အသေးစိတ် ပြင်ဆင်ပါ။',
    btn_save_marketplace: 'လက်ရှိ ပြင်ဆင်မှုများ သိမ်းဆည်းပါ။',
    btn_ai_podcast: 'AI ဖြင့် Podcast အပိုင်း ဖန်တီးပါ။',
    btn_upload_podcast: 'ကိုယ်ပိုင် Podcast အသံ အပိုင်းတင်ပါ။',
    attach_file: 'ဖိုင်တင်ပြီး မိမိရဲ့ အကြောင်းအရာများကို ပရိသတ်နှင့် မျှဝေပါ',
    fileDownload: 'ဤဖိုင်ကို ဒေါင်းလုပ်လုပ်ပါ။',
    singleEpishode: 'အပိုင်း',
    podcast_music: 'Podcast၊ ဂီတ & ပုံပြင်များ',
    publishHeader: 'Podcast၊ ဂီတ & ပုံပြင်များ ထုတ်ဝေပါ',
    editHeader: 'Podcast၊ ဂီတ & ပုံပြင်များ ပြင်ဆင်ပါ',
    createHeader: 'Podcast၊ ဂီတ & ပုံပြင်များ ဖန်တီးပါ',
    marketplaceHeader: 'Podcast၊ ဂီတ & ပုံပြင်များ စျေးကွက် အသေးစိတ်',
    message_marketplace: 'စျေးကွက် ဖောင် ပြည့်စုံစွာ ဖြည့်ပါ!',
    create_podcast_live: 'တိုက်ရိုက် Podcast နှင့် ဂီတ',
    create_podcast_custom: 'စိတ်ကြိုက် Podcast နှင့် ဂီတ',
    create_podcast_stories: 'ပုံပြင်များ',
    ai_Assisted_podcast_reation: 'AI ကူညီမှု Podcast နှင့် ဂီတ',
    publishTitle:
      'Podcast၊ ဂီတ & ပုံပြင်များ ထုတ်ဝေပြီး ကမ္ဘာတစ်ဝှမ်း မျှဝေပါ။',
    customButton: 'စိတ်ကြိုက်ဖန်တီးပါ',
    customTitle: 'Podcast တွင် ပြင်ဆင်ချက်များ သိမ်းဆည်းပါ။',
    updateButton: 'အပ်ဒိတ်လုပ်ပါ',
    createButton: 'ဖန်တီးပါ',
    createNewButton: 'အသစ် ဖန်တီးပါ',
    updateTitle: 'လက်ရှိ Podcast၊ ဂီတ & ပုံပြင် အသေးစိတ် ပြင်ဆင်ပါ။',
    createTitle: 'Podcast၊ ဂီတ & ပုံပြင် အသစ် ဖန်တီးပါ။',
    createNewTitle:
      'လက်ရှိ Podcast၊ ဂီတ & ပုံပြင် အသစ် အချက်အလက်များ ဖြင့် အသစ်တစ်ခု ဖန်တီးမည်။',
    podcastTitle: 'အပိုင်း စာရင်း',
    podcastStoryTitle: 'ပုံပြင် အပိုင်း စာရင်း',
    podcastToolTipTitle: 'Podcast အပိုင်း စာရင်း',
    uploadAudio: 'တင်ပါ',
    aiAudio: 'AI အသံ',
    emptyPodcast: 'အခုထိ Podcast၊ ဂီတ & ပုံပြင် မရှိသေးပါ။',
    emptyStoriesPodcast: 'အခုထိ ပုံပြင် မထည့်ထားသေးပါ။',
    emptyCreatePodcast: 'အသံထည့်ရန် Podcast ဖန်တီးပါ။',
    playPodcast: 'ရွေးချယ်ထားသော Podcast၊ ဂီတ & ပုံပြင် အသံဖွင့်ပါ။',
    pausePodcast: 'ရွေးချယ်ထားသော Podcast၊ ဂီတ & ပုံပြင် ရပ်ပါ။',
    selectPodcast: 'ဒီ Podcast၊ ဂီတ & ပုံပြင် ရွေးချယ်ပါ။',
    downloadPodcast: 'ဒီအသံ ဒေါင်းလုပ်လုပ်ပါ။',
    uploadAudioFile: 'အသစ်တင်ပြီး လက်ရှိ အသံ ပြောင်းပါ။',
    deleteConfirm: 'ဒီအသံ ဖျက်မှာ သေချာပါသလား?',
    roomName: 'Podcast အမည်',
    addGuestTitle: 'အတက်အကျ ဧည့်သည် ထည့်ပါ',
    showTime: 'ပြသမည့်အချိန်',
    startTime: 'စတင်ချိန်',
    endTime: 'ပြီးဆုံးချိန်',
    erorMsgImg: 'တရားဝင် ပုံရွေးပါ။',
    failedMsgImg: 'ပုံတင်ရန် မအောင်မြင်ပါ၊ ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ!',
    failedMsgUpload: 'ဖုံးပုံ တင်ရန် မအောင်မြင်ပါ!',
    btnCoverUpload: 'ဖုံးပုံ တင်ပါ',
    is_private: 'ပုဂ္ဂလိက',
    to_attach: 'ဖိုင်ကိုချိတ်ဆက်ပါ',
    file_attached: 'ဖိုင်(များ) ချိတ်ဆက်ပြီး',
    main_event: 'အဓိက အခမ်းအနား',
    event: 'အခမ်းအနားများ',
    upload_pdf: 'PDF တင်ပါ',
    portrait: 'ပေါ်ထရိတ်',
    landscape: 'လန်ဒ်စကေးပ',
    import_from_library: 'မီဒီယာစာကြည့်တိုက်မှ စာသားတင်သွင်းပါ',
    question_answer_ai: 'မေးခွန်း/အဖြေ AI',
    take_maze: 'MetaMaze ယူပါ',
    training: 'လေ့ကျင့်မှု',
    select_transcribe_locale: 'စာသားပြန်ထုတ်ရန် ဘာသာစကား ရွေးချယ်ပါ',
    transcribe_limit: 'ကျေးဇူးပြု၍ စာသားပြန်ထုတ် မိနစ်ရိုက်ထည့်ပါ',
    not_complete: 'စျေးကွက်သတင်းအချက်အလက် မပြီးစီးသေးပါ',
    complete: 'စျေးကွက်သတင်းအချက်အလက် ပြည့်စုံပါသည်',
    not_admin: 'စျေးကွက်တွင် ထုတ်ဝေရန် အုပ်ချုပ်သူ အခွင့်အရေး လိုအပ်သည်',
    no_course: 'စျေးကွက်ကို ဖွင့်ရန် ခေါင်းစဉ်နှင့် ပုံရွေးပါ',
    scorm_not_complete: 'SCORM ဖိုင်တင်ရန် ခေါင်းစဉ်နှင့် ပုံရွေးပါ',
    not_found_maze: 'MetaMaze မတွေ့ပါ',
    email_require: 'အီးမေးလ်လိုအပ်သည်',
    poll_required: 'မဲပေးရန် အချက်အလက်လိုအပ်သည်',
    alert: 'သတိပေးချက်!',
    warning: 'ဂရုစိုက်ပါ!',
    ok: 'အိုကေ',
    cancel: 'ပယ်ဖျက်ပါ',
    done: 'ပြီးပြီ',
    insert: 'ထည့်ပါ',
    private: 'ပုဂ္ဂလိက',
    public: 'အများပြည်သူ',
    no_connection: 'အင်တာနက် ချိတ်ဆက်မှု ပျက်ကွက်နေပါသည်',
    switch: 'ပြောင်းပါ',
    share_screen: 'မျက်နှာပြင်မျှဝေပါ',
    stop_share_screen: 'မျက်နှာပြင်မျှဝေခြင်း ရပ်နားပါ',
    share_screen_with_camera: 'ကင်မရာနှင့်မျက်နှာပြင်မျှဝေပါ',
    stop_share_screen_with_camera: 'ကင်မရာနှင့်မျက်နှာပြင်မျှဝေခြင်း ရပ်နားပါ',
    camera_on: 'ကင်မရာ ဖွင့်ပါ',
    camera_off: 'ကင်မရာ ပိတ်ပါ',
    mic_on: 'အသံဖွင့်ပါ',
    mic_off: 'အသံပိတ်ပါ',
    fullscreen: 'ပြည့်ပြည့်စုံစုံ မျက်နှာပြင်',
    live_now: 'လက်ရှိ ထုတ်လွှင့်နေသည်',
    schedule_on: 'အစီအစဉ်ထားသည်',
    organisations: 'အဖွဲ့အစည်းများ',
    org_groups: 'အဖွဲ့အစည်းအုပ်စုများ',
    specific_user: 'သတ်မှတ်ထားသော အသုံးပြုသူ',
    gif: 'GIF',
    unavailable: 'မရနိုင်ပါ',
    yes: 'ဟုတ်ကဲ့',
    no: 'မဟုတ်ပါ',
    event_duration_message: 'အများဆုံး ၃၀၀ မိနစ် (၅ နာရီ)',
    send_email: 'အီးမေးလ် အသိပေးစာ ပို့ပါ',
    admin_only: 'အုပ်ချုပ်သူများသာ',
    join: 'ပူးပေါင်းပါ',
    leave: 'ထွက်ပါ',
    share: 'မျှဝေပါ',
    share_text:
      'ဤဖိုင်ကို မျှဝေရန် မိမိဆက်သွယ်လိုသော အီးမေးလ်လိပ်စာကို ရိုက်ထည့်ပါ။',
    share_text_title: 'PDF မျှဝေပါ',
    share_text_title_txt: 'စာသား မျှဝေပါ',
    select_users: 'အသုံးပြုသူ ရွေးချယ်ပါ',
    delete: 'ဖျက်ပါ',
    attachment_event: 'အခမ်းအနားအတွက် တွဲဖက်စာရွက်များ:',
    transcribe_limit: 'စာသားပြန်ထုတ်မိနစ်',
    monthly_transcribe: 'လစဉ် စာသားပြန်ထုတ် အကန့်အသတ်:',
    enable_ai: 'AI ကို ဖွင့်ပါ:',
    enable_maze: 'MetaMaze ကို ဖွင့်ပါ:',
    media_service: 'မီဒီယာဝန်ဆောင်မှု',
    allow_others: 'အခြားသူများကို တည်းဖြတ်ခွင့်ပြုပါ',
    join_breakout_room: 'အုပ်စုခွဲခန်းထဲ ဝင်ပါ',
    bio: 'ကိုယ်ရေးအကျဥ်း',
    linkedin: 'LinkedIn',
    select_org_report: 'အစီရင်ခံစာ ပြုလုပ်ရန် အဖွဲ့အစည်း ရွေးချယ်ပါ',
    org_image_not_found: 'ပုံ မတွေ့ပါ',
    insert_text: 'စာသား ထည့်ပါ',
    insert_question_answer: 'မေးခွန်း/အဖြေ AI',
    modal_title2: 'စာသား ပြခန်း',
    my_text_library: 'ကျွန်ုပ်၏ စာသား စာကြည့်တိုက်',
    ai: 'AI',
    public_text_library: 'အများပြည်သူ စာသား စာကြည့်တိုက်',
    organization_text_library: 'အဖွဲ့အစည်း စာသား စာကြည့်တိုက်',
    no_transcribed_text: 'စာသား ပြန်ထုတ်ခြင်း မတွေ့ပါ',
    public_text_not_found: 'အများပြည်သူ စာသား မတွေ့ပါ',
    org_text_not_found: 'အဖွဲ့အစည်း စာသား မတွေ့ပါ',
    org_video_not_found: 'ဗီဒီယို မတွေ့ပါ',
    canva: 'Canva မှ ပြုလုပ်ပါ',
    canva_open: 'Canva အယ်ဒီတာ ဖွင့်ရန် ဒီမှာနှိပ်ပါ',
    pdf: 'PDF',
    txt: 'စာသား',
    human: 'ပရီးမီယံ',
    shared_file: 'ဖိုင်ကို အောင်မြင်စွာ မျှဝေပြီးပါပြီ',
    error_shared_file: 'ဖိုင် မျှဝေရာတွင် ပြဿနာရှိနေသည်။ ပြန်လည်ကြိုးစားပါ',
    publish: 'ထုတ်ပြန်ပါ',
    maze_scenes: 'MetaMaze ဇာတ်ကောင်များ',
    pexel_images: 'Pexel ပုံများ',
    group: 'အုပ်စု',
    group_name: 'အုပ်စုအမည်',
    select_group: 'အုပ်စု ရွေးချယ်ပါ',
    search_maze: 'MetaMaze ရှာဖွေရန်',
    hosts: 'ဖိတ်ကြားသူများ',
    avg_score: 'ပျမ်းမျှရမှတ် (%)',
    maze_report: 'MetaMaze အစီရင်ခံစာ',
    maze_view: 'MetaMaze ကြည့်ရန်',
    title_maze: 'MetaMaze',
    author: 'ရေးသားသူ',
    match: 'လမ်းကြောင်းကိုက်ညီမှု',
    preview_mazeTitle: 'ခေါင်းစဉ်: ',
    other: 'အခြား',
    total: 'စုစုပေါင်း',
    report_course: 'သင်တန်း',
    report_courses: 'သင်တန်းများ',
    report_event: 'ဖြစ်ရပ်',
    report_events: 'ဖြစ်ရပ်များ',
    report_maze: 'မေဇ်',
    report_personalize_learning: 'တစ်ဦးချင်းအလိုက်သင်ယူမှု',
    report_live_assessment: 'တိုက်ရိုက်အကဲဖြတ်မှု',
    report_live_assessments: 'တိုက်ရိုက်အကဲဖြတ်မှုများ',
    report_skill_journey: 'ကျွမ်းကျင်မှု ခရီးစဉ်',
    skill_journey: 'ကျွမ်းကျင်မှု ခရီးစဉ်',
    skill_journeys: 'ကျွမ်းကျင်မှု ခရီးစဉ်များ',
    date: 'ရက်စွဲ: ',
    search_people: 'လူများကို ရှာဖွေရန်',
    passed: 'ဖြတ်သန်းခဲ့သည်',
    failed: 'မအောင်မြင်ပါ',
    item: 'အိုင်တမ်',
    type: 'အမျိုးအစား',
    minimum_pass_score: 'အနည်းဆုံး ဖြတ်သန်းရန် အမှတ်',
    resources_count: 'အရင်းအမြစ်အရေအတွက်',
    back: 'နောက်သို့',
    resources: 'အရင်းအမြစ်များ',
    time_spent: 'ကုန်ဆုံးသောအချိန် (မိနစ်)',
    detail: 'အသေးစိတ်',
    watched_time_mins: 'ကြည့်ရှုချိန် (မိနစ်)',
    personalize_learning: 'တစ်ဦးချင်းအလိုက် သင်ယူမှု',
    result: 'ရလဒ်',
    assessment_title: 'ခေါင်းစဉ်',
    marketPlace_graph: 'Marketplace ဇယား',
    attachments: 'ထပ်မံ ဖိုင်များ',
    new_scorm_course: 'SCORM သင်တန်းအသစ်တင်ရန်',
    upload_scorm_course: 'SCORM သင်တန်းတင်ရန်',
    new_maze: 'MetaMaze အသစ်ဖန်တီးရန်',
    new_skill_journey: 'ကျွမ်းကျင်မှု ခရီးစဉ်အသစ် ဖန်တီးရန်',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'ကျွမ်းကျင်မှု ခရီးစဉ်',
    new_discussion_room: 'Podcast အသစ်ဖန်တီးရန်',
    title: 'ယနေ့ သင် ဘာလုပ်ချင်ပါသလဲ?',
    build_course: 'ကျွန်ုပ်၏သင်တန်း တည်ဆောက်ရန်',
    live_broadcast: 'တိုက်ရိုက်ထုတ်လွှင့်မှု',
    invite_users: 'ကျွန်ုပ်၏အဖွဲ့အစည်းသို့ အသုံးပြုသူများ ဖိတ်ကြားရန်',
    build_voice_over: 'ကျွန်ုပ်၏အသံဖိုင် ဖန်တီးရန်',
    view_reports: 'အစီရင်ခံစာများ ကြည့်ရန်',
    upload_media: 'မီဒီယာ/အလုပ်များ တင်ပြီး မျှဝေရန်',
    main_menu: 'မိမိနမူနာ',
    get_started: 'စတင်လိုက်ပါ',
    search_group: 'အဖွဲ့အစည်းအဖွဲ့ရှာဖွေရန်',
    ai_course: 'AI သင်တန်း',
    search_user: 'ကုမ္ပဏီအမည် ရှာဖွေရန်',
    no_maze: 'လက်ရှိတွင် MetaMaze မရှိပါ။',
    conference_event_title: 'စာတမ်းဖိတ်ကြားပွဲများ',
    conference_event_subTitle: 'ပြီးဆုံးသည့် စာတမ်းဖိတ်ကြားပွဲများ',
    conference_event: 'လက်ရှိတွင် စာတမ်းဖိတ်ကြားပွဲ မရှိပါ။',
    no_skill: 'လက်ရှိတွင် ကျွမ်းကျင်မှု ခရီးစဉ် မရှိပါ။',
    no_podcast: 'လက်ရှိတွင် podcast မရှိပါ။',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'ပြီးခဲ့သည့် တိုက်ရိုက်အကဲဖြတ်မှုများ',
    no_live_assessment: 'လက်ရှိတွင် တိုက်ရိုက်အကဲဖြတ်မှု မရှိပါ။',
    enrolled_courses: 'သင်တန်းများ',
    my_video_channel: 'ကျွန်ုပ်၏ဗီဒီယိုချန်နယ်များ',
    enrolled_liveEvents: 'တိုက်ရိုက်ဖြစ်ရပ်များ',
    sharebot: 'Sharebot',
    selected_language: 'ရွေးချယ်ထားသော ဘာသာစကား',
    shareSphere_game: 'ShareSphere ဂိမ်း',
    maze: 'MetaMaze',
    skill: 'ကျွမ်းကျင်မှု ခရီးစဉ်',
    channel: 'ချန်နယ်',
    order: 'အမှာစာ',
    is_record: 'မှတ်တမ်းတင်မည်',
    no_maze_found: 'MetaMaze မတွေ့ပါ။',
    maze_self_limit_reached:
      'MetaMaze ကို ကိုယ်တိုင် လေ့လာခွင့် ကန့်သတ်မှုကို ကျော်လွန်လိုက်သည်။',
    metamaze_two_times:
      'ဤ MetaMaze ကို သင် ပြီးခဲ့သည့်အကြိမ် ၂ ကြိမ် ဖြေဆိုပြီးဖြစ်သည်။',
    metamaze_two_times_no_result:
      'ဤ MetaMaze ကို ၂ ကြိမ်ဖြေဆိုပြီးဖြစ်သည်။ တတိယအကြိမ်မှစ၍ ရလဒ် မမှတ်တမ်းတင်တော့ပါ။',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'ဖြတ်သန်းရန်အနည်းဆုံးအမှတ်',
    organization: 'အဖွဲ့အစည်းတစ်ခုရွေးပါ',
    pass_score_mark: '၁ မှ ၁၀၀ အတွင်းမှတ်အရေအတွက်ထည့်ပါ',
    maze_cloning_success:
      'MetaMaze "<0/>" ကို အောင်မြင်စွာ မိတ္တူပြုလုပ်ပြီးပါပြီ!',
    create_certificate: 'အောင်လက်မှတ် ဖန်တီးရန်',
    create_badge: 'ဘတ်ခ်ဖန်တီးရန်',
    certificate_added: 'အောင်လက်မှတ် ထည့်ပြီးပါပြီ။',
    badge_added: 'ဘတ်ခ် ထည့်ပြီးပါပြီ။',
    certificate_warning:
      'အောင်လက်မှတ်/ဘတ်ခ် ကို ထုတ်ဝေပြီးနောက် ပြင်ဆင်လို့မရတော့ပါ!',
    created_course_plan:
      'သင်ဖန်တီးထားသော သင်တန်းကို ပြင်ဆင်ပြီး တိုက်ရိုက်ဖြစ်ရပ်များ စီစဉ်ပါ',
    market_place_space: 'Marketplace',
    select_course_language: 'ဘာသာစကားရွေးပါ (ရွေးချယ်စရာ)',
    select_language: 'ဘာသာစကားရွေးပါ',
    file_upload: 'ဖိုင်တင်ပါ',
    text: 'စာသားကို ဤနေရာတွင် ရိုက်ထည့်ပါ...',
    attempts_count: 'အသုံးပြုသူတစ်ဦး တစ်ကြိမ်မှ မကြိမ် မလုပ်နိုင်ပါ',
    no_of_people_placeholder: 'လူအရေအတွက်',
    back_to_maze: 'MetaMaze အခြေအနေသို့ ပြန်သွားရန်',
    edit_maze: 'Maze ကို တည်းဖြတ်ရန်',
    wait: 'စောင့်ပါ...',
    retry: 'ပြန်လည်ကြိုးစားပါ',
    publish_scorm_course: 'SCORM သင်တန်းကို ထုတ်ဝေပါ',
    publish_maze: 'MetaMaze ကို ထုတ်ဝေပါ',
    import: 'အကြောင်းအရာများ တင်သွင်းပါ',
    answer_correct: 'မှန်ကန်သောအဖြေကိုရွေးချယ်ပါ',
    author_name: `ကျေးဇူးပြု၍စာရေးသူ၏အမည်ထည့်ပါ`,
    select_category: 'ကျေးဇူးပြု၍အမျိုးအစားရွေးချယ်ပါ',
    course_outline: 'သင်တန်းအစီအစဉ်ကိုထည့်ပါ',
    course_obj: 'သင်တန်းရည်ရွယ်ချက်များကိုထည့်ပါ',
    course_description: 'သင်တန်းဖော်ပြချက်ကိုထည့်ပါ',
    maze_outline: 'မေးဇ်အစီအစဉ်ကိုထည့်ပါ',
    maze_obj: 'မေးဇ်ရည်ရွယ်ချက်များကိုထည့်ပါ',
    maze_description: 'မေးဇ်ဖော်ပြချက်ကိုထည့်ပါ',
    lessons: 'သင်ခန်းစာအရေအတွက်ကိုထည့်ပါ',
    user_email_require: `အသုံးပြုသူအီးမေးလ်လိုအပ်သည်`,
    team_size: `အသင်းအရေအတွက်လိုအပ်သည်`,
    enter_price: 'စျေးနှုန်းထည့်ပါ (၅ အထက်ဖြစ်ရမည်)',
    input_title_maze: 'မေးဇ်ခေါင်းစဉ်ထည့်ပါ',
    trainer_bio: 'လေ့ကျင့်သူ၏ကိုယ်ရေးအကျဥ်းကိုထည့်ပါ',
    trainer_linkedin: 'လေ့ကျင့်သူ၏ LinkedIn ကိုထည့်ပါ',
    error_video: 'ဗီဒီယိုအရေအတွက်ထည့်ပါ',
    input_video_link: 'ဗီဒီယိုလင့်ခ်ထည့်ပါ',
    number_of_video: 'ဗီဒီယိုအရေအတွက်',
    number_of_lessions: 'သင်ခန်းစာအရေအတွက်',
    no_of_people_in_conference: 'အစည်းအဝေးတွင်လူများအရေအတွက် ဘယ်လောက်ရှိသလဲ?',
    transcribe_settings: 'စာသားသွင်းတမ်းဆက်တင်များ',
    transcribe: 'စာသားသွင်းတမ်းဆက်',
    cloning_maze: 'MetaMaze ကိုကလုန်းလုပ်နေသည်...',
    id_number: 'အိုင်ဒီနံပါတ်',
    timezone: 'အချိန်ဇုန်',
    edit_maze: 'ပြင်ဆင်ရန်',
    delete_maze: 'ဖျက်ရန်',
    view_maze: 'ကြည့်ရန်',
    create_metamaze: 'MetaMaze အသစ်ဖန်တီးပါ',
    metamaze_scenario: 'MetaMaze အခြေအနေ',
    publish_metamaze: 'ထုတ်ပြန်မှု ဆက်တင်',
    search_result: 'ရှာဖွေမှုရလဒ်များ:',
    search_for: 'ရှာဖွေရန်',
    search_no_result: '- ရလဒ်မတွေ့ရှိပါ!',
    channel_no_available: 'စင်ကြယ်တန်းမရှိပါ!',
    this_card: 'ဤသည်ကကဒ်တစ်ခုဖြစ်သည်',
    course_no_available: 'သင်တန်းများမရှိပါ!',
    exit_fullscreen: 'ပြည့်စုံမျက်နှာပြင်ထဲမှထွက်ရန်',
    bg_image: 'နောက်ခံပုံ',
    introduction: 'နိဒါန်း',
    summary: 'အကျဉ်းချုပ်',
    generate_introduction: 'နိဒါန်းဖန်တီးပါ',
    generate_summary: 'အကျဉ်းချုပ်ဖန်တီးပါ',
    bullet_points: 'အချက်အလက်များ',
    title_simulation: 'အတုခေါင်းစဉ်ထည့်ပါ',
    view_generated_images: 'ဖန်တီးပြီးပုံများကြည့်ရန်',
    image_transparency: 'ပုံဖျတ်သားမှု',
    template_bg_color: 'ပုံစံနောက်ခံအရောင်',
    select_template_layout: 'ပုံစံ Layout ရွေးချယ်ပါ',
    reload_template: '(ပုံစံများကိုပြန်တင်ပါ)',
    are_you_sure_want_close: 'ပိတ်ရန်သေချာပါသလား?',
    all_your_changes_will_be_lost: 'သင်၏ပြင်ဆင်မှုအားလုံး ပျောက်ဆုံးသွားမည်။',
    please_checked_before_generated_video:
      'ဗီဒီယိုဖန်တီးမီ အခြေအနေအားလုံးကို အတည်ပြုပါ',
    voice_must_be_selected: 'အသံတစ်ခု ရွေးချယ်ထားရမည်',
    avatar_must_be_selected: 'ပုံတစ်ပုံ ရွေးချယ်ထားရမည်',
    maximum_five_slides_try_again:
      'ဖိုင်မှပုံများထုတ်ယူရာတွင်အမှားဖြစ်ပါသည်။ ဖိုင်တွင် Slide ၅ ခုအထိသာရှိရမည်၊ Slide တစ်ခုစီတွင်မှတ်စုများပါဝင်ရမည်။ ထပ်မံကြိုးစားပါ။',
    back_to_upload: 'တင်သွင်းရန်ပြန်သွားပါ',
    uploading_file_to_server: 'ဖိုင်ကို Server သို့တင်နေသည်',
    extracting_images_from_your_file: 'ဖိုင်မှပုံများထုတ်ယူနေသည်',
    upload_your_ppt_or_drag:
      'သင်၏ Presentation (.PPTX) ဖိုင်ကိုတင်ပါ သို့မဟုတ်ဒီမှာဆွဲထားပါ',
    maximum_five_slides_error:
      'သင်၏ PowerPoint ဖိုင်တွင် Slide ၅ ခုအထိသာရှိရမည်၊ Slide တစ်ခုစီတွင်မှတ်စုများပါရှိရမည်။ မဟုတ်ပါက အမှားဖြစ်မည်။',
    number_of_questions_generated: 'ဖန်တီးမည့်မေးခွန်းအရေအတွက်',
    quiz_page_this_cannot_be_done:
      'ဤစာမျက်နှာတွင် Quiz ထည့်ရန် သေချာပါသလား? ပြန်ပြင်၍မရပါ။',
    confirm_selection: 'ရွေးချယ်မှု အတည်ပြုပါ',
    select_quiz_page: 'Quiz စာမျက်နှာရွေးချယ်ပါ',
    lesson_do_you_want_add_this_quiz:
      'သင်ခန်းစာ၏ မည်သည့်အစိတ်အပိုင်းတွင် ဤ Quiz ထည့်လိုပါသလဲ?',
    beginning_of_lesson: 'သင်ခန်းစာအစမှာ',
    end_of_lesson: 'သင်ခန်းစာအဆုံးမှာ',
    currently_active_page: 'လက်ရှိ တက်ကြွသောစာမျက်နှာ',
    finish: 'ပြီးဆုံး',
    upload_selection_file: 'အပိုင်းဖိုင်တင်ပါ',
    general_quiz: 'အထွေထွေ Quiz',
    manage_sequence: 'စဉ်လိုက်စီမံပါ',
    save_sequence: 'စဉ်လိုက်သိမ်းဆည်းပါ',
    new: 'အသစ်',
    in_progress: 'ဆက်လက်လုပ်ဆောင်နေသည်',
    recommended_course: 'အကြံပြုသင်တန်း',
    up_coming: 'မကြာမီဖြစ်မည်',
    past_live: 'အတိတ် Live',
    input_your_channel_name: 'ကျေးဇူးပြု၍ သင့် Channel အမည်ထည့်ပါ',
    organization_place: 'အဖွဲ့အစည်း စျေးကွက်',
    marketplace_report: 'စျေးကွက်အစီရင်ခံစာ',
    story_writing: 'ပုံပြင်ရေးသားခြင်း',
    Ai_quiz: 'AI Quiz',
    generate_quiz: 'Quiz ဖန်တီးပါ',
    create_story: 'ပုံပြင် ဖန်တီးပါ',
    change_layout_page: 'ဤစာမျက်နှာ Layout ပြောင်းရန်ရှိသည်',
    change_layout_message:
      'စာသား၊ ပုံများ၊ နောက်ခံနှင့် အမှတ်တံဆိပ်သာ ထိန်းသိမ်းမည်ဖြစ်ပြီး အခြားအချက်အလက်များအားလုံး ဖယ်ရှားမည်ဖြစ်သည်။',
    reviews: 'ပြန်လည်သုံးသပ်ချက်များ',
    tab_attachments: 'ဆက်စပ်ဖိုင်များ',
    zoom_in: 'အနီးကပ်မြှင့်တင်',
    zoom_out: 'အဝေးမြှင့်တင်',
    zoom_reset: 'Zoom ပြန်လည်သတ်မှတ်',
    no_attachment: 'ဆက်စပ်ဖိုင် မရှိပါ',
    select_upload_simulation: 'ကျေးဇူးပြု၍ အတုကိုရွေးချယ်/တင်ပါ',
    quiz_updated_successfully: 'Quiz အောင်မြင်စွာပြင်ဆင်ပြီးပါပြီ!',
    quizes: 'Quiz များ',
    trivia: 'Trivia',
    closing: 'ပိတ်နေသည်...',
    products: 'ကုန်ပစ္စည်းများ',
    ask_questions: 'ဤနေရာတွင်မေးခွန်းမေးပါ...',
    course_information: 'သင်တန်းအချက်အလက်',
    course_assistance: 'သင်တန်းဖန်တီးသူ အကူအညီ',
    go_back: 'ပြန်သွားပါ',
    ai_generate_content_progress: 'အကြောင်းအရာ ဖန်တီးခြင်း တိုးတက်မှု',
    view_generate_content: 'ဖန်တီးပြီး အကြောင်းအရာ ကြည့်ရှုရန်',
    generate_error: 'ဖန်တီးမှု အမှား!',
    confirm_creating_course:
      'ဤအကြောင်းအရာဖြင့် သင်တန်း ဖန်တီးရန် အတည်ပြုပါသလား?',
    generate_content_automatically:
      'ဖန်တီးပြီး အကြောင်းအရာအားလုံးကို သင်တန်းတွင် သင်ခန်းစာနှင့် စာမျက်နှာအဖြစ် အလိုအလျောက် ထည့်သွင်းမည်ဖြစ်သည်။',
    quiz_created_successfully: 'Quiz အောင်မြင်စွာ ဖန်တီးပြီးပါပြီ!',
    create_quiz: 'Quiz ဖန်တီးပါ',
    quiz_setting: 'Quiz ဆက်တင်',
    please_fill_quiz_setting: '* Quiz ဆက်တင်မှ အချက်အလက်များအားလုံး ဖြည့်ပါ',
    question_list: 'မေးခွန်းစာရင်း',
    add_quiz_to_page: 'Quiz ကို စာမျက်နှာတွင် ထည့်ပါ',
    form_create_question: 'မေးခွန်း ဖန်တီးဖောင်',
    user_information_updated: 'အသုံးပြုသူအချက်အလက် အပ်ဒိတ်ပြီးပါပြီ!',
    your_stripe_activete_to_continue:
      'သင့် Stripe အကောင့် မအက်တစ်ဖြစ်ပါ။ ဆက်လက်ရန် ချိတ်ဆက် သို့မဟုတ် အက်တစ်လုပ်ပါ။',
    connect_tripe: 'Stripe ချိတ်ဆက်ပါ',
    certificate_sent_sucessfully:
      'လက်မှတ်ကို သင့်အီးမေးလ်သို့ အောင်မြင်စွာပို့ပြီးပါပြီ။',
    error_try_again: 'အမှားရှိပါသည်။ ထပ်မံကြိုးစားပါ!',
    error_delete_channel: 'ချန်နယ် ဖျက်ခြင်းအမှားရှိသည်။',
    error_update_sub: 'စာရင်းသွင်းမှု အပ်ဒိတ်အမှားရှိသည်။',
    end_time_cannot_start: 'ပြီးဆုံးချိန်သည် စတင်ချိန်ထက် မကျော်လွန်နိုင်ပါ။',
    start_date_time_interval: 'စတင်သည့်နေ့နှင့်အချိန် ကာလလိုအပ်သည်!',
    podcast_updated_successful: 'Podcast ကိုအောင်မြင်စွာ အပ်ဒိတ်လုပ်ပြီးပါပြီ။',
    podcast_created_successful: 'Podcast ကိုအောင်မြင်စွာ ဖန်တီးပြီးပါပြီ။',
    podcast_published_successful: 'Podcast ကို အများသို့ထုတ်ပြန်ပြီးပါပြီ',
    podcast_cover_updated: 'Podcast အဖုံး အပ်ဒိတ်လုပ်ပြီးပါပြီ',
    new_podcast_details:
      'အသစ် Podcast ကို လက်ရှိ Podcast နှင့် အသေးစိတ် အသစ်များဖြင့် ဖန်တီးမည်။',
    current_update_podcast:
      'လက်ရှိ Podcast ကို အပ်ဒိတ်လုပ်ပါ၊ ဂီတနှင့် ပုံပြင်အသေးစိတ်များပါ။',
    create_new_podcast: 'Podcast အသစ်ဖန်တီးပါ',
    publish_podcast_public_view: 'Podcast ကို အများသို့ထုတ်ပြန်ပါ',
    only_allowed_twenty_five_email: 'အီးမေးလ် ၂၅ ခုသာ ခွင့်ပြုသည်',
    only_allowed_five_email: 'အီးမေးလ် ၅ ခုသာ ခွင့်ပြုသည်',
    cover_is_required: 'အဖုံး လိုအပ်သည်',
    topic_is_required: 'အကြောင်းအရာ လိုအပ်သည်',
    delete_schedule: 'ဇယားဖျက်ရန်',
    make_as_coaching: 'လေ့ကျင့်မှုအနေဖြင့် မှတ်သားရန်',
    manage_category: 'အမျိုးအစားစီမံခန့်ခွဲပါ',
    threshold: 'အဆင့်နိမ့်ဆုံး',
    threshold_popup:
      'အဆင့်နိမ့်ဆုံးတန်ဖိုး (ရာခိုင်နှုန်း) ဖြစ်ပြီး အဆိုပါအမျိုးအစားအတွက် အကြံပြုချက် ဖော်ပြမှု စတင်မည့် တန်ဖိုးဖြစ်သည်',
    list_of_catagory: 'အမျိုးအစားစာရင်း',
    category_name: 'အမျိုးအစားအမည်',
    category_threshold: 'အမျိုးအစားအဆင့်နိမ့်ဆုံး',
    play_game: 'ဂိမ်းကစားမယ်',
    switching_organization: 'အဖွဲ့အစည်းပြောင်းလဲနေသည်...',
    coaching_session: 'နည်းပြအတန်း',
    required_channel_id: 'ချန်နယ်အိုင်ဒီလိုအပ်သည်!',
    error_occured_try_again: 'အမှားဖြစ်ပွားခဲ့သည်။ ထပ်မံကြိုးစားပါ!',
    please_complete_marketplace_form: 'စျေးကွက်ဖောင်ကို ပြည့်စုံစွာ ဖြည့်ပါ!',
    upload_file_corrupt: 'တင်သွင်းထားသောဖိုင်သည် ပျက်စီးနေသည်။',
    course_not_published: 'သင်ခန်းစာကို မထုတ်ဝေသေးပါ!',
    error_request: 'တောင်းဆိုမှုတွင် အမှားရှိသည်။ ထပ်မံကြိုးစားပါ!',
    skill_request: 'ပျက်ကွက်နေသောကွက်လပ်များကို ဖြည့်စွက်ပါ!',
    error_occured: 'အမှားဖြစ်ပွားခဲ့သည်။ ထပ်မံကြိုးစားပါ!',
    show_time: 'ပြသချိန်',
    start_time: 'စတင်ချိန်',
    end_time: 'ပြီးဆုံးချိန်',
    room_name: 'ပေါ့ဒ်ကတ်အမည်',
    add_guest_speaker: 'အိမ်ရှင်ဧည့်သည် ထည့်ပါ',
    cover_picture: 'ဖုံးအုပ်ပုံ',
    guest_speaker: 'ဧည့်သည်အတိုင်ပင်ခံ',
    see_more: 'ပိုပြီးကြည့်မယ်',
    see_less: 'နည်းနည်းကြည့်မယ်',
    background: 'နောက်ခံ',
    icon: 'အိုင်ကွန်း',
    icon_size: 'အိုင်ကွန်းအရွယ်အစား',
    icon_color: 'အိုင်ကွန်းအရောင်',
    only_text: 'စာသား',
    change_bg: 'နောက်ခံအရောင်ပြောင်းပါ',
    bg_color: 'နောက်ခံအရောင်',
    font_size: 'စာလုံးအရွယ်အစား',
    normal: 'ပုံမှန်',
    change_color: 'စာသားအရောင်ပြောင်းပါ',
    slant_text: 'စာသားထောင့်ကွေ့',
    text_radius: 'စာသားအကွာအဝေး',
    vertical_align: 'အလယ်တန်းတန်းဖြင့်',
    horizontal_align: 'အလယ်တန်းတန်းဖြင့် (ထောင့်တန်း)',
    change_icon_color: 'အိုင်ကွန်းအရောင်ပြောင်းပါ',
    upload_icon: 'အိုင်ကွန်းတင်ပါ',
    upload_signature: 'လက်မှတ်တင်ပါ',
    add_another_sign: 'လက်မှတ်တစ်ခုထပ်ထည့်ပါ',
    name_badges: 'ဘတ်ဂျ်အမည်များ',
    should_less_150: 'ဇယားအနည်းဆုံး ၁၅၀ စာလုံးအောက်ဖြစ်ရမည်',
    your_badge: 'သင့်ဘတ်ဂျ်',
    do_you_want_delete_badge: 'ဤဘတ်ဂျ်ကို ဖျက်မလား သေချာပါသလား?',
    do_you_want_delete_cert: 'ဤလက်မှတ်ကို ဖျက်မလား သေချာပါသလား?',
    upload_logo: 'လိုဂိုတင်ပါ',
    name_of_cert: 'လက်မှတ်အမည်',
    upload_cert: 'လက်မှတ်အသစ်ထည့်ပါ',
    your_cert: 'သင့်လက်မှတ်',
    translate_to: 'ဘာသာပြန်ရန်',
    select_file_attach: 'ဖိုင်ကိုရွေးပါ',
    certificate: 'လက်မှတ်',
    badge: 'ဘတ်ဂျ်',
    publish_options: 'ထုတ်ပြန်မှုရွေးချယ်မှုများ',
    publish_skills_journey: 'ကျွမ်းကျင်မှုခရီးစဉ် ထုတ်ပြန်မည်',
    videos: 'ဗီဒီယိုများ',
    generate_ai_video:
      'ဗီဒီယိုဖန်တီးခြင်းလုပ်ငန်းစဉ်မှာ အချိန်ယူနိုင်ပြီး အပြီးသတ်လျှင် အီးမေးလ်ဖြင့် သတင်းပို့ပေးမည်ဖြစ်သည်။',
    trainer_information: 'နည်းပြအချက်အလက်',
    promotional_video_link: 'ကြော်ငြာဗီဒီယိုလင့်ခ်',
    please_select: 'ရွေးချယ်ပါ',
    image_name: 'ပုံအမည်:',
    image_size: 'ပုံအရွယ်အစား:',
    charecters_fifteen_less: '၁၅ စာလုံးအောက်',
    leadership: 'ခေါင်းဆောင်မှု',
    text_arc: 'စာသားဝိုင်း',
    vertical: 'လျှောတည့်',
    horizontal: 'လျှောတန်း',
    badge_history: 'ဘတ်ဂျ်မှတ်တမ်း',
    templates: 'ပုံစံများ',
    sign: 'လက်မှတ်',
    logo: 'လိုဂို',
    certificate_history: 'လက်မှတ်မှတ်တမ်း',
    please_wait: 'ကျေးဇူးပြု၍ စောင့်ပါ...',
    information: 'အချက်အလက်',
    support_five_thousand_live_event: 'ပွဲတွင် ပါဝင်သူ ၅၀၀၀ အထိ ထောက်ခံသည်',
    support_ten_live_event: 'တိုက်ရိုက်ဗီဒီယို ပါဝင်သူ ၁၀ ဦးအထိ ထောက်ခံသည်',
    we_will_back_participant: 'ကြီးမားသော ပါဝင်သူများနှင့် ပြန်လာပါမည်။',
    course_objectives: 'သင်ခန်းစာ ရည်ရွယ်ချက်များ',
    course_outlines: 'သင်ခန်းစာ အကြောင်းအရာ',
    price_dollor: 'စျေးနှုန်း (ယူအက်စ်ဒေါ်လာ)',
    not_completed: 'မပြီးစီးသေးပါ',
    enable_marketplace: 'စျေးကွက်ကို ဖွင့်ပါ',
    enable_course_ai: 'AI ဖြင့် သင်တန်းဖန်တီးမှု ဖွင့်ပါ',
    enable_report_to_admin: 'အက်မင်ထံမှ အစီရင်ခံစာပြသခြင်း ဖွင့်ပါ',
    enable_white_label: 'ဝိုင်ယက်လေးဘယ် ဖွင့်ပါ',
    enable_eleven_labs_for_maze_play: 'Maze Play အတွက် Elevenlabs ကို ဖွင့်ပါ',
    enable_eleven_labs_for_maze_play_cloned:
      'Elevenlabs Cloned အသံများ ဖွင့်ပါ',
    not_completed: 'မပြီးစီးသေးပါ',
    simulation_quiz: 'အတုစမ်းသပ်မှု မေးခွန်းများ',
    bg_color_setting: 'နောက်ခံအရောင် ဆက်တင်များ',
    color_preview: 'အရောင် ကြိုတင်ကြည့်ရှုခြင်း',
    choose_new_color: 'အရောင်အသစ် ရွေးချယ်ပါ',
    remove_color: 'အရောင် ဖယ်ရှားပါ',
    apply_color: 'အရောင် အကောင်အထည်ဖော်ပါ',
    elemeent_in_a_sceenario_page:
      'သင်သည် စိန်ခေါ်မှုစာမျက်နှာတွင် အခြားအရာများ ထည့်သွင်း၍ မရပါ။ ကျေးဇူးပြု၍ အခြားစာမျက်နှာများကို ကြိုးစားပါ သို့မဟုတ် စိန်ခေါ်မှုကို စာမျက်နှာမှ ဖယ်ရှားပါ။',
    no_data_found: 'ဒေတာ မတွေ့ရှိပါ',
    references: 'ကိုးကားချက်များ',
    open_file: 'ဖိုင် ဖွင့်ပါ',
    showing_result: 'ရလဒ်များ ပြသနေသည်:',
    fiften_day_free_trail: '၁၅ ရက် အခမဲ့ စမ်းသပ်ခြင်း',
    your_browser_does_not_support: 'သင်၏ဘရောက်ဇာသည် အသံအပိုင်းကို မထောက်ပံ့ပါ။',
    podcast_desc: 'ပေါ့တ်ကတ်ဖ် ဖော်ပြချက်',
    input_podcast_desc: 'ပေါ့တ်ကတ်ဖ် ဖော်ပြချက် ထည့်သွင်းပါ',
    podcast_obj: 'ပေါ့တ်ကတ်ဖ် ရည်မှန်းချက်များ',
    input_podcast_obj: 'ပေါ့တ်ကတ်ဖ် ရည်မှန်းချက်များ ထည့်သွင်းပါ',
    podcast_outline: 'ပေါ့တ်ကတ်ဖ် အကြောင်းအရာ အကျဉ်း',
    input_podcast_outline: 'ပေါ့တ်ကတ်ဖ် အကြောင်းအရာ အကျဉ်း ထည့်သွင်းပါ',
    add_file: 'ဖိုင် ထည့်သွင်းပါ',
    generate_podcast_audio: 'ပေါ့တ်ကတ်ဖ် အသံ ဖန်တီးပါ',
    generate_uploaded_file_input_parameter:
      'အသုံးပြုသူတင်သွင်းထားသောဖိုင်များနှင့် ပက်သက်သော အကြောင်းအရာများကို ထည့်သွင်းအချက်အလက်များဖြင့် ဖန်တီးသည်။',
    go_backe_generation_state:
      'အကြောင်းအရာ ဖန်တီးခြင်း အခြေအနေသို့ ပြန်သွားပါ။',
    create_ai_powered_podcast:
      'AI ဖြင့် စွမ်းဆောင်သော ပေါ့တ်ကတ်ဖ် အပိုင်းများ ဖန်တီးပါ။',
    generate_voice_for_all_podcast:
      'ကျေးဇူးပြု၍ ပေါ့တ်ကတ်ဖ် အပိုင်းအားလုံးအတွက် အသံ ဖန်တီးပါ',
    create_podcast_episode: 'ပေါ့တ်ကတ်ဖ် အပိုင်း ဖန်တီးပါ',
    voice_name: 'အသံအမည်',
    input_custom_name: 'စိတ်ကြိုက်အမည် ထည့်သွင်းပါ!',
    enter_custom_name: 'စိတ်ကြိုက် အသံအမည် ရိုက်ထည့်ပါ',
    upload_complete: 'တင်သွင်းပြီးပါပြီ',
    uploading_in_progress: 'တင်သွင်းနေဆဲ...',
    podcast_stream_content: 'ပေါ့တ်ကတ်ဖ် အကြောင်းအရာ စီးရီး',
    upload_podcast_cover: 'ကျေးဇူးပြု၍ ပေါ့တ်ကတ်ဖ် အဖုံး တင်ပါ!',
    enter_podcast_name: 'ပေါ့တ်ကတ်ဖ် အမည် ထည့်ပါ!',
    podcast_topic: 'ပေါ့တ်ကတ်ဖ် ခေါင်းစဉ်',
    enter_podcast_topic: 'ပေါ့တ်ကတ်ဖ် ခေါင်းစဉ် ထည့်ပါ!',
    enter_podcast_desc: 'ပေါ့တ်ကတ်ဖ် ဖော်ပြချက် ထည့်ပါ!',
    number_of_speaker: 'စကားပြောသူ အရေအတွက်',
    select_the_number_of_speaker: 'စကားပြောသူ အရေအတွက် ရွေးချယ်ပါ!',
    number_of_episode: 'အပိုင်းအရေအတွက်',
    input_number_of_episode: 'အပိုင်းအရေအတွက် ထည့်သွင်းပါ!',
    podcast_length: 'ပေါ့တ်ကတ်ဖ် ကြာမြင့်ချိန်',
    select_the_podcast_length: 'ပေါ့တ်ကတ်ဖ် ကြာမြင့်ချိန် ရွေးချယ်ပါ!',
    short_podcast: 'တို (၅-၁၀ မိနစ်)',
    medium_podcast: 'အလတ်စား (၁၅-၁၈ မိနစ်)',
    long_podcast: 'ရှည် (၁၈ မိနစ် နှင့်အထက်)',
    name_of_host: 'ဖျော်ဖြေပုဂ္ဂိုလ် အမည်',
    enter_host_name: 'ဖျော်ဖြေပုဂ္ဂိုလ် အမည် ထည့်ပါ!',
    guest_name: 'ဧည့်သည်အမည်များ',
    enter_guest_name: 'ဧည့်သည်အမည် ထည့်ပါ!',
    choose_speaker_tone: 'စကားပြောသူ အသံအသွင် ရွေးချယ်ပါ',
    enter_speaker_tone: 'ပေါ့တ်ကတ်ဖ် အသံအသွင် ရွေးချယ်ပါ!',
    informal: 'မပွင့်လင်းသော',
    formal: 'တရားဝင်',
    serious: 'ပြင်းထန်သော',
    light_humor: 'ပြင်းနည်း ဟာသ',
    casual: 'ပျင်းရိသော',
    select_content_source: 'အကြောင်းအရာ အရင်းအမြစ် ရွေးချယ်ပါ',
    from_internet: 'အင်တာနက်မှ',
    upload_pdf_internet: 'PDF သို့မဟုတ် အတွင်းရေးရာ စာရွက် တင်ပါ',
    note: 'မှတ်ချက်:',
    podcast_content_will_be_automatically_generated:
      'ပေါ့တ်ကတ်ဖ် အကြောင်းအရာကို ယုံကြည်စိတ်ချရသော အင်တာနက် အရင်းအမြစ်များဖြင့် အလိုအလျောက် ဖန်တီးမည်ဖြစ်သည်။',
    upload_or_select_file: 'ဖိုင်(များ) တင်သွင်း သို့မဟုတ် ရွေးချယ်ပါ!',
    podcast_eposode_title: 'ပေါ့တ်ကတ်ဖ် အပိုင်း ခေါင်းစဉ်',
    enter_podcast_title: 'အပိုင်း ခေါင်းစဉ် ထည့်ပါ!',
    podcast_episode_des: 'ပေါ့တ်ကတ်ဖ် အပိုင်း ဖော်ပြချက်',
    enter_podcast_episode_des: 'အပိုင်း ဖော်ပြချက် ထည့်ပါ!',
    voice: 'အသံ',
    music: 'တေးဂီတ',
    select_music: 'တေးဂီတ ရွေးချယ်ပါ',
    play_the_music: 'တေးဂီတ ဖွင့်ပါ',
    stop_the_music: 'တေးဂီတ ပိတ်ပါ',
    context: 'အကြောင်းအရာ',
    generate_audio_content_selected_voice:
      'ရွေးချယ်ထားသော အသံအတိုင်း အကြောင်းအရာ အသံ ဖန်တီးမည်ဖြစ်သည်။',
    required_field_before_submitting:
      'တင်သွင်းမည့်အရေအတွက်လိုအပ်သည့် နယ်ပယ်အားလုံးကို ဖြည့်စွက်ပါ။',
    regenerate_voice: 'အသံ ထပ်ဖန်တီးပါ',
    generate_voice: 'အသံ ဖန်တီးပါ',
    your_browser_does_not_suppot: 'သင်၏ဘရောက်ဇာသည် အသံအပိုင်းကို မထောက်ပံ့ပါ။',
    are_sure_leave_podcast: 'ပေါ့တ်ကတ်ဖ်မှ ထွက်မလား သေချာပါသလား?',
    broadcast_ongoing:
      'ထုတ်လွှင့်မှု ဆက်လက်လုပ်ဆောင်နေသည်။ ဒီစာမျက်နှာမှ ထွက်ရန် သေချာပါသလား?',
    brodcaster_unavailable: 'ထုတ်လွှင့်သူ မရရှိနိုင်ပါ။',
    setting_calender_for_booking: 'စာရင်းသွင်းခြင်းအတွက် ပြက္ခဒိန် စီစဉ်ခြင်း',
    add_calender: 'ပြက္ခဒိန် ထည့်ပါ',
    waiting_join_host: 'ဖျော်ဖြေပုဂ္ဂိုလ် ဝင်ရောက်ရန် စောင့်နေသည်...',
    no_reviews_found: 'သုံးသပ်ချက် မတွေ့ရှိပါ',
    rated_already: 'သင်သည် ဒီတိုက်ရိုက်အဖြစ် သုံးသပ်ပြီးသား ဖြစ်သည်',
    downlink_png: 'PNG အနေဖြင့် ဒေါင်းလုပ်လုပ်ရန်',
    downlink_jpg: 'JPG အနေဖြင့် ဒေါင်းလုပ်လုပ်ရန်',
    donwload_file_format: 'ဒေါင်းလုပ်လုပ်မည့် ဖိုင် ဖော်မတ်ကို ရွေးချယ်ပါ။',
    crashed_event:
      'ဒီပွဲပျက်သွားပါသည်။ ပွဲအသစ် ဖန်တီးရန် လိုအပ်ပါသည်။ အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်။',
    prompt: 'အကြောင်းအရာ:',
    generated_image: '🚀 ပုံဖန်တီးနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ။',
    download_add: 'အားလုံး ဒေါင်းလုပ်လုပ်ပါ',
    setting_generator: 'ဖန်တီးစက် ဆက်တင်',
    enter_image_prompt: 'ပုံဖန်တီးရန် အကြောင်းအရာ ရိုက်ထည့်ပါ',
    image_prompt: 'ပုံဖန်တီးရန် အကြောင်းအရာ',
    negative_prompt: 'မလိုလားအပ်သော အကြောင်းအရာ',
    negative_image_prompt: 'မလိုလားအပ်သော ပုံဖန်တီးရန် အကြောင်းအရာ',
    number_output: 'ထွက်ရှိရန် ပုံအရေအတွက်',
    enter_number_output: 'ထွက်ရှိရန် ပုံအရေအတွက် ထည့်ပါ',
    image_style: 'ပုံပုံစံ ရွေးချယ်ပါ',
    output_format: 'ထွက်ရှိရန် ဖော်မတ်',
    seeds: 'စေ့များ',
    enter_seeds: 'စေ့ အရေအတွက် ထည့်ပါ',
    performance_mode: 'စွမ်းဆောင်ရည် မုဒ်',
    quality: 'အရည်အသွေး',
    speed: 'အမြန်နှုန်း',
    balanced: 'ထိန်းညှိထားသော',
    guidance_scale: 'လမ်းညွှန်မှု အတိုင်းအတာ',
    enter_guidance: 'လမ်းညွှန်မှု အတိုင်းအတာ ထည့်ပါ',
    select_image: 'ပုံ ရွေးချယ်ပါ။',
    image_prmt: 'ပုံဖန်တီးရန် အကြောင်းအရာ',
    generate_image_list_empty: 'ဖန်တီးထားသော ပုံစာရင်း ဖွင့်မရပါ။',
    knowledge_center_tooltrip_des:
      'အင်တာနက်မှ အချက်အလက်များအပေါ် အခြေခံပြီး အတိအကျနှင့် သက်ဆိုင်သော ဖြေကြားချက်များကို ရယူနိုင်သည်။ AI မော်ဒယ်က တင်သွင်းထားသော အင်တာနက်စာသားများဖြစ်သည်။',
    contexts: 'အကြောင်းအရာများ',
    ai_processing_video_sharebot:
      'Sharebot သို့ ဗီဒီယိုကို AI ဖြင့် လုပ်ဆောင်မှုကာလ သာ ၂၄ နာရီကြာပြီး ပြီးဆုံးပါသည်။',
    remove_sharebot_video: `Sharebot ကိုယ်စားပြုသော ဗီဒီယို ကို ဖယ်ရှားလိုပါက၊ အသံပြန်လည်ဖြတ်တမ်းနှင့် ဗီဒီယိုကို ဖျက်ပစ်ပါ။`,
    remove_sharebot_video_audio:
      'အသံပြန်လည်ဖြတ်တမ်း ဖျက်သိမ်းပါက Sharebot နှင့်ဆက်နွယ်သည့် ဗီဒီယို/အသံ ကို ဖယ်ရှားနိုင်သော်လည်း ဗီဒီယိုသည် မီဒီယာစာကြည့်တိုက်/ချန်နယ်တွင် ဆက်လက်ပေါ်ပါလိမ့်မည်။',
    monthly_live_stream:
      'လစဉ် တိုက်ရိုက်ထုတ်လွှင့်မှု ကန့်သတ်မှု ပြောင်းလဲရန် ကျေးဇူးပြု၍ ဆက်သွယ်ပါ',
    monthly_transcribe_limit:
      'လစဉ် အသံဖတ်ချက် ကန့်သတ်မှု ပြောင်းလဲရန် ကျေးဇူးပြု၍ ဆက်သွယ်ပါ',
    must_be_one_to_three_hundred: '၁ မှ ၃၀၀ မိနစ်အတွင်း ဖြစ်ရမည်။',
    all_field_required: 'အားလုံး နယ်ပယ်များ လိုအပ်ပါသည်။',
    duration_minute: 'ကြာမြင့်ချိန် (အများဆုံး ၃၀၀ မိနစ်)',
    gender: 'ကျား/မ',
    select_gender: 'ကျား/မ ရွေးပါ',
    accent: 'အသံထွက်',
    select_accent: 'အသံထွက် ရွေးပါ',
    create_voice: 'အသံဖန်တီးပါ',
    enter_voice_name: 'အသံအမည်ထည့်ပါ',
    select_voice_gender: 'အသံအမျိုးအစား ရွေးပါ',
    upload_voice: 'သင့်အသံကိုတင်ပါ',
    upload_voice_mp_three: 'သင့်အသံကိုတင်ပါ (.mp3)',
    cloned_voice: 'ကူးယူထားသောအသံ',
    voice_type: 'အသံအမျိုးအစား',
    select_voice_type: 'အသံအမျိုးအစား ရွေးပါ',
    sharelook_stand: 'စံတော်ချိန်',
    sharelook_premium: 'ပရီမီယံ',
    sharelook_custum_voice: 'စိတ်ကြိုက် (အသံကူးခြင်း)',
    create_auto_flow: 'အလိုအလျောက်စီးဆင်းမှုဖန်တီးပါ',
    how_many_layers: 'အလွှာအရေအတွက်',
    verify_selection: 'ရွေးချယ်မှုအတည်ပြုပါ',
    uploaded_successful: 'တင်သွင်းမှုအောင်မြင်သည်',
    upload_failed: 'တင်သွင်းမှုမအောင်မြင်ပါ',
    upload_only_five_mb: 'အကြောင်းအရာတင်ပါ (PDF ဖိုင်၊ အများဆုံး ၅ဖိုင်)',
    docs_from_org_library: 'အဖွဲ့အစည်းစာကြည့်တိုက်မှစာရွက်စာတမ်းများ',
    failed_maze_generate: 'မေ့စ်ဖန်တီးမှုမအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။',
    generate_metamaze: 'MetaMaze ဖန်တီးနေသည်...',
    metamaze_being_generated:
      'သင့် MetaMaze ဖန်တီးနေဆဲ ဖြစ်သည်။ ပြီးသွားသည်နှင့်အီးမေးလ်ဖြင့်အသိပေးပါမည်။',
    metamaze_generate_successfully: 'MetaMaze အောင်မြင်စွာဖန်တီးပြီးပါပြီ!',
    metamaze_with_proceed:
      'ယခု သင်သည် MetaMaze ဖြင့် ဆက်လက်လုပ်ဆောင်နိုင်ပါသည်။',
    ai_metamaze_generate: 'AI မှဖန်တီးသော MetaMaze',
    what_kind_maze_create: 'သင်ဖန်တီးလိုသောမေ့စ်အမျိုးအစား',
    manual_metamaze_creation: 'လက်ဖြင့် MetaMaze ဖန်တီးခြင်း',
    manually_maze_customizing_scnario:
      'အကြောင်းအရာများနှင့်ရွေးချယ်မှုများကို စိတ်ကြိုက်ပြင်ဆင်ပြီး မေ့စ်ဖန်တီးပါ',
    maze_ai_generated: 'AI မှအလိုအလျောက်ဖန်တီးထားသောမေ့စ်',
    unmark_deadend: 'အဆုံးသတ်ဖျက်ရန်',
    mark_deadend: 'အဆုံးသတ်အဖြစ်မှတ်ရန်',
    select_multiple_image_for_scenario:
      'ဤအကြောင်းအရာအတွက် ဓာတ်ပုံများများစွာရွေးချယ်နိုင်သည်။',
    select_your_image: 'သင့်ရွေးချယ်ထားသောဓာတ်ပုံ',
    click_to_preview: 'မူကြမ်းကြည့်ရန် နှိပ်ပါ',
    are_you_sure_delete_image: 'ဓာတ်ပုံကိုဖျက်ချင်တာသေချာပြီလား?',
    select_image_from_library: 'မီဒီယာစာကြည့်တိုက်မှဓာတ်ပုံရွေးပါ',
    uploading_video: 'ဗီဒီယိုတင်နေသည်...',
    tree_node_type: 'Tree Node အမျိုးအစား',
    correct_option_scenario: 'မှန်သောရွေးချယ်မှု/အကြောင်းအရာ',
    incorrect_option: 'မှားသောရွေးချယ်မှု',
    option_scenario_without_text: 'စာသားမပါသော ရွေးချယ်မှု/အကြောင်းအရာ',
    dead_end: 'အဆုံးသတ် (အနီစက်ဖြင့်)',
    correct_path: 'မှန်သောလမ်းကြောင်း',
    incorrect_path_not_selected_correct_option_path:
      'မှားသောလမ်း / မှန်သောရွေးချယ်မှုမပြုထားသောလမ်း',
    double_click_on_tree_node:
      'Tree node တစ်ခုကိုနှစ်ချက်နှိပ်သည်ဖြင့် သက်ဆိုင်ရာအကြောင်းအရာကို ပြန်လည်ကြည့်ရှုနိုင်ပါသည်။',
    add_scenario: 'အကြောင်းအရာထည့်ပါ',
    add_option: 'ရွေးချယ်မှုထည့်ပါ',
    an_error_occured: 'အမှားအယွင်းတစ်ခုဖြစ်ပွားခဲ့သည်:',
    download_summary: 'အကျဉ်းချုပ်ဒေါင်းလုဒ်လုပ်ပါ',
    step_wise_analysis: 'အဆင့်လိုက်ခွဲခြမ်းစိတ်ဖြာချက်',
    step: 'အဆင့်',
    upload_csv_file: 'CSV ဖိုင်တင်ပါ',
    download_template_to_import: 'သွင်းယူရန်နမူနာအခြေခံပုံစံဒေါင်းလုဒ်လုပ်ပါ',
    please_input_email: 'ကျေးဇူးပြုပြီးအီးမေးလ်ထည့်ပါ',
    email_at_least_three_characters:
      'အီးမေးလ်တွင်အနည်းဆုံး စာလုံးသုံးလုံးလိုအပ်သည်။',
    email_cannot_be_empty: 'အီးမေးလ်အထဲကွက်လပ်မဖြစ်နိုင်ပါ',
    input_email_in_new_line: 'အီးမေးလ်တစ်ခုစီကို အသစ်သောလိုင်းတွင်ထည့်ပါ',
    role: 'တာဝန်',
    select_role: 'တာဝန်ရွေးပါ',
    select_group: 'အုပ်စုရွေးပါ',
    identification_number: 'အထောက်အထားနံပါတ် (ရွေးချယ်နိုင်သည်)',
    add_identification_number: 'အထောက်အထားနံပါတ်ထည့်ပါ',
    pie_chart_of_all_categories:
      'Sharelook တွင်သုံးသောအမျိုးအစားများအပေါ်အခြေခံပြီး Pie Chart',
    total_sharesphere_question_answered_by_users:
      'ယခုအဖွဲ့အစည်းမှအသုံးပြုသူများကဖြေထားသော ShareSphere မေးခွန်းအရေအတွက်နှင့်အောင်မြင်မှု၊ မအောင်မြင်မှု',
    voice_style_over_the_text:
      'သင်ရိုက်ထားသောစာသားတွင်အသံစတိုင်အမျိုးမျိုးသုံးနိုင်ပါသည်။ Lorem Ipsum သည် စာနှင့်ပတ်သက်သောအလုပ်အကိုင်တွင် ၁၅၀၀ ခုနှစ်ကတည်းကအသုံးပြုနေသည်။',
    input_your_question: 'သင့်မေးခွန်းထည့်ပါ!',
    make_me_sales_manager: 'ဥပမာ - ငါSales Manager ဖြစ်ချင်တယ်',
    enter_the_number_relevant_document: 'သက်ဆိုင်ရာစာရွက်စာတမ်းအရေအတွက်ထည့်ပါ',
    please_wait_loading_result: 'ကျေးဇူးပြုပြီးစောင့်ပါ၊ ရလဒ်များ တင်နေသည်...',
    no_result_found: 'ရလဒ်မရှိပါ၊ ကျေးဇူးပြုပြီး နောက်ထပ်ပုံစံဖြင့် မေးပါ',
    browser_doesnot_support_iframes: 'သင့် browser သည် iframes ကို မပံ့ပိုးပါ',
    total_duration: 'စုစုပေါင်းကြာချိန်',
    number_of_messages: 'မက်ဆေ့ချ်အရေအတွက်',
    search_result: 'ရှာဖွေမှုရလဒ်',
    count_result: '(၁၂၄၄ ရလဒ်)',
    your_other_interests: 'သင့်အခြားစိတ်ဝင်စားမှုများ',
    your_total_score: 'သင့်စုစုပေါင်းအမှတ်',
    add_a_question: '+မေးခွန်းတစ်ခုထည့်ပါ',
    travia_question_empty: 'Trivia မေးခွန်းများမရှိပါ။',
    video_generation_is_on_queue:
      'သင့်ဗီဒီယိုဖန်တီးမှုသည် စောင့်ဆိုင်းစာရင်းတွင်ရှိသည်!',
    checking_video_status: 'ဗီဒီယိုအခြေအနေ စစ်ဆေးနေသည်...',
    total_quizzes: 'စုစုပေါင်းကွစ်',
    number_of_votes: 'မဲအရေအတွက်',
    total_events: 'စုစုပေါင်းဖြစ်ရပ်များ',
    number_of_rates: 'အဆင့်သတ်မှတ်မှုအရေအတွက်',
    number_of_likes: 'နှစ်သက်မှုအရေအတွက်',
    all_courses: 'အားလုံးသင်တန်းများ',
    total_questions: 'စုစုပေါင်းမေးခွန်းများ',
    no_skill_journey: 'Skill Journey မရှိပါ!',
    search_no_results: '- ရလဒ်မတွေ့ပါ!',
    no_image_generated: 'ဓာတ်ပုံမဖန်တီးရသေးပါ!',
    all_topic_in_this_lesson:
      'ဤသင်ခန်းစာတွင်ပါတဲ့အကြောင်းအရာအားလုံးကိုဖျက်ပါမည်။ ပြန်မရနိုင်ပါ။',
    content_has_been_generated: 'ဤအကြောင်းအရာအတွက် မော်ကွန်းဖန်တီးပြီးပါပြီ။',
    update_course_template: 'သင်တန်းအခြေခံပုံစံပြင်ဆင်ပါ',
    add_course_template: 'သင်တန်းအခြေခံပုံစံထည့်ပါ',
    create_course_now: 'သင်တန်းတစ်ခုဖန်တီးပါ',
    preview_course: 'သင်တန်းကို ကြိုကြည့်ပါ',
    layout: 'ဖော်ပြပုံ',
    import_from_youtube: 'YouTube မှတင်သွင်းပါ',
    my_media_library: 'ကျွန်ုပ်၏ မီဒီယာစာကြည့်တိုက်',
    bg_added: 'နောက်ခံပုံထည့်ပြီးပါပြီ',
    add_bg: 'နောက်ခံပုံထည့်ပါ',
    booked_schedule: 'ကြိုတင်စာရင်းသွင်းထားသောအချိန်ဇယား',
    add_schedule: 'အချိန်ဇယားထည့်ပါ',
    are_you_delete_schedule: 'ဤအချိန်ဇယားကိုဖျက်ချင်တာသေချာလား?',
    add_task: 'တာဝန်ထည့်ပါ',
    update_calender: 'ပြက္ခဒိန် ပြင်ဆင်ပါ',
    manage_cookies: 'ကွတ်ကီးများကို စီမံပါ',
    cookie_banner_text:
      'ကျွန်ုပ်တို့သည် သင့်၏ ကြည့်ရှုမှုအတွေ့အကြုံကို တိုးတက်အောင် ပြုလုပ်ရန်၊ ဝဘ်ဆိုဒ် သယ်ယူပို့ဆောင်မှုကို ချင့်ချိန်ရန်နှင့် အကြောင်းအရာကို ပုဂ္ဂိုလ်ရေးအခြေခံစွာ ပြုလုပ်ရန်အတွက် ကွတ်ကီးများကို အသုံးပြုပါသည်။ သင့်၏ ကိုယ်ရေးအချက်အလက်ကို ကျွန်ုပ်တို့အတွက် အရေးကြီးပါသည်။',
    accept_all_cookies: 'ကွတ်ကီးအားလုံး လက်ခံမည်',
    reject_all: 'အားလုံး ငြင်းပါ',
    customize: 'စိတ်ကြိုက်ပြင်ဆင်မည်',
    cookie_preferences_title: 'ကွတ်ကီးနှင့် ကိုယ်ရေးအချက်အလက် အပြင်အဆင်များ',
    privacy_subtitle:
      'သင့်၏ ကိုယ်ရေးအချက်အလက်သည် ကျွန်ုပ်တို့အတွက် အရေးကြီးပါသည်။ သင်လိုချင်သော ကွတ်ကီးများကို ရွေးချယ်ပါ။ နောက်ပိုင်းတွင် မည်သည့်အချိန်တွင်မဆို ပြောင်းလဲနိုင်ပါသည်။',
    save_choices: 'ရွေးချယ်မှုများ သိမ်းဆည်းပါ',
    strictly_necessary: 'အရေးကြီးသော',
    strictly_necessary_desc:
      'ဤကွတ်ကီးများသည် ဝဘ်ဆိုဒ်ကို မှန်မှန်ကန်ကန် လည်ပတ်နိုင်စေရန် အရေးကြီးပါသည်။ စာမျက်နှာသွားလာမှု၊ ဖောင်တင်ခြင်းနှင့် လုံခြုံရေးနေရာများသို့ ဝင်ရောက်ခြင်းတို့အတွက် လိုအပ်ပါသည်။',
    analytics_performance: 'စစ်တမ်းနှင့် လုပ်ဆောင်ချက်',
    analytics_performance_desc:
      'ဤကွတ်ကီးများသည် သုံးစွဲသူများက ကျွန်ုပ်တို့၏ ဝဘ်ဆိုဒ်ကို မည်သို့ အသုံးပြုကြသည်ကို နားလည်နိုင်ရန် ကူညီသည်။ ၎င်းတို့သည် အမည်မဖော်ဘဲ အချက်အလက်များကို စုဆောင်းပေးပြီး လုပ်ဆောင်မှုနှင့် အသုံးပြုသူအတွေ့အကြုံကို တိုးတက်အောင် ကူညီပေးသည်။',
    advertising_marketing: 'ကြော်ငြာနှင့် စျေးကွက်ဖန်တီးမှု',
    advertising_marketing_desc:
      'ဤကွတ်ကီးများသည် သင်အတွက် ပိုမိုသက်ဆိုင်သော ကြော်ငြာများ ပြသရန် အသုံးပြုသည်။ ထပ်ခါထပ်ခါ ပြသခြင်း မဖြစ်စေရန်နှင့် ကြော်ငြာများကို မှန်မှန်ကန်ကန် ပြသနိုင်စေရန် အထောက်အပံ့ပေးသည်။',
    tracking_social: 'ခြေရာခံခြင်းနှင့် လူမှုမီဒီယာ',
    tracking_social_desc:
      'ဤကွတ်ကီးများသည် လူမှုမီဒီယာ လုပ်ဆောင်ချက်များနှင့် ပုဂ္ဂိုလ်ရေးအခြေခံ အကြောင်းအရာများ တိုးတက်အောင် ပြုလုပ်ပေးပါသည်။ ၎င်းတို့ကို ကျွန်ုပ်တို့ သို့မဟုတ် အခြားတဖက်မှ တပ်ဆင်ထားနိုင်ပါသည်။',
    functional: 'လုပ်ဆောင်နိုင်မှု',
    functional_desc:
      'ဤကွတ်ကီးများသည် ချက်အထောက်အပံ့၊ လိုင်းအကူအညီနှင့် အခြား အပြန်အလှန် လုပ်ဆောင်ချက်များကဲ့သို့သော အင်္ဂါရပ်များကို သုံးစွဲသူအတွက် ပိုမိုကောင်းမွန်အောင် ပြုလုပ်ပေးသည်။',
    your_rights: 'သင့်အခွင့်အရေးများ:',
    rights_description:
      'သင်သည် မည်သည့်အချိန်တွင်မဆို သဘောတူချက် ရုပ်သိမ်းခြင်း၊ သင့်အချက်အလက်ကို ကြည့်ခြင်း သို့မဟုတ် ဖျက်ပစ်ရန် တောင်းဆိုနိုင်ပါသည်။',
    withdraw_consent: 'သဘောတူချက်အားလုံး ရုပ်သိမ်းမည်',

    how_many_options: 'ရွေးချယ်စရာ အရေအတွက်',
    add_content: 'အကြောင်းအရာ ထည့်ပါ',
    downloads_center: 'ဒေါင်းလုဒ် စင်တာ',
    sharelook_help_center: 'Sharelook အကူအညီစင်တာ',
    channel_outline: 'ချန်နယ် အကျဉ်းချုပ်',
    channel_objectives: 'ချန်နယ်ရည်ရွယ်ချက်များ',
    no_sop_available: 'SOP စာရင်း မရှိပါ။',
    generate_world_summary: 'အဖြစ်အပျက် တည်ဆဲအခြေအနေ ဖန်တီးပါ',
    world_scenario: 'တကယ်ဖြစ်ပျက်နေသော အဖြစ်အပျက်',
    drag_icon_hint:
      'အကြံပြုချက် - အိုင်ကွန်ကို ကန်ဗပ်ပေါ်သို့ ဆွဲ၍ တည်နေရာ သတ်မှတ်ပါ',
    drag_text_hint:
      'အကြံပြုချက် - စာသားကို ကန်ဗပ်ပေါ်သို့ ဆွဲ၍ တည်နေရာ သတ်မှတ်ပါ',
    edit_badge: 'ဘျှေ့ချ်ပြင်ဆင်ပါ',
    create_new_badge: 'ဘျှေ့ချ်အသစ် ဖန်တီးပါ',
    select_video_preview: 'ကြိုတင်ကြည့်ရန် ဗီဒီယို ရွေးပါ',
    certificate_title_required: 'ဆောင်ပုဒ်လိုအပ်သည်',
    discard_changes: 'ပြောင်းလဲမှုများ ဖျက်မည်',
    edit_certificate: 'သက်သေခံလက်မှတ် ပြင်ဆင်ပါ',
    add_another_logo: 'အခြား လိုဂိုတစ်ခုပြန်ထည့်ပါ',
    optional: 'ရွေးချယ်ခွင့်ရှိသော',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'ခရီးစဉ်အသစ် ဖန်တီးပါ',
    quest_filter_title: 'ခရီးစဉ်',
    sharelook_assistance: 'Sharelook အကူအညီ',
    upload_scorm_zip: 'SCORM ZIP အပ်လုဒ်ပါ',
    only_letters_numbers_space_dot_allowed:
      'အက္ခရာ၊ နံပါတ်၊ နေရာလပ်နှင့် Dot အပါအဝင်သာ ခွင့်ပြုပါသည်!',
    video_playing: 'ဗီဒီယို ဖွင့်နေသည်',
    course_price_message:
      '*ဤသင်တန်းသည် အဖွဲ့အစည်း အသုံးပြုသူများအတွက်သာ ထုတ်ဝေပြီး စျေးကွက်တွင် မရောင်းနိုင်ပါ။',
    lesson_must_be_positive: 'သင်ခန်းစာအရေအတွက် ၁ ထက် ပိုရှိရမည်',
    btn_proceed: 'ဆက်လက်လုပ်ဆောင်မည်',
    rule_select_music: 'တေးဂီတ တစ်ပုဒ် ရွေးချယ်ပါ',
    course_info: 'သင်တန်းအချက်အလက်',
    content_selection: 'အကြောင်းအရာ ရွေးချယ်မှု',
    course_content_source: 'သင်တန်းအကြောင်းအရာ အရင်းအမြစ်',
    choose_how_to_source:
      'သင်တန်းအတွက် အကြောင်းအရာကို မည်သို့ ရယူမည်ကို ရွေးပါ:',
    automatic_selection: 'အလိုအလျောက် ရွေးချယ်မှု',
    system_will_automatically_select_relavant_documents:
      'စနစ်သည် သက်ဆိုင်ရာ စာရွက်စာတမ်းများကို အလိုအလျောက် ရွေးချယ်ပေးမည်။',
    manual_selection: 'ကိုယ်တိုင်ရွေးချယ်မှု',
    choose_specific_documents_from_your_library:
      'သင်၏ စာကြည့်တိုက်မှ စာရွက်စာတမ်းများကို ကိုယ်တိုင် ရွေးချယ်ပါ။',
    upload_files: 'ဖိုင်များ တင်ပါ',
    upload_new_documents:
      'စာရွက်စာတမ်းအသစ်များ (PDF, DOC, DOCX, PPT, PPTX, TXT) အများဆုံး ၅ ဖိုင် တင်ပါ။',
    file: 'ဖိုင်',
    ready_to_upload: 'တင်ရန်အဆင်သင့်ဖြစ်ပါသည်',
    clear_all: 'အားလုံး ဖျက်ပါ',
    confirm_course_wide_premiew: 'သင်တန်း Preview အတည်ပြုပါ',
    generate_course_preview: 'သင်တန်း Preview ဖန်တီးပါ',
    instructions_across_the_course_to_generate:
      'သင်၏ညွှန်ကြားချက်များကို သင်တန်းတစ်ခုလုံးအတွက် အသုံးပြုပြီး Preview တစ်ခု ဖန်တီးပါမည်။ သိမ်းရန်မတိုင်မီ ပြန်လည်စစ်ဆေးပါ။',
    instruction_to_preview_course_wide:
      'သင်တန်း Preview ပြုလုပ်ရန် ညွှန်ကြားချက်:',
    edit_content: 'အကြောင်းအရာ ပြင်ဆင်ပါ',
    manage_course_template: 'သင်တန်းပုံစံ စီမံပါ',
    undo: 'မလုပ်တော့ပါ',
    apply_changes: 'ပြောင်းလဲမှုများ အသုံးပြုပါ',
    characters: 'အက္ခရာ',
    apply_all: 'အားလုံး အသုံးပြုပါ',
    apply_to_all: 'အားလုံးသို့ အသုံးပြုပါ',
    use_this_content: 'ဤအကြောင်းအရာကို အသုံးပြုပါ',
    original: 'မူရင်း',
    edited: 'ပြင်ဆင်ပြီး',
    edited_content_preview: 'ပြင်ဆင်ပြီး အကြောင်းအရာ Preview',
    apply_edits_to_all_topices:
      'အကြောင်းအရာ အားလုံးသို့ ပြင်ဆင်မှု အသုံးပြုမည်?',
    current_editing_instructions_across_the_whole_course:
      'ဤအကြောင်းအရာသည် သင်တန်းတစ်ခုလုံးအတွက် သင်၏ ပြင်ဆင်မှုညွှန်ကြားချက်များကို အသုံးပြုပါမည်။ သိမ်းမီ ပြန်လည်စစ်ဆေးနိုင်ပါသည်။',
    edit_content_instructions: 'အကြောင်းအရာ ပြင်ဆင်ရန် ညွှန်ကြားချက်',
    generate_content_for_this_topic_instruction:
      'ဤအကြောင်းအရာအတွက် သင်၏ညွှန်ကြားချက်များ အသုံးပြုပြီး အကြောင်းအရာ ဖန်တီးပါ။',
    descrip_edit_content:
      'အကြောင်းအရာကို မည်သို့ ပြင်ဆင်မည်ကို ဖော်ပြပါ (ဥပမာ - အတိုချုံးပါ၊ လွယ်ကူအောင် ပြင်ပါ၊ စာသားပြန်ရေးပါ)',
    try_short_clear_direcctives:
      'တိုတောင်းပြီး ရှင်းလင်းသော ညွှန်ကြားချက်များ ပေးပါ။ ဥပမာ - “၁၀၀ စကားလုံးအတွင်း အတိုချုံးပါ”, “ဘာသာလွယ်အောင် ပြန်ရေးပါ”။',
    we_preserve_the_core_meaning:
      'ကျွန်ုပ်တို့သည် သင်၏ညွှန်ကြားချက်များ အသုံးပြုစဉ် အဓိကအဓိပ္ပါယ်ကို ထိန်းသိမ်းထားပါသည်။',
    feedback_optional: 'အကြံပြုချက် (ရွေးချယ်ခွင့်ရှိသည်)',
    write_your_feedback_here: 'အကြံပြုချက်ကို ဤနေရာတွင် ရေးပါ',
    from_web: 'ဝဘ်မှ',
    from_desktop: 'ဒက်စ်တော့မှ',
    pleae_wait_processing: 'ကျေးဇူးပြုပြီး စောင့်ပါ - စနစ်လုပ်ဆောင်နေသည်...',
    create_simulation_from_screen_capture:
      'အကွက်ဖမ်းမှုမှ Simulation တစ်ခု ဖန်တီးပါ',
    sharelook_not_found: 'ShareLook မတွေ့ပါ',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook စကရင်ဖမ်း Application ကို မဖွင့်နိုင်ပါ။ သင့်ကွန်ပျူတာတွင် မတပ်ဆင်ထားနိုင်ပါ။',
    download_sharelook: 'ShareLook ဒေါင်းလုဒ်လုပ်ပါ',
    launch_sharelook_application: 'ShareLook App ဖွင့်ပါ',
    this_will_open_the_sharelook_application_for_screen_capture:
      'ဤအရာသည် စကရင်ဖမ်းရန်အတွက် ShareLook App ကို ဖွင့်ပါမည်။',
    sharelook_dosenot_open:
      'ShareLook မဖွင့်ပါက သင်၏ ကွန်ပျူတာတွင် မတပ်ဆင်ထားနိုင်ပါ။',
    open_sharelook: 'ShareLook ဖွင့်ပါ',
    download_app: 'အက်ပ် ဒေါင်းလုဒ်ပါ',
    background_image_setting: 'နောက်ခံပုံ ဆက်တင်များ',
    current_image: 'လက်ရှိပုံ',
    change_image: 'ပုံပြောင်းပါ',
    remove_image: 'ပုံဖယ်ပါ',
    no_background_image_selected: 'နောက်ခံပုံ မရွေးရသေးပါ',
    add_image: 'ပုံထည့်ပါ',
    this_will_open_for_screen_recording:
      'ဤအရာသည် စကရင်မှတ်တမ်းတင်ရန်အတွက် ShareLook App ကို ဖွင့်ပါမည်။',
    ai_image_generation: 'AI ပုံဖန်တီးမှု',
    image_edit: 'ပုံပြင်ဆင်ခြင်း',
    text_to_image: 'စာသားမှ ပုံဖန်တီးခြင်း',
    output_gallary: 'ရလာဒ် ဓာတ်ပုံပြခန်း',
    instant_generation: 'ချက်ချင်း ဖန်တီးပါ',
    prompt_and_unleash_the_power: 'သင်၏ စာသားထည့်ပြီး AI ဗဟုသုတကို အသုံးပြုပါ',
    use_this_image: 'ဤပုံကို အသုံးပြုပါ',
    error_generating: 'ဖန်တီးစဉ် အမှား ဖြစ်ပွားသည်။',
    generation_tips: 'ဖန်တီးမှု အကြံပြုချက်များ',
    detailed_descriptions_for_more_accurate_results:
      'ပိုမိုတိကျသော ရလဒ်များအတွက် အသေးစိတ်ဖော်ပြချက်များ အသုံးပြုပါ',
    reference_image: 'အကိုးအကားပုံ',
    select_pixel_image: 'ပစ်ဆယ်ပုံ ရွေးပါ',
    max_mb: 'အများဆုံး ၅၀MB',
    please_enter_text_to_appear_image: 'ပုံပေါ်တွင် ဖော်ပြရန် စာသားထည့်ပါ',
    enter_text_to_apear_in_the_image: 'ပုံပေါ်တွင် ပြသရန် စာသားထည့်ပါ',
    generate_image: 'ပုံဖန်တီးပါ',
    prompt_assistant: 'Prompt အကူအညီ',
    generate_image_using_suggested_prompt: 'အကြံပြု Prompt ဖြင့် ပုံဖန်တီးပါ',
    talk_to_ai_about_the_image_generate:
      'သင်ဖန်တီးလိုသော ပုံအကြောင်းကို AI နှင့် ဆွေးနွေးပါ',
    ask_for_prompt_suggestions: 'Prompt အကြံပြုချက် တောင်းပါ...',
    enter_a_search_term_to_find_stock_images:
      'ပုံစံဓာတ်ပုံများ ရှာဖွေရန် စာလုံးတစ်လုံး ထည့်ပါ',
    choose_your_content_source: 'အကြောင်းအရာ အရင်းအမြစ် ရွေးချယ်ပါ:',
    upload_new_document_from_your_device: 'သင်၏ စက်မှ စာရွက်စာတမ်း အသစ် တင်ပါ',
    automatic_library_selection: 'အလိုအလျောက် စာကြည့်တိုက် ရွေးချယ်မှု',
    system_automatically_selects_relevant_document:
      'စနစ်သည် သက်ဆိုင်သော စာရွက်စာတမ်းများကို အလိုအလျောက် ရွေးချယ်ပါမည်။',
    manual_library_selection: 'ကိုယ်တိုင် စာကြည့်တိုက် ရွေးချယ်မှု',
    generate_content: 'အကြောင်းအရာ ဖန်တီးပါ',
    add_to_current_page: 'လက်ရှိစာမျက်နှာတွင် ထည့်ပါ',
    generate_bullet_points: 'အချက်အလက်အနက်ဖန်တီးပါ',
    generating: 'ဖန်တီးနေသည်...',
    this_may_take_a_few_moments: 'အချို့အချိန်ယူနိုင်ပါသည်။',
    apply_to_page: 'စာမျက်နှာသို့ အသုံးပြုပါ',
    scenario_escription: 'အဖြစ်အပျက် ဖော်ပြချက်:',
    feedback: 'အကြံပြုချက်',
    form_mode: 'ဖောင်ပုံစံ',
    chat_mode: 'ချက်ပုံစံ',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'ဤအရာသည် ရွေးချယ်ထားသော ပုံပြင်၏ ဆက်လက်ဖြစ်ရပ်များကို AI ဖြင့် ဖန်တီးပါမည်။',
    continue_this_story_question: 'ဤပုံပြင်ကို ဆက်လုပ်မည်လား?',
    continue_this_story: 'ပုံပြင် ဆက်လုပ်ပါ',
    what_will_happen: 'အဘယ်ကြောင့်ဖြစ်မည်:',
    the_ai_will_analyze_the_existing_story_content:
      'AI သည် ရှိပြီးသား ပုံပြင်အကြောင်းအရာကို ချင့်ချိန်လေ့လာမည်။',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'တူညီသော အသံနှင့် စတိုင်ဖြင့် သဘာဝဆန်သော ဆက်လက်ဖြစ်ရပ်တစ်ခု ဖန်တီးပါ။',
    create_new_content_that_build_upon_the_current_narrative:
      'လက်ရှိ ပုံပြင်အပေါ်အခြေခံပြီး အကြောင်းအရာ အသစ်များ ဖန်တီးပါ။',
    this_process_may_take_a_few_moments_to_complete:
      'ဤလုပ်ငန်းစဉ်သည် အချို့အချိန်ယူနိုင်ပါသည်။',
    no_existing_stories_found_for_this_course:
      'ဤသင်တန်းအတွက် ရှိပြီးသား ပုံပြင် မတွေ့ပါ။',
    create_your_first_story: 'သင့်ပထမဆုံး ပုံပြင်ကို ဖန်တီးပါ',
    existing_stories: 'ရှိပြီးသား ပုံပြင်များ',
    create_new_story: 'ပုံပြင်အသစ် ဖန်တီးပါ',
    tone: 'အသံ (Tone)',
    style: 'စတိုင်',
    genre: 'အမျိုးအစား',
    loading_your_stories: 'သင့်ပုံပြင်များကို စိစစ်နေသည်...',
    edit_story: 'ပုံပြင် ပြင်ဆင်ပါ',
    story_preferences: 'ပုံပြင် သဘောထားများ',
    please_input_your: 'ကျေးဇူးပြု၍ သင်၏ ... ထည့်ပါ',
    add_character_names_and_press_enter:
      'ဇာတ်ကောင်အမည်များ ထည့်ပြီး Enter နှိပ်ပါ',
    select_or_type_your: 'ရွေးချယ်မယ် ဒါမှမဟုတ် ရိုက်ထည့်ပါ',
    enter_your: 'သင့် ... ထည့်ပါ',
    position_of_the_story_in_the_lesson:
      'ပုံပြင်ကို သင်ခန်းစာတွင် မည်သည့်နေရာတွင် ထည့်မည်ကို သတ်မှတ်ပါ။ ပုံပြင်ကို သတ်မှတ်ထားသောနေရာတွင် block အဖြစ် ထည့်ပါမည်။',
    save_previous_content_on_the_pages:
      'စာမျက်နှာများပေါ်ရှိ ယခင်အကြောင်းအရာများကို သိမ်းဆည်းပါ',
    the_existing_content_in_the_selected_pages:
      'ရွေးချယ်ထားသော စာမျက်နှာများရှိ ယခင်အကြောင်းအရာများကို ဖန်တီးထားသော ပုံပြင်ဖြင့် အစားထိုးမည်။',
    real_world_scenario: 'အမှန်တကယ် ဖြစ်ပျက်နေသော အခြေအနေ',
    add_optional_instructions:
      'ရွေးချယ်စရာ ညွှန်ကြားချက်များ ထည့်ပါ (အသံ, အရှည်, ပရိသတ်, စသည်...)',
    ready_to_enerate_your_real_world_scenario:
      'သင့် အမှန်တကယ် ဖြစ်ပျက်နေသော အခြေအနေကို ဖန်တီးရန် အဆင်သင့်ဖြစ်ပါသည်',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'သင်ခန်းစာအကြောင်းအရာအရ အမှန်တကယ်ဖြစ်နိုင်သော အခြေအနေတစ်ခု ဖန်တီးရန် "Generate Real World Scenario" ကို နှိပ်ပါ။',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI သည် သင်ခန်းစာအကြောင်းအရာနှင့် ခေါင်းစဉ်များကို ချင့်ချိန်လေ့လာမည်',
    generate_a_practical_real_world_scenario:
      'လက်တွေ့ အမှန်တကယ် ဖြစ်နိုင်သော အခြေအနေ ဖန်တီးပါ',
    you_can_then_edit_and_customize_the_result:
      'ပြီးနောက် သင်သည် ရလဒ်ကို ပြင်ဆင်ပြီး စိတ်ကြိုက်ပြုလုပ်နိုင်ပါသည်',
    add_it_as_a_new_page_to_your_lesson: 'သင်ခန်းစာသစ်အဖြစ် ထည့်ပါ',
    regenerate_with_instructions: 'ညွှန်ကြားချက်နှင့်ပြန်ထုတ်ပါ',
    add_real_world_scenario: 'အစစ်အမှန် ကမ္ဘာဇာတ်အခင်းထည့်ပါ',
    generate_real_world_scenario: 'အစစ်အမှန် ကမ္ဘာဇာတ်အခင်း ဖန်တီးပါ',
    simulation_has_been_stopped: 'စမူလေးရှင်းရပ်ထားပါပြီ!',
    loading_simulation: 'စမူလေးရှင်း လုပ်ဆောင်နေပါသည်...',
    you_have_exhausted_all_the_attempts:
      'သင်အားလုံးကြိုးစားမှုကို အသုံးပြုပြီးပါပြီ',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'ဤစာမျက်နှာရှိ ဇာတ်အခင်းကို လေ့လာပြီး အောက်ပါရွေးချယ်မှုများမှ မှန်ကန်သော အဖြေကို ရွေးပါ။',
    attempts_limit_reached:
      'ကြိုးစားမှု အကန့်အသတ်ကို ရောက်ရှိသွားပါပြီ။ သင်နောက်တစ်ကြိမ် ကစားနိုင်သော်လည်း သင်၏အမှတ်မသိမ်းဆည်းပါ။',
    play_again: 'ထပ်မံကစားပါ',
    import_music_from_computer: 'ကွန်ပျူတာမှ တေးဂီတကို တင်သွင်းပါ။',
    more: 'ပိုပြီး',
    no_badge_yet: 'ဘတ်ဂျ်မရှိသေးပါ',
    competition_filter: 'ပြိုင်ပွဲ စစ်ထုတ်ခြင်း',
    global_leaderboard: 'ကမ္ဘာလုံးဆိုင်ရာ နိုင်ငံတော်အဆင့်စာရင်း',
    placeholder_for_the_global_leaderboard:
      'ကမ္ဘာလုံးဆိုင်ရာ နိုင်ငံတော်အဆင့်စာရင်း အတွက် placeholder ဖြစ်ပါသည်။',
    badge_editor: 'ဘတ်ဂျ် အယ်ဒီတာ',
    adjust_the_appearance_of_this_badge_icon:
      'ဤဘတ်ဂျ်အိုင်ကွန်၏ ပုံစံကို ညှိပါ။ ပြင်ဆင်မှုများသည် ဤဘတ်ဂျ်အတွက်သာ သက်ရောက်ပါသည်။',
    badge_style: 'ဘတ်ဂျ် ပုံစံ',
    the_image_must_be_pixels: 'ပုံသည် 200x200 ပစ်ဆယ် ဖြစ်ရမည်။',
    badge_name: 'ဘတ်ဂျ်အမည်',
    badge_descrription: 'ဘတ်ဂျ်ဖော်ပြချက်',
    enter_badge_criteria: 'ဘတ်ဂျ် သတ်မှတ်ချက် ထည့်ပါ',
    discard: 'မထည့်ပါ',
    badge_enable: 'ဘတ်ဂျ် ဖွင့်ထားသည်',
    award_users_with_badges_to_highlight_the_milestones:
      'သင်ခန်းစာခရီးတွင် လုပ်ဆောင်ချက်အရေးကြီးချက်များကို ဖော်ပြရန် အသုံးပြုသူများအား ဘတ်ဂျ်ပေးပါ။',
    badge_types: 'ဘတ်ဂျ် အမျိုးအစားများ',
    enable_or_disable_specific_badge_types_for_your_users:
      'အသုံးပြုသူများအတွက် ဘတ်ဂျ်အမျိုးအစား အချို့ကို ဖွင့်/ပိတ်ပါ။',
    levels_enabled: 'အဆင့် ဖွင့်ထားသည်',
    level_rules: 'အဆင့်နည်းဥပဒေ',
    points: 'ပွိုင့်',
    add_new_level: 'အဆင့်သစ်ထည့်ပါ',
    add_level: 'အဆင့်ထည့်ပါ',
    points_enabled: 'ပွိုင့် ဖွင့်ထားသည်',
    learning_activities_and_encourage_healthy_competition:
      'အမျိုးမျိုးသော သင်ယူမှု လှုပ်ရှားမှုများအတွက် အသုံးပြုသူများကို ပွိုင့်ပေးပြီး ကျန်းမာသော ပြိုင်ဆိုင်မှုကို လှုံ့ဆော်ပါ။',
    award_points: 'ပွိုင့်ပေးပါ',
    the_following_equates_the_value_of_one_item_completion:
      'အောက်ပါသည် တစ်ခုတည်းသော အရာအောင်မြင်မှုတန်ဖိုးနှင့် တန်းတူသည်',
    general: 'ပုံမှန်',
    others: 'အခြား',
    certificate: 'သင်တန်းလက်မှတ်',
    quiz_passed: 'ကွစ် ဖြေပြီးပါပြီ',
    tip_approved: 'အကြံပြုချက် ခွင့်ပြုထားသည်',
    tip_liked: 'အကြံပြုချက် နှစ်သက်သည်',
    rewards: 'ဆု',
    offer_discounts_when_learners_achieve:
      'သင်ယူသူများသည် သတ်မှတ်ပွိုင့်၊ ဘတ်ဂျ် သို့မဟုတ် အဆင့် ရောက်ရှိပါက လျှော့စျေး ပေးပါ။',
    give_rewards: 'ဆုပေးပါ',
    discount_course_purchases_by: 'သင်တန်းဝယ်ယူမှုအား လျှော့စျေးပေးပါ',
    with_points_more_than: 'ပိုပြီး ပွိုင့် ရှိပါက',
    with_badges_more_than: 'ပိုပြီး ဘတ်ဂျ် ရှိပါက',
    with_level_upwards_more_than: 'အဆင့်ပိုများပါက',
    leaderboard: 'နာမည်စာရင်း',
    leaderboard_enabled: 'နာမည်စာရင်း ဖွင့်ထားသည်',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'နာမည်စာရင်းသည် အသုံးပြုသူများကို သူတို့၏ သင်ယူမှု တိုးတက်မှုကို အခြားသူများနှင့် နှိုင်းယှဉ်၍ ကြည့်နိုင်ရန် ပေးပါသည်။',
    show_levels: 'အဆင့် ပြပါ',
    show_points: 'ပွိုင့်ပြပါ',
    show_badges: 'ဘတ်ဂျ်ပြပါ',
    show_courses: 'သင်တန်းပြပါ',
    show_certificates: 'လက်မှတ်ပြပါ',
    leaderboard_settings: 'နာမည်စာရင်း ဆက်တင်များ',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'သင်ယူသူ စိတ်အားထက်သန်မှု မြှင့်တင်ရန် စိတ်ဝင်စားဖွယ် နာမည်စာရင်း အတွေ့အကြုံများကို စီစဉ်ပါ။',
    award_users_with_points_for_different_learning_activities:
      'အမျိုးမျိုးသော သင်ယူမှု လှုပ်ရှားမှုများအတွက် အသုံးပြုသူများကို ပွိုင့်ပေးပါ။',
    badge_set: 'ဘတ်ဂျ် စနစ်',
    choose_the_type_of_badges_your_users:
      'သင်၏အသုံးပြုသူများ သင်ယူမှုအတွင်း ရရှိမည့် ဘတ်ဂျ်အမျိုးအစားကို ရွေးပါ။',
    levels: 'အဆင့်များ',
    Levels_represent_the_stages:
      'အဆင့်များသည် အသုံးပြုသူ၏ သင်ယူမှု ခရီးစဉ်အဆင့်များကို ကိုယ်စားပြုသည်။',
    enabled: 'ဖွင့်ထားသည်',
    disabled: 'ပိတ်ထားသည်',
    quick_select: 'အမြန်ရွေးချယ်မှု',
    yesterday: 'မနေ့က',
    last_week: 'ပြီးခဲ့သည့်အပတ်',
    Last_month: 'ပြီးခဲ့သည့်လ',
    last_quarter: 'ပြီးခဲ့သည့်သုံးလပတ်',
    historical_leaderboard: 'သမိုင်းနာမည်စာရင်း',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'သင်၏လုပ်ဆောင်မှုကို ချိန်ညှိပြီး အခြားသူများထဲတွင် သင်ဘယ်နေရာတွင်ရှိသည်ကို ကြည့်ပါ။',
    time_period: 'အချိန်ကာလ',
    page_of: 'စာမျက်နှာ 1 / 1',
    edit_competition: 'ပြိုင်ပွဲ တည်းဖြတ်ပါ',
    create_competition: 'ပြိုင်ပွဲ ဖန်တီးပါ',
    arrow_right: 'ညာဦး တံဆိပ်',
    update_competition: 'ပြိုင်ပွဲ အပ်ဒိတ်ပါ',
    competition_title: 'ပြိုင်ပွဲ ခေါင်းစဉ်',
    enter_competition_title: 'ပြိုင်ပွဲခေါင်းစဉ် ထည့်ပါ',
    enter_competition_description: 'ပြိုင်ပွဲ ဖော်ပြချက် ထည့်ပါ',
    leaderboard_skill: 'ကျွမ်းကျင်မှု',
    select_a_skill: 'ကျွမ်းကျင်မှု ရွေးပါ',
    no_skills_found: 'ကျွမ်းကျင်မှု မတွေ့ပါ',
    competition_period: 'ပြိုင်ပွဲကာလ',
    add_badge_rule: 'ဘတ်ဂျ် စည်းမျဉ်း ထည့်ပါ',
    create_badge: 'ဘတ်ဂျ် ဖန်တီးပါ',
    add_level_rule: 'အဆင့် စည်းမျဉ်း ထည့်ပါ',
    selected_participants: 'ရွေးချယ်ထားသော ပါဝင်သူများ',
    no_participants: 'ပါဝင်သူ မရှိပါ',
    start_end_date: 'စတင်/ပြီးဆုံးရက်',
    created_date: 'ဖန်တီးသူ',
    new_competition: 'ပြိုင်ပွဲအသစ်',
    competitions_list: 'ပြိုင်ပွဲစာရင်း',
    search_competitions: 'ပြိုင်ပွဲရှာပါ...',
    are_you_sure_you_want_to_delete_the_competition:
      'သင်ပြိုင်ပွဲကို ဖျက်ရန် မည်သို့သေချာပါသလား?',
    history: 'သမိုင်း',
    export: 'တင်ပို့ပါ',
    search_by_name: 'အမည်ဖြင့် ရှာပါ...',
    no_historical_data_available_for_the_selected_period:
      'ရွေးထားသောကာလအတွက် သမိုင်းဒေတာ မရှိပါ။',
    no_leaderboard_data_available: 'နာမည်စာရင်း ဒေတာ မရှိပါ။',
    competitions: 'ပြိုင်ပွဲများ',
    leaderboards: 'နာမည်စာရင်းများ',
    welcome_back: 'ပြန်လည်ကြိုဆိုပါသည်',
    track_your_performance_and_see: 'သင်၏လုပ်ဆောင်မှုကို ချိန်ညှိပြီး ကြည့်ပါ:',
    team_leaderboard: 'အဖွဲ့ နာမည်စာရင်း',
    try_again: 'ထပ်မံကြိုးစားပါ',
    no_competitions_for_search: 'ရှာဖွေရန် ပြိုင်ပွဲမရှိပါ',
    no_competitions_available: 'ပြိုင်ပွဲမရှိပါ',
    no_competitions_matching_search:
      'သင်ရှာဖွေမှုနှင့် ကိုက်ညီသော ပြိုင်ပွဲမတွေ့ပါ။ အသုံးအနှုန်း ပြောင်းပြီး ထပ်မံကြိုးစားပါ။',
    no_competitions_general:
      'လောလောဆယ် ပြိုင်ပွဲမရှိပါ။ နောက်မှ ပြန်စစ်ပါ သို့မဟုတ် စီမံခန့်ခွဲသူထံ အဆက်အသွယ်ပြု၍ ပြိုင်ပွဲအသစ် ဖန်တီးပါ။',
    media_management: 'မီဒီယာ စီမံခန့်ခွဲမှု',
    badgess_set: 'ဘတ်ဂျ် စနစ်',
    choose_the_default_visual_style_for_badge:
      'ပလက်ဖောင်းတစ်လျှောက် အသုံးပြုမည့် ဘတ်ဂျ်အိုင်ကွန်များအတွက် သို့မဟုတ် ပုံစံ ရွေးပါ။',
    enable_badges: 'ဘတ်ဂျ် ဖွင့်ပါ',
    add_badge: 'ဘတ်ဂျ် ထည့်ပါ',
    min: 'အနည်းဆုံး',
    max: 'အများဆုံး',
    your_rank: 'သင့်အဆင့်',
    your_points: 'သင့်ပွိုင့်',
    your_level: 'သင့်အဆင့်',
    rank: 'အဆင့် #',
    level: 'အဆင့်',
    progress: 'တိုးတက်မှု',
    new_folder: 'ဖိုလ်ဒါသစ်',
    file_upload: 'ဖိုင်တင်သွင်းမှု',
    writer: 'ရေးသူ',
    text_documents: 'စာရွက်စာတမ်းများ',
    spreadsheets: 'စာရင်းဇယားများ',
    impress: 'အင်ပရက်စ်',
    presentations: 'နာရီသရုပ်ပြမှုများ',
    capture_desktop_screen: 'ဒက်စ့ထပ် စကရင် ဖမ်းယူပါ',
    capture_desktop_screens: 'ဒက်စ့ထပ် စကရင်များ ဖမ်းယူပါ',
    your_documents: 'သင့်စာရွက်စာတမ်းများ',
    manage_your_videos_images_audio_files:
      'သင်၏ ဗီဒီယို၊ ပုံများ၊ အသံဖိုင်များနှင့် အခြားအချို့ကို စီမံခန့်ခွဲပါ။',
    your_organization_documents: 'သင့်အဖွဲ့အစည်းစာရွက်စာတမ်းများ',
    keep_your_organization_creative_assets_organized:
      'သင့်အဖွဲ့အစည်း၏ ဖန်တီးမှုအရင်းအမြစ်များကို စနစ်တကျ ထိန်းသိမ်းပါ။',
    your_public_documents: 'သင့်အများပြည်သူစာရွက်စာတမ်းများ',
    curated_collection_of_media_assets_available:
      'အားလုံးအတွက် ရွေးချယ်ထားသည့် မီဒီယာအရင်းအမြစ်များ- စူးစမ်းပါ၊ ပြန်အသုံးပြုပါ၊ ဖန်တီးပါ။',
    your_download_center_documents: 'သင့်ဒေါင်းလုဒ်စင်တာစာရွက်စာတမ်းများ',
    repository_of_approved_media_assets_for_download:
      'ဒေါင်းလုဒ်လုပ်နိုင်သည့် အတည်ပြုမီဒီယာအရင်းအမြစ်များ စုစည်းထားသည်။',
    search_files_and_folders: 'ဖိုင်များနှင့် ဖိုလ်ဒါများ ရှာပါ...',
    home: 'မူလစာမျက်နှာ',
    folders: 'ဖိုလ်ဒါများ',
    folder_name: 'ဖိုလ်ဒါအမည်',
    owner: 'ပိုင်ရှင်',
    last_updated: 'နောက်ဆုံး ပြင်ဆင်ချိန်',
    action: 'လုပ်ဆောင်ချက်',
    no_folders_found: 'ဖိုလ်ဒါမတွေ့ပါ',
    files: 'ဖိုင်များ',
    enabling_ai: 'AI ကိုဖွင့်နေပါသည်...',
    rename: 'နာမည်ပြောင်းပါ',
    copy: 'မိတ္တူ',
    move: 'ရွှေ့ပါ',
    verson_history: 'ဗားရှင်းသမိုင်း',
    manage_permission: 'ခွင့်ပြုချက် စီမံပါ',
    generate_audit_report: 'စာရင်းစစ်အစီရင်ခံစာ ဖန်တီးပါ',
    last_edited: 'နောက်ဆုံးပြင်ဆင်မှု',
    no_files_found: 'ဖိုင်မတွေ့ပါ',
    are_you_sure_you_want_to_make_this_item_public:
      'ဤအရာကို အများပြည်သူသို့ လွှင့်မည်မှာ သေချာပါသလား? ၎င်းသည် သင့်အများပြည်သူစာကြည့်တိုက်သို့ မိတ္တူသွင်းပါမည်။',
    move_to_organization: 'အဖွဲ့အစည်းသို့ ရွှေ့ပါ',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'ဤအရာကို သင်၏ အဖွဲ့အစည်းစာကြည့်တိုက်သို့ မိတ္တူသွင်းမည်မှာ သေချာပါသလား?',
    are_you_sure_you_want_to_make_this_item_private:
      'ဤအရာကို ပုဂ္ဂိုလ်ရေးသို့ပြောင်းရန် သေချာပါသလား? ၎င်းကို သင့်ကိုယ်ပိုင်စာကြည့်တိုက်သို့ မိတ္တူသွင်းပါမည်။',
    date_modified: 'ပြင်ဆင်ခဲ့သည့်နေ့စွဲ',
    workflow_management: 'Workflow စီမံခန့်ခွဲမှု',
    configure_editors_approvers_and_viewers_for_this_document:
      'ဤစာရွက်စာတမ်းအတွက် အယ်ဒီတာများ၊ အတည်ပြုသူများ နှင့် ကြည့်ရှုသူများကို ဖန်တီးပါ။',
    error_Loading_editor: 'အယ်ဒီတာကို ရှာမတွေ့ပါ',
    debug_info: 'Debug အချက်အလက်',
    loading_editor: 'အယ်ဒီတာကို လုပ်ဆောင်နေပါသည်...',
    submitted_for_review: 'သုံးသပ်ရန် တင်ထားပြီး',
    editors: 'အယ်ဒီတာများ',
    no_editors_added_yet:
      'အယ်ဒီတာမရှိသေးပါ။ ထည့်ရန် "အယ်ဒီတာထည့်ပါ" ကိုနှိပ်ပါ။',
    add_editor: 'အယ်ဒီတာထည့်ပါ',
    approvers: 'အတည်ပြုသူများ',
    no_approvers_added_yet:
      'အတည်ပြုသူ မရှိသေးပါ။ ထည့်ရန် "အတည်ပြုသူထည့်ပါ" ကိုနှိပ်ပါ။',
    add_approvers: 'အတည်ပြုသူ ထည့်ပါ',
    viewer: 'ကြည့်ရှုသူ',
    no_viewers_added_yet:
      'ကြည့်ရှုသူ မရှိသေးပါ။ ထည့်ရန် "ကြည့်ရှုသူထည့်ပါ" ကိုနှိပ်ပါ။',
    add_viewer: 'ကြည့်ရှုသူ ထည့်ပါ',
    are_you_sure_you_want_to_delete_the_selected_items:
      'ရွေးထားသောအရာများကို ဖျက်ရန် သေချာပါသလား?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'အမျိုးအစားအနှစ်ချုပ်',
    triviaReport: 'ShareSphere အမျိုးအစား',
    overviewGraph: 'အမျိုးအစားအနှစ်ချုပ် ဂရပ်',
    category: 'အမျိုးအစား',
    phCategory: 'အမျိုးအစားရွေးချယ်ပါ',
    podcast: 'ပေါ့ဒ်ကတ်၊ တေးဂီတနှင့်ပုံပြင်များ',
    pastPodcast: 'ယခင် ပေါ့ဒ်ကတ်',
    upcomingPodcast: 'လာမည့် ပေါ့ဒ်ကတ်',
    podcastLanguageTitle: 'ပေါ့ဒ်ကတ်၊ တေးဂီတနှင့်ပုံပြင်များ၏ ဘာသာစကား',
    podcastLanguageCheckbox: 'ကျွန်ုပ်၏ပေါ့ဒ်ကတ်အတွက် AI ဘာသာစကားဖန်တီးပါ',
    howRate: 'ဤပေါ့ဒ်ကတ်ကို သင်ဘယ်လို အကဲဖြတ်မည်နည်း?',
    podcastSubmit: 'တင်ပြပါ',
    podcastGuest: 'ဧည့်သည် တင်ဆက်သူ:',
    podcastReview: 'သုံးသပ်ချက်များ',
    podcastEpishode: 'အစီအစဉ်များ',
    podcastEnd: 'ပေါ့ဒ်ကတ် အပြီးသတ်ပါပြီ',
    date_podcast: 'ပေါ့ဒ်ကတ် ရက်စွဲ',
    skill_not_found: 'ဆင်းရဲပါ! ကျွမ်းကျင်မှု ခရီးစဉ် မတွေ့ရှိပါ။',
    coaching: 'လေ့ကျင့်မှု',
    webinar: 'ဝက်ဘီနာ',
    public_conference: 'အများပြည်သူ ဆွေးနွေးပွဲ',
    skill_journey_subtitle:
      'သင့်ကျွမ်းကျင်မှု ခရီးစဉ်တွင် ဆက်တင်များ ထည့်သွင်းပြီး ဘယ်သူတွေကြည့်ရှု၍ အပြန်အလှန်ဆက်ဆံနိုင်မလဲ ရွေးချယ်ပါ။',
    enable_white_label: 'အဖြူအမှတ်တံဆိပ် ဖွင့်ပါ',
    create_new_event_org: 'သင့်အဖွဲ့အစည်းအတွက် အစီအစဉ်အသစ် တည်ဆောက်ပါ။',
    create_new_event_marketplace: 'ဈေးကွက်အတွက် အစီအစဉ်အသစ် တည်ဆောက်ပါ။',
    create_new_event_both:
      'သင့်အဖွဲ့အစည်းနှင့် ဈေးကွက် နှစ်ခုလုံးအတွက် အစီအစဉ်အသစ် တည်ဆောက်ပါ။',
    event_outline: 'အကြောင်းအရာ အကျဉ်းချုပ် ထည့်ပါ',
    event_obj: 'အစီအစဉ် ရည်မှန်းချက်များ ထည့်ပါ',
    event_description: 'အစီအစဉ် ဖော်ပြချက် ထည့်ပါ',
    create_new_metamaze_org: 'သင့်အဖွဲ့အစည်းအတွက် MetaMaze အသစ် တည်ဆောက်ပါ။',
    create_new_metamaze_marketplace: 'ဈေးကွက်အတွက် MetaMaze အသစ် တည်ဆောက်ပါ။',
    create_new_metamaze_both:
      'သင့်အဖွဲ့အစည်းနှင့် ဈေးကွက် နှစ်ခုလုံးအတွက် MetaMaze အသစ် တည်ဆောက်ပါ။',
    add_key_words: 'သော့စကားများ ထည့်ပါ',
    press_enter_make_keyword: 'သော့စကား ဖန်တီးရန် Enter ခလုတ်ကိုနှိပ်ပါ',
    disable_skip_quiz: 'မေးခွန်းဖြေခြင်း လွှဲပြောင်းမှု ပိတ်ထားပါ',
    warning_complete_quiz:
      'ဆက်လက်ရန် ကျေးဇူးပြု၍ မေးခွန်းဖြေခြင်း ပြီးမြောက်ပါ။',
    signup_email_verification:
      'သင်ပေးအပ်သော အီးမေးလ်လိပ်စာသို့ အတည်ပြုလင့်ခ် ပေးပို့ပြီးပါပြီ။ အဆိုပါလင့်ခ်သို့ သွားရောက်၍ မှတ်ပုံတင်ခြင်း အတည်ပြုပါ။',
    verifying_registration: 'အကောင့် မှတ်ပုံတင်မှု စစ်ဆေးနေသည်...',
    reset_password_linK:
      'သင်ပေးအပ်သော အီးမေးလ်လိပ်စာသို့ လင့်ခ် ပေးပို့ပြီးပါပြီ။ လင့်ခ်သို့ သွားရောက်၍ စကားဝှက်အသစ် သတ်မှတ်ပါ။',
    reset_email_error:
      'ဤအီးမေးလ်ဖြင့် အသုံးပြုသူ မတွေ့ရှိပါ၊ ကျေးဇူးပြု၍ အသုံးပြုသူအမည်ဖြင့် ထပ်မံကြိုးစားပါ။',
    first_name: 'နာမည် (အရှေ့)',
    last_name: 'နောက်ဆုံးအမည်',
    error_firstName: 'ကျေးဇူးပြု၍ သင်၏ နာမည် (အရှေ့) ထည့်ပါ',
    error_sharebot_organization: 'ကျေးဇူးပြု၍ သင်၏ အဖွဲ့အစည်းအမည် ထည့်ပါ',
    error_lastName: 'ကျေးဇူးပြု၍ သင်၏ နောက်ဆုံးအမည် ထည့်ပါ',
    private_conference: 'ပုဂ္ဂလိက ဆွေးနွေးပွဲ',
    public_conference: 'အများပြည်သူ ဆွေးနွေးပွဲ',
    discussion_room: 'ဆွေးနွေးခန်း',
    training_no_courses: 'သင်သည် လက်ရှိတွင် သင်တန်းမရှိပါ။',
    training_no_events: 'သင်သည် လက်ရှိတွင် အစီအစဉ်မရှိပါ။',
    allow_sharing_trainer_info:
      'ဈေးကွက်တွင် အီးမေးလ်လိပ်စာ မျှဝေရန် ခွင့်ပြုပါ',
    error_username_space: 'အသုံးပြုသူအမည်တွင် အလွတ်နေရာ မပါဝင်နိုင်ပါ။',
    error_sharebot_organization_space:
      'အဖွဲ့အစည်းအမည်တွင် အလွတ်နေရာ မပါဝင်နိုင်ပါ။',
    edit_permission: 'ပြုပြင်ခွင့်',
    valid_price: 'စျေးနှုန်းသည် 0 ထက် ကြီးရမည်',
    course_price_message: `*သင်တန်းကို အဖွဲ့အစည်းမှ ဝယ်ယူထားသည့် အသုံးပြုသူအရေအတွက်သို့သာ ထုတ်ပြန်မည်ဖြစ်ပြီး ဈေးကွက်တွင် ပြန်လည်ရောင်းချ၍ မရပါ။`,
    valid_edit_price:
      'ပြင်ဆင်မည့် စျေးနှုန်းသည် ဝယ်ယူမည့် စျေးနှုန်းထက် နည်းရမည်။',
    my_calendar: 'ကျွန်ုပ်၏ ကယ်လင်ဒါ',
    error_valid_firstName: 'ကျေးဇူးပြု၍ တရားဝင် နာမည် (အရှေ့) ရိုက်ထည့်ပါ။',
    error_valid_organization: 'ကျေးဇူးပြု၍ တရားဝင် အဖွဲ့အစည်းအမည် ရိုက်ထည့်ပါ။',
    error_valid_lastName: 'ကျေးဇူးပြု၍ တရားဝင် နောက်ဆုံးအမည် ရိုက်ထည့်ပါ။',
    error_name_spaces: 'နာမည်တွင် အလွတ်နေရာ မပါဝင်နိုင်ပါ',
    items: 'ပစ္စည်းများ',
    publish_to_channel: 'ကျွန်ုပ်၏ ချန်နယ် စုစည်းမှုတွင် ထုတ်ပြန်ပါ',
    create_a_channel: 'ကျွန်ုပ်၏ ချန်နယ် တည်ဆောက်ပါ',
    create_a_trivia: 'ပြိုင်ပွဲဂိမ်း တည်ဆောက်ပါ',
    create_a_new_channel: 'ချန်နယ် အသစ် တည်ဆောက်ပါ',
    add_videos: 'ဗီဒီယို ထည့်ပါ',
    save_and_continue: 'သိမ်းဆည်းပြီး ဆက်လက်လုပ်ဆောင်ပါ',
    channel: 'ချန်နယ်',
    channels: 'ချန်နယ်များ',
    view_channel: 'ချန်နယ်ကြည့်ရန်',
    edit_channel: 'ချန်နယ် ပြင်ဆင်ရန်',
    delete_channel: 'ချန်နယ် ဖျက်ရန်',
    my_video_channels: 'ကျွန်ုပ်၏ ဗီဒီယို ချန်နယ်များ',
    training_no_channel: 'သင်သည် လက်ရှိတွင် ချန်နယ်မရှိပါ။',
    monthly_price_required: 'လစဉ်စျေးနှုန်း လိုအပ်သည်',
    yearly_price_required: 'နှစ်စဉ်စျေးနှုန်း လိုအပ်သည်',
    one_time_price_required: 'တစ်ကြိမ်ပဲသော စျေးနှုန်း လိုအပ်သည်',
    marketplace_quantity: 'USD',
    report_webinar: 'ဝက်ဘီနာ',
    report_coaching: 'လေ့ကျင့်မှု',
    report_channel: 'ချန်နယ်',
    report_public_conference: 'အများပြည်သူ ဆွေးနွေးပွဲ',
    report_maze: 'မေးဇ်',
    channel: 'ချန်နယ်',
    edit_price: 'စျေးနှုန်း ပြင်ဆင်ရန် ($)',
    quantity: 'ပမာဏ',
    payment_type: 'ပေးချေမှု အမျိုးအစား',
    total_amount: 'စုစုပေါင်း ပမာဏ ($)',
    net_amount: 'အနုတ်ပမာဏ ($)',
    edit_option: 'ပြင်ဆင်ရန် ရွေးချယ်စရာ',
    marketplace_price: 'စျေးနှုန်း ($)',
    market_name: 'နာမည်',
    duration_min: 'အချိန် (မိနစ်)',
    users_total: 'အသုံးပြုသူ (စုစုပေါင်း)',
    sales_total: 'အရောင်းစုစုပေါင်း (USD)',
    search_coaching: 'လေ့ကျင့်မှု ရှာဖွေမှု',
    search_channel: 'ချန်နယ် ရှာဖွေမှု',
    search_webinar: 'ဝက်ဘီနာ ရှာဖွေမှု',
    search_maze: 'မေးဇ် ရှာဖွေမှု',
    search_public_conference: 'အများပြည်သူ ဆွေးနွေးပွဲ ရှာဖွေမှု',
    buyer_type: 'ဝယ်သူအမျိုးအစား',
    quanity: 'ပမာဏ',
    channel_unit_amount: 'အနုတ်ပမာဏ ($)',
    channel_updated_at: 'နောက်ဆုံးပြင်ဆင်သည့်ရက်',
    month: 'လ',
    year: 'နှစ်',
    onetime: 'တစ်ကြိမ်',
    marketplace: 'ဈေးကွက်',
    marketplace_price_per_month: 'လစဉ်စျေးနှုန်း',
    marketplace_price_per_year: 'နှစ်စဉ်စျေးနှုန်း',
    marketplace_price_onetime: 'တစ်ကြိမ်ပဲသော စျေးနှုန်း',
    month_label: 'လ',
    year_label: 'နှစ်',
    one_time_label: 'တစ်ကြိမ်',
    select_filter: 'စစ်ထုတ်ရန် ရွေးပါ',
    search_filter_placeholder: 'ရှာဖွေမည့် စကားလုံးကို ရိုက်ထည့်ပါ',
    no_result_found: 'ရလဒ် မတွေ့ရှိပါ',
    ai_course_title: 'သင်တန်းခေါင်းစဉ်',
    ai_input_course_title: 'ကျေးဇူးပြု၍ သင်တန်းခေါင်းစဉ်ကို ထည့်ပါ!',
    learning_objective_label: 'သင်ယူရန် ရည်ရွယ်ချက်',
    learning_objective_message: 'ကျေးဇူးပြု၍ သင်ယူရန် ရည်ရွယ်ချက်ကို ထည့်ပါ!',
    standard_question: 'သင်ယူသူများလိုက်နာရမည့် စံချိန်မရှိပါသလား?',
    standard_details_label: 'စံချိန်အသေးစိတ်',
    standard_details_message: 'ကျေးဇူးပြု၍ စံချိန်အသေးစိတ်ကို ထည့်ပါ!',
    estimated_duration_label: 'သင်တန်းကြာချိန် ခန့်မှန်းချက် (မိနစ်ဖြင့်)',
    estimated_duration_message: 'ကျေးဇူးပြု၍ ကြာချိန် ခန့်မှန်းချက်ကို ထည့်ပါ!',
    min_duration_message: 'အနည်းဆုံး ကြာချိန်မှာ မိနစ် ၅ ဖြစ်ရပါမည်။',
    ai_mins: '၂၅ မိနစ်',
    industry_specific_question: 'လုပ်ငန်းအထူးသီးသန့်ပါသလား?',
    industry_label: 'လုပ်ငန်းအမျိုးအစား ဖော်ပြပါ',
    industry_message: 'ကျေးဇူးပြု၍ လုပ်ငန်းအမျိုးအစားကို ထည့်ပါ!',
    ai_course_creation: 'AI သင်တန်းဖန်တီးခြင်း',
    course_generated: 'Sharelook မှ ဖန်တီးသော သင်တန်း',
    ai: 'AI',
    ai_you: 'သင်',
    ai_prompt_ready:
      'သင်၏ prompt ပြီးစီးပါပြီ။ အခု Table of Content ဖန်တီးနိုင်ပါပြီ။',
    ai_unable_respond:
      'တောင်းပန်ပါတယ်! AI သည် သင်၏ prompt ကို တုံ့ပြန်၍ မရပါ။ ထပ်မံ ကြိုးစားပါ။',
    ai_hide_toc: 'Table of Content ကို ဖျောက်ရန်',
    ai_preview_toc: 'Table of Content ကြိုပြချက်',
    ai_generate_toc_now: 'ယခု Table of Content ဖန်တီးပါ',
    ai_creation_course_title: 'သင်တန်းခေါင်းစဉ်:',
    ai_creation_industry_specific: 'လုပ်ငန်းအထူးသီးသန့်ပါသလား:',
    ai_creation_industry: 'လုပ်ငန်းအမျိုးအစား:',
    ai_creation_standard_needed: 'သင်ယူသူများလိုက်နာရမည့် စံချိန် ရှိပါသလား?:',
    ai_creation_standard_details: 'စံချိန် အသေးစိတ်:',
    ai_creation_estimated_duration:
      'သင်တန်းကြာချိန် ခန့်မှန်းချက် (မိနစ်ဖြင့်):',
    minutes: 'မိနစ်',
    ai_creation_learning_objective: 'သင်ယူရန် ရည်ရွယ်ချက်:',
    setup_again: 'ထပ်မံ ပြင်ဆင်ရန်',
    ai_creation_confirm_title: 'ဖောင်ကို ထပ်မံ ပြင်ဆင်ရန် သေချာပြီလား?',
    ai_creation_confirm_content:
      'စကားပြောခန်းနှင့် ဖန်တီးထားသော အကြောင်းအရာများအားလုံး ပြန်လည် စတင်သွားမည် ဖြစ်သည်။',
    ai_toc: 'Table of Content',
    ai_note_topic:
      'မှတ်ချက်: သင်ခန်းစာအတွင်း ခေါင်းစဉ်များကို ဆွဲယူ၍ စီစဉ်နိုင်သည်။',
    ai_add_topic: '+ ခေါင်းစဉ် ထပ်ထည့်ရန်',
    add_topic: 'ခေါင်းစဉ် ထည့်ရန်',
    add_lesson: 'သင်ခန်းစာ ထည့်ရန်',
    add_new_lesson: 'သင်ခန်းစာ အသစ် ထည့်ရန်',
    ai_add_lesson: '+ သင်ခန်းစာ ထည့်ရန်',
    attention: 'ဂရုစိုက်ရန်',
    before_varifying: 'အတည်ပြုမီ',
    ai_save_later: 'နောက်မှ သိမ်းဆည်းရန်',
    ai_download_word_doc: 'Word စာရွက်အဖြစ် ဒေါင်းလုပ်လုပ်ရန်',
    ai_download_course_word_doc:
      'သင်တန်းကို Word စာရွက်အဖြစ် ဒေါင်းလုပ်လုပ်ရန်',
    ai_create_course_button: 'သင်တန်း ဖန်တီးမည်',
    ai_generate_course_content: 'သင်တန်း အကြောင်းအရာ ဖန်တီးမည်',
    ai_out_of: 'မှ',
    ai_subtopic_failed_content:
      'ခွဲခေါင်းစဉ်များအတွက် အကြောင်းအရာ ဖန်တီးမှု မအောင်မြင်ပါ။ "သင်တန်းအကြောင်းအရာ ဖန်တီးမည်" ခလုတ်ကို ထပ်မံနှိပ်ပါ။',
    ai_edit_topic: 'ခေါင်းစဉ် ပြင်ဆင်ရန်',
    ai_edit_lesson_title: 'သင်ခန်းစာခေါင်းစဉ် ပြင်ဆင်ရန်',
    ai_save_topic: 'ခေါင်းစဉ် သိမ်းဆည်းရန်',
    ai_save: 'သိမ်းဆည်းရန်',
    ai_save_lesson_title: 'သင်ခန်းစာခေါင်းစဉ် သိမ်းဆည်းရန်',
    ai_add_new_topic: 'ခေါင်းစဉ် အသစ် ထည့်ရန်',
    ai_download_ref: 'ရင်းမြစ်များနှင့်အတူ ဒေါင်းလုပ်လုပ်ရန်',
    ai_download_ref_content:
      'သင်တန်းကို ရင်းမြစ်များပါဝင်သည့် Word စာရွက်အဖြစ် ဒေါင်းလုပ်လုပ်ပါမည်။',
    ai_download_without_ref: 'ရင်းမြစ် မပါသော အတိုင်း ဒေါင်းလုပ်လုပ်ရန်',
    ai_download_two_word: 'Word စာရွက် နှစ်စောင် ဒေါင်းလုပ်လုပ်မည်။',
    ai_download_two_word_content_one:
      '- အကြောင်းအရာ အဓိကပါဝင်သည့် စာရွက်တစ်စောင်၊',
    ai_download_two_word_content_two:
      '- ရင်းမြစ်စာရင်းသာပါရှိသည့် စာရွက်တစ်စောင်။',
    ai_manage_content: 'အကြောင်းအရာ စီမံခန့်ခွဲရန်',
    ai_add_content_from_internet: '+ အင်တာနက်မှ အကြောင်းအရာ ထည့်ရန်',
    ai_confirm_start: 'စတင်ရန် အတည်ပြုပါ',
    ai_Verify: 'အတည်ပြုပါ',
    ai_undo_warning:
      'ဤလုပ်ငန်းစဉ်မှာ အချိန်ယူနိုင်ပါသည်။ ပြီးဆုံးရန် မပြုလုပ်သေးသည့်အထိ ဤပြတင်းပေါ်ကို ပိတ်မထားပါနှင့်၊ ပြန်လည် ပြုပြင်၍ မရပါ။',
    ai_verified_content:
      'သင်သည် အကြောင်းအရာကို အတည်ပြုခဲ့ပါသည်။ အတည်ပြုချိန်မှစပြီး AI အကူအညီနှင့် စကားပြောခန်းသို့ ပြန်သွား၍ မရပါ။',
    ai_want_proceed: 'သင်ဆက်လက်လုပ်ဆောင်ရန် သေချာပါသလား?',
    upload_simulation: 'စမ်းသပ်မှု အပ်လုတ်လုပ်ရန်',
    name_simulation: 'စမ်းသပ်မှု အမည်',
    selected_simulation_files: 'ရွေးချယ်ထားသော စမ်းသပ်မှု ဖိုင်များ',
    score_between_one_hundred: 'မှတ်ပုံတင်သည် ၁ မှ ၁၀၀ ကြားရှိရမည်။',
    are_sure_simulation: 'ဤ စမ်းသပ်မှု ဖိုင်ကို ဖျက်ရန် သေချာပါသလား?',
    required_simulation: 'မှတ်ပုံတင် လိုအပ်သည်',
    required_section_file: 'အပိုင်း ဖိုင် လိုအပ်သည်',
    simulation: 'စမ်းသပ်မှု',
    simulation_quiz_games: 'ဂိမ်းများတွင် မေးခွန်းထည့်ရန် လိုအပ်သည်',
    simulation_alert_des:
      'မေးခွန်းများအားလုံး၏ ဖြေဆိုမှု အမျိုးအစား Single သို့မဟုတ် Multiple ဖြစ်ပါကသာ ဂိမ်းများထည့်နိုင်သည်။',
    alert_info: 'သတင်းအချက်အလက်',
    ai_number_quiz: 'မေးခွန်း အရေအတွက်',
    ai_point: 'အမှတ်',
    ai_points: 'အမှတ်များ',
    val_required: 'လိုအပ်သည်',
    games: 'ဂိမ်းများ',
    add_simulation: 'စမ်းသပ်မှု ထည့်ရန်',
    text_tiewer: 'စာသား ကြည့်ရှုရန်',
    back_to_account: 'အကောင့်သို့ ပြန်သွားရန်',
    delete_account: 'အကောင့် ဖျက်ရန်',
    delete_account_title: 'အကောင့် ဖျက်ရန် ???',
    delete_account_subtitle: 'ဤနေရာမှ သင်၏ အကောင့်ကို ဖျက်နိုင်ပါသည်။',
    delete_account_cannot_undo:
      'သင်၏ အကောင့်ကို ဖျက်ရန် ရှိနေပါသည်။ ဤလုပ်ဆောင်ချက်ကို ပြန်လည် ပြုပြင်၍ မရပါ။',
    account_org_profile:
      'သင်ဖန်တီးထားသည့် သင်တန်းများ၊ သင့်အဖွဲ့အစည်း ပရိုဖိုင်နှင့် ဆက်တင်များအားလုံးကိုလည်း လက်လျော့မည်။',
    deleting_account_database:
      'အကောင့်ဖျက်ခြင်းသည် ဒေတာများအားလုံးကို ဒေတာဘေ့စ်မှ ဖျက်မည်။',
    account_confirm_delete: 'သင် အကောင့်ဖျက်ရန် သေချာပါသလား?',
    action_cannot_be_undone: 'ဤလုပ်ဆောင်ချက်ကို ပြန်လည် မပြုလုပ်နိုင်ပါ။',
    account_delete_message_success:
      'သင်၏ အကောင့်ကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ။',
    message_edit: 'ပြင်ဆင်ရန်',
    message_delete: 'ဖျက်ရန်',
    message_reply: 'ပြန်ဖြေမည်',
    attached_file: 'ဖိုင် တပ်ဆင်ပြီး',
    attach_file: 'ဖိုင် တပ်ဆင်ရန်',
    attach_des: '၂၅ MB၊ အများဆုံး ဖိုင်အရွယ်အစား',
    view: 'ကြည့်ရန်',
    go_to_marketplace: 'Marketplace သို့ သွားရန်',
    learning_center: 'သင်ယူရေး ဗဟို',
    knowledge_center: 'အသိပညာ ဗဟို',
    sharebot: 'ShareBot',
    sharebot_help_message: 'ဒီနေ့ မင်းဘာကူညီပေးရမလဲ?',
    my_organization: 'ကျွန်ုပ်၏ အဖွဲ့အစည်း',
    world_knowledge: 'ကမ္ဘာ့အသိပညာ',
    welcome_to_sharelook: 'Sharelook သို့ ကြိုဆိုပါသည်!',
    sharelook_you_want_go: 'ဒီနေ့ မင်းဘယ်ကို သွားချင်ပါသလဲ?',
    shareLook_learning_management_system:
      'သင်တန်းဖန်တီးခြင်းနှင့် လုပ်ငန်းဆောင်တာများအတွက် ShareLook LMS ကို အသုံးပြုပါ။',
    shareLook_powerful_ai_system:
      'ShareLook ၏ AI စနစ်ဖြင့် PDF များ တင်ပြီး အချက်အလက်များကို လျင်မြန်စွာ ရယူနိုင်ပါသည်။',
    edit_now: 'ယခု ပြင်ဆင်ပါ',
    sharelook_log_out: 'Sharelook မှ ထွက်ပြီးပါပြီ။ ထပ်မံ ဝင်ရောက်ပါ။',
    sorry_error: 'တောင်းပန်ပါတယ်! အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်။',
    login: 'ဝင်ရန်',
    refresh_page: 'စာမျက်နှာ ပြန်လည်တင်ရန်',
    just_a_moment: 'အနည်းငယ် စောင့်ပါ',
    enter_lname_fname: 'နာမည် နှင့် နောက်အမည် ထည့်ပါ',
    procced_to_sharelook: 'Sharelook သို့ ဆက်လက် သွားရန်',
    option_one: 'ရွေးချယ်မှု ၁',
    option_two: 'ရွေးချယ်မှု ၂',
    selected_image: 'ရွေးချယ်ထားသော ပုံ:',
    add_text: 'စာသား ထည့်ရန်',
    linkdin_is_required: 'Linkedin လိုအပ်သည်။',
    bio_is_required: 'ကိုယ်ရေး အကျဉ်း လိုအပ်သည်။',
    save_user_information: 'အသုံးပြုသူ အချက်အလက် သိမ်းဆည်းရန်',
    select_all: 'အားလုံး ရွေးပါ',
    enable_ai: 'AI ကို ဖွင့်ရန်',
    load_more: 'ထပ်ဆောင်း ဖတ်ရန်',
    channel_id: 'ချန်နယ် ID',
    send: 'ပို့မည်',
    v4: 'အချက်အလက်',
    subscription: 'စာရင်းသွင်းခြင်း',
    reset_user_flag: 'အသုံးပြုသူ အမှတ်အသား ပြန်လည် သတ်မှတ်ရန်',
    delete_my_accont: 'ကျွန်ုပ်၏ အကောင့် ဖျက်ရန်',
    sharebot_sub_error: 'စာရင်းသွင်းမှု မရရှိပါ။ ထပ်မံ ကြိုးစားပါ!',
    sharebot_no_sub: 'သင်တွင် လက်ရှိ အက်တိဗ် စာရင်းသွင်းမှု မရှိပါ။',
    sharebot_dont_sub: 'သင်အရင်က စာရင်းသွင်းမှု မရှိပါ။',
    sharebot_prev_sub: 'အရင် စာရင်းသွင်းမှုများ',
    sharebot_sub: 'ShareBot စာရင်းသွင်းမှု',
    sharebot_un_sub: 'ShareBot စာရင်းသွင်းမှု ဖျက်ခြင်း',
    sharebot_no_available: 'ဖော်ပြချက် မရှိပါ',
    sharebot_start_date: 'စတင်သည့် ရက်စွဲ:',
    sharebot_end_date: 'ပြီးဆုံးသည့် ရက်စွဲ:',
    sharebot_sure: 'သေချာပါသလား?',
    sharebot_do_you_want: 'သင် ဆက်လုပ်ချင်ပါသလား',
    unsubscribe: 'စာရင်းမှ ထွက်ရန်',
    unsubscribe_what: 'စာရင်းမှ ထွက်မလား?',
    subscribe: 'စာရင်းသွင်းရန်',
    subscribe_what: 'စာရင်းသွင်းမလား?',
    subscribe_now: 'ယခု စာရင်းသွင်းပါ',
    confirm: 'အတည်ပြုပါ',
    sharebot_intel_knowledge_center: 'ShareBot ၏ ဉာဏ်ရည် အချက်အလက် ဗဟို',
    sharebot_welcome_paragraph:
      'ShareBot ၏ Knowledge Center သည် အဆင့်မြင့် AI စကားပြောစနစ်ဖြစ်ပြီး ပရော်ဖက်ရှင်နယ်များအတွက် အသိပညာ ရယူမှုကို ပြောင်းလဲပေးပါသည်။',
    expired: 'ကန့်သတ် သက်တမ်းကုန်ဆုံး',
    active: 'လက်ရှိအသုံးပြုနေ',
    Inactive: 'မသုံးစွဲနေ',
    yearly_subscription: 'နှစ်စဉ် စာရင်းသွင်းမှု',
    monthly_subscription: 'လစဉ် စာရင်းသွင်းခြင်း',
    no_sharebot_org: 'သင့်တွင် ShareBot အဖွဲ့အစည်းမရှိပါ',
    sharebot_start_free_trial: 'အခမဲ့ စမ်းသပ်ကာလ စတင်ပါ',
    sub_month: 'လစဉ် စာရင်းသွင်းခြင်း',
    sub_year: 'တစ်နှစ်စာ စာရင်းသွင်းခြင်း',
    question_per_month: 'ဒေတာသိမ်းဆည်းမှု (1 တီဘီ) နှင့် အမြဲ ၁၀၀၀ မေးခွန်း',
    sharebot_para:
      'ဆက်လုပ်ခြင်းဖြင့် အဖွဲ့အစည်းကို ချက်ချင်း ဖျက်ပစ်မည်ဖြစ်သည်ကို သင် အတည်ပြုလိုက်ပါသည်။ ဤလုပ်ဆောင်ချက်ကြောင့် ShareBot မှ ပေးသော တန်ဖိုးရှိသော ထောက်လှမ်းချက်များအားလုံး ပျောက်ဆုံးမည်ဖြစ်ပြီး ပြန်လည် ပြောင်းလဲ၍ မရနိုင်ပါ။',
    cancelled_date: 'ဖျက်သိမ်း တာရီချိန်:',
    live_straming_para:
      'လစဉ် live-streaming ကန့်သတ်မှုအား ပြောင်းလဲလိုပါက ကျေးဇူးပြု၍ ဆက်သွယ်ပါ',
    sharelook_agree: 'Sharelook ၏',
    terms_condition: 'စည်းမျဉ်းများနှင့် အချက်အလက်များ',
    and: 'နှင့်',
    privacy_policy: 'ကိုယ်ရေးလုံခြုံရေး မူဝါဒ',
    save_for_later: 'နောက်မှ သိမ်းဆည်းရန်',
    ai: 'အဲအိုအိုင်',
    no_video_yet: 'ဗီဒီယို မရွေးထားသေးပါ!',
    are_you_sure_delete_video: 'ဤဗီဒီယိုကို ဖျက်လိုက်ချင်သည်မှာ မှန်ပါသလား။',
    video_des: 'အကြောင်းအရာ',
    video_now: 'ယခု',
    video_playing: 'ဖွင့်ပြသနေသည်:',
    video_no: 'ဗီဒီယို နံပါတ်',
    ai_generated_course: 'AI များဖြင့် ဖန်တီးထားသော သင်တန်း',
    create_course_on_our_own: 'ကိုယ်တိုင် သင်တန်း တစ်ခု ဖန်တီးပါ',
    ai_Assisted_ourse_reation: 'AI ပံ့ပိုး ကူညီသည့် သင်တန်းဖန်တီးခြင်း',
    pending: 'စောင့်ဆိုင်းနေသည်',
    published: 'ထုတ်ဝေပြီး',
    intro_course: 'သင်တန်းထဲသို့ ထည့်မည်လား?',
    clone_course: 'ကလုန်း ထုတ်ချင်ပါသလား',
    browser_audio_not_support: 'သင့် browser မှ audio တစ်ခုကို မထောက်ပံ့ပါ။',
    audio_popup_content:
      'သင် ရိုက်ထည့်သည့် စာသားပေါ် အများအပြား အသံပုံစံ အသုံးပြုနိုင်သည်—Lorem Ipsum သည် စာနှင့် စက်ပညာအသုံးပြု စက်များတွင် မတူညီသော ပုံစံအဖြစ် ၁၅၀၀ ခုနှစ်မှ စတင် အသုံးပြုလာသော စံသတ်မှတ် Dummy စာသားဖြစ်သည်။',
    close: 'ပိတ်မည်',
    podcast_rec: 'REC',
    create_podcast: 'Podcast ဖန်တီးမည်',
    add_admin: 'အဒ်မင် ထည့်မည်',
    delete_all: 'အားလုံး ဖျက်မည်',
    ai_podcast_audio: 'AI Podcast အသံ',
    language: 'ဘာသာစကား',
    podcast_download_content:
      '*AI မှဘာသာပြန်ထားသော အသံဖိုင်ကို ဒေါင်းလုပ်ဆွဲ၍ ကိုယ်ပိုင် အယ်ဒီတာတွင် တည်းဖြတ်နိုင်ပါသည်။',
    upload_audio: 'အသံ ဖိုင်တင်မည်',
    browser_do_not_support_audio:
      'သင်၏ browser သည် audio အစိတ်အပိုင်းကို မထောက်ပံ့ပါ။',
    upload_cover: 'ဖန်တီးပြီး ကာဗာတင်မည်',
    upload_ai_creator: 'AI ဖန်တီးသူ ထည့်မည်',
    required_cover_image: 'ကာဗာပုံ လိုအပ်ပါသည်!',
    room_required_name: 'Podcast အမည် လိုအပ်ပါသည်!',
    add_guest_list: 'ကျေးဇူးပြု၍ ဧည့်သည်များ ထည့်ပါ!',
    podcast_add_participants: 'ပါဝင်သူ ထည့်မည်',
    topic_required: 'ကိစ္စ တစ်ခုထက်ပို လိုအပ်ပါသည်',
    podcast_description: 'ဖော်ပြချက်',
    podcast_date: 'နေ့စွဲ',
    date: 'နေ့စွဲ',
    podcast_time: 'အချိန်',
    podcast_to: 'မှ',
    podcast_all_day: 'တစ်နေ့လုံး',
    podcast_start_date_time:
      'စတင်မည့် နေ့စွဲနှင့် အချိန် အပိုင်းများ လိုအပ်ပါသည်!',
    podcast_id: 'ID',
    selected_user: 'ရွေးချယ်ထားသော အသုံးပြုသူများ ဖိတ်ကြားမည်',
    see_more: 'ပိုမိုကြည့်ရန်',
    see_less: 'အနည္းငယ်သာ ကြည့်ရန်',
    no_review_yet: 'သုံးသပ်ချက် မရှိသေးပါ၊ သုံးသပ်သူ ပထမနှစ်ဦး ဖြစ်လိုက်ပါ။',
    request_to_speak: 'အသုံးပြုသူ၏ ပြောခွင့် တောင်းဆိုမှု ခွင့်ပြုမည်နားလား?',
    kick_user: 'ဤအသုံးပြုသူကို ဖယ်ရှားချင်ပါသလား?',
    accept_request: 'တောင်းဆိုမှု လက်ခံမည်',
    kick: 'ဖယ်ရှားမည်',
    started: 'စတင်ပြီး',
    end: 'ပြီးဆုံး',
    join_now: 'ယခု ပေါင်းပါ',
    podcast_end: 'Podcast က နုတ်ဆုံးခဲ့သည်',
    connecting: 'ချိတ်ဆက်နေသည်...',
    knowledge_center_know_today: 'တစ်နေ့တာ ဘာတွေ သိချင်ပါသလဲ?',
    knowledge_center_question: 'ကျေးဇူးပြု၍ မေးခွန်း တစ်ခု ရိုက်ထည့်ပါ',
    knowledge_center_error: 'တောင်းပန်ပါတယ်! အမှားတစ်ခု ဖြစ်ပျက်နေပါသည်။',
    knowledge_center_tooltrip:
      'သင်၏ အဖွဲ့အစည်း၏ ShareLook စုဆောင်းထားသည့် သင်ယူမှုအရင်းအမြစ်မှ ချက်ချင်းဖြေခွင့် နှင့် PDF စာရွက်များကို ကြည့်ရှု ဒေါင်းလုပ်ဆွဲနိုင်ပါသည်။',
    my_organization: 'ကျွန်ုပ်၏ အဖွဲ့အစည်း',
    world_knowledge: 'ကမ္ဘာ့ အသိပညာ',
    open_file: 'ဖိုင် ဖွင့်မည်',
    reference: 'ရည်ညွှန်းချက်',
    are_you_cancel: 'မဖြစ်မနေ ဖျက်ရန် သေချာကြောင်း မေးပါလား?',
    are_you_remove_media: 'မီဒီယာ ဖယ်ရှားချင်တာ သေချာပါသလား?',
    terms_agree: 'ဤ စည်းမျဉ်းများနှင့် သဘောတူပါသည်',
    ready: 'ပြင်ဆင်ပြီးသား',
    send_email: 'အီးမေး ပို့မည်',
    active_users: 'လှုပ်ရှားနေသော အသုံးပြုသူများ',
    sign_up_user: 'မှတ်ပုံတင်ထားသော အသုံးပြုသူများ',
    non_sign_up_user: 'မှတ်ပုံမတင်သေးသော အသုံးပြုသူများ',
    organisation: 'အဖွဲ့အစည်း',
    usage_report: 'အသုံးပြုခြင်း အစီရင်ခံစာ',
    check_email: 'အီးမေးလ် စစ်ဆေးပါ',
    delete_schedule: 'ဇယား ဖျက်မည်',
    are_you_sure_delete_schedule: 'ဤ ဇယားကို ဖျက်ရန် သေချာပါသလား?',
    add_task: 'အတိတ်လက်တွင် တာဝန် တစ်ခု ထည့်ပါ!',
    coaching_available: 'မောင်းကြားမှု ရရှိနိုင်သည်ဟု အမှတ်မည်ထားပါသည်',
    message_booking_coaching:
      'ဤ အချိန် အပိုင်း သည် လူကြီးမင်းတစ်ဦးက Coaching အတွက် စာရင်းပေးထားပါသည်။',
    task_day: 'တာဝန်နေ့',
    created_task_day: 'ဤနေ့တွင် တာဝန်တစ်ခု ဖန်တီးပြီးပါပြီ။',
    event_day: 'ပွဲနေ့',
    has_booked_coaching: 'ဤနေ့တွင် Coaching တစ်ခု စာရင်းသွင်းပြီးပါပြီ။',
    active_day: 'လှုပ်ရှားနေသော နေ့လေး',
    selectable_time_slots:
      'ညာဘက်တွင် ရွေးချယ်နိုင်သော အချိန် အပိုင်းများ သက်ဆိုင်ရာနေ့တွင် အသုံးပြုနိုင်ပါသည်။',
    compare_last_month: 'ယခင်လနှင့် နှိုင်းယှဥ်မည်',
    uploading_file: 'သင့် ဖိုင် တင်နေပါသည်',
    attach_file_course: 'သင်တန်းနှင့် ချိတ်ဆက်ပြီး',
    fetch_request: 'သင့် တောင်းဆိုမှုယူနေသည်',
    finilize_upload: 'တင်သွင်းမှု နီးပါးပြီး',
    scorm_scanned:
      'ကျေးဇူးပြု၍ စောင့်ပါ... သင့် တင်သော SCORM zip ဖိုင် စစ်ဆေးနေပါသည်။',
    scan_status: 'စစ်ဆေးမှု အခြေအနေ:',
    scan_completed: 'စစ်ဆေးခြင်း ပြီးမြောက်ပါပြီ။ ဖိုင် သည်',
    scan_progress: 'စစ်ဆေးခြင်း ဆက်လက်ဆောင်ရွက်နေပါသည်...',
    check_scorm:
      'သင့် SCORM ဖိုင် ဖော်မတ် စစ်ဆေးနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...',
    file_check_success: 'ဖိုင် စစ်ဆေးမှုအောင်မြင်ပါသည်',
    file_check_progress: 'ဖိုင် စစ်ဆေးမှု ဆက်ပြီး',
    scorm_not_upload:
      'သင်တင်သွင်းသော ဖိုင်သည် SCORM 1.2 စံမီ မဟုတ်ပါ၊ ထပ်မံ တင်ပေးပါ။',
    select_question: 'အဖြေရွေးစရာများ (တစ်ခုသာ မှန်ကန်သည်)',
    select_answer: 'ကျေးဇူးပြု၍ အဖြေရွေးစရာ ကိုရွေးပါ!',
    check_option_one: 'လိုအပ်ပါက ရွေးစရာ တစ်ခု ရိုက်ထည့်ပါ!',
    check_option_two: 'ရွေးစရာ နှစ် ခု ရိုက်ထည့်ပါ!',
    check_option_three: 'ရွေးစရာ သုံး ခု ရိုက်ထည့်ပါ!',
    check_option_four: 'ရွေးစရာ လေး ခု ရိုက်ထည့်ပါ!',
    question_image: 'မေးချ်၏ ပုံ',
    select_question_image: 'မေးရှင်း ပုံရွေးပါ!',
    ans_image: 'အဖြေ ပုံ',
    upload_image_question: 'မေးရှင်း ပုံ တင်ပါ',
    select_image_answer: 'အဖြေ ပုံ ရွေးပါ!',
    save_question: 'မေးခွန်း သိမ်းဆည်းမည်',
    do_you_leave: 'ထွက်လိုသလား? သေချာပါသလား?',
    loose_all_progress: 'သင်၏ တိုးတက်မှုအားလုံး ပျောက်ဆုံးနိုင်ပါသည်။',
    welcome: 'ကြိုဆိုပါတယ်',
    team_knowledge_quest: 'အဖွဲ့ ပညာ ခရီးစဉ်',
    your_score: 'သင့် အမှတ်',
    start_playing: 'ကစား စတင်ပါ',
    share_sphere_complete: 'ShareSphere ပြီးစီးပြီး',
    final_score: 'နောက်ဆုံး အမှတ်',
    play_next: 'နောက်တစ်ခု ကစားမည်',
    you_donot_access_event: 'ဤ ကြိုဆိုမည့် ပွဲထဲသို့ မဝင်နိုင်ပါ',
    ai_content_generated: 'ဤ အကြောင်းအရာအတွက် ကြောင်း ကုန်ကပ် ထုတ်လုပ်ပြီး',
    ai_popup_confirm_content: 'ဖန်တီးမည့် အကြောင်းအရာ အတည်ပြုပါ',
    limit_transcribe_text:
      'ကျန်ရှိသော အသံပြန်လည်ရေးမိနစ်များ: <0>{{ transcribe_limit }}</0> မိနစ် <1/><2/> <3>။ သင်၏ အသံပြန်လည်ရေး ကန့်သတ်ချက်ကို ပြောင်းလဲရန် ကျေးဇူးပြု၍ ဆက်သွယ်ပါ </3> <4>admin@sharelook.com</4>။',
    you_donot_access_event: 'ဤ အစည်းအဝေးသို့ မဝင်ခွင့်ရှိပါ။',
    ai_course_title_training: 'ခေါင်းဆောင်မှု လေ့ကျင့်ရေး သင်တန်းများ',
    ai_course_object: 'ဒစ်ဂျစ်တယ်ခေါင်းဆောင်မှု လမ်းညွှန်ခြင်း',
    create_ai_video: 'AI ဗီဒီယို ဖန်တီးပါ',
    generate: 'ထုတ်လုပ်ပါ',
    video_generate_process:
      'ဗီဒီယို ဖန်တီးမှု လုပ်ငန်းစဉ်မှာ အချိန်ယူနိုင်ပါသည်။ ပြီးစီးပါက အီးမေးလ်ဖြင့် အသိပေးပါမည်။',
    stripe_account_connect:
      'သင်၏ Stripe အကောင့်သည် အလုပ်မလုပ်ပါ။ ဆက်လက်အသုံးပြုရန် ချိတ်ဆက်ရန် သို့မဟုတ် ဖွင့်လှစ်ရန် လိုအပ်ပါသည်။',
    ai_creator: 'AI ဖန်တီးသူ',
    check_video_status: 'ဗီဒီယို ဖန်တီးမှု အခြေအနေ စစ်ဆေးနေသည်...',
    video_on_queue: 'ဗီဒီယို ဖန်တီးမှု စဉ်ဆက်မပြတ် ဖြစ်နေပါသည်။',
    video_fail_generation:
      'တောင်းပန်ပါသည်၊ ဗီဒီယို ဖန်တီးမှု မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။',
    video_currently_generated: 'ဤဗီဒီယိုကို လက်ရှိ ဖန်တီးနေဆဲ ဖြစ်သည်။',
    checking_status: 'အခြေအနေ စစ်ဆေးနေသည်',
    check_status: 'အခြေအနေ စစ်ဆေးပါ',
    browser_does_not_support_audio:
      'သင်၏ဘရောက်ဇာသည် အသံအတွက် tag ကို မထောက်ပံ့ပါ',
    existing_edit_scenario:
      'ရှိပြီးသား အခြေအနေကို ပြင်ဆင်မလား၊ အသစ်တစ်ခု ဖန်တီးမလား? အသစ် ဖန်တီးပါက ယခင် အခြေအနေ ပျောက်ဆုံးသွားမည် ဖြစ်သည်။',
    generate_scenario: 'အခြေအနေ ဖန်တီးပါ',
    layout: 'အစီအစဉ်',
    confirm_change: 'ပြောင်းလဲမှုကို အတည်ပြုပါ',
    generated_ai_creation_message:
      'AI ဖန်တီးမှုမှ စာသားအချက်အလက်များသာ သိမ်းဆည်းထားမည်ဖြစ်ပြီး အခြားအရာများအားလုံးကို စာမျက်နှာမှ ဖယ်ရှားမည် ဖြစ်ပါသည်။',
    generate_story: 'ဇာတ်ကြောင်း ဖန်တီးပါ',
    save_original_content: 'မူရင်း အကြောင်းအရာ သိမ်းဆည်းပါ:',
    story_added_specified_position:
      'သင်တန်းအတွင်း ဇာတ်ကြောင်းတည်နေရာ။ ဇာတ်ကြောင်းကို သတ်မှတ်ထားသောနေရာတွင် ပုံစံအဖြစ် ထည့်သွင်းမည်။',
    position_of_story: 'ဇာတ်ကြောင်း၏ တည်နေရာ',
    start_the_lesson: 'သင်ခန်းစာ စတင်ခြင်း',
    end_the_lesson: 'သင်ခန်းစာ ပြီးဆုံးခြင်း',
    add_story_pages: 'ဇာတ်ကြောင်းကို စာမျက်နှာများတွင် ထည့်ပါ',
    browser_does_not_support: 'သင်၏ဘရောက်ဇာသည် အသံ အရာဝတ္ထုကို မထောက်ပံ့ပါ။',
    no_video_available: 'ဗီဒီယို မရရှိနိုင်ပါ။',
    no_podcast_available: 'ပိုဒ်ကတ် မရရှိနိုင်ပါ။',
    no_item_baskets: 'ထုတ်ပိုးတွင် အရာဝတ္ထု မရှိပါ။',
    ai_course_object: 'ဒစ်ဂျစ်တယ်ခေါင်းဆောင်မှု လမ်းညွှန်ခြင်း'
  },
  v2: {
    n_data: 'ဒေတာမရှိပါ',
    change: 'ပြောင်းလဲရန်',
    remove: 'ဖယ်ရှားရန်',
    auto_background: 'အလိုအလျောက်နောက်ခံ',
    create_new_course_org: 'သင်၏အဖွဲ့အစည်းအတွက် သစ်တစ်ခုသောသင်တန်းဖန်တီးပါ။',
    create_new_course_marketplace:
      'Marketplace အတွက် သစ်တစ်ခုသောသင်တန်းဖန်တီးပါ။',
    create_new_course_both:
      'အဖွဲ့အစည်းနှင့် Marketplace နှစ်ခုစလုံးအတွက် သင်တန်းသစ်ဖန်တီးပါ။',
    ok: 'အိုကေ',
    page_bg: 'စာမျက်နှာနောက်ခံ',
    lesson_cover: 'သင်ခန်းစာ အဖုံးပုံ',
    create_skill_journey: 'ကျွမ်းကျင်မှုခရီးစဉ် ဖန်တီးပါ',
    Metamaze: 'Metamaze',
    events: 'ပွဲများ',
    scroms: 'SCORMs',
    min_score_pass: 'အောင်မြင်ရန် အနိမ့်ဆုံးအမှတ်',
    no_scorms_available: 'SCORM မရှိပါ။',
    no_events_available: 'ပွဲမရှိပါ။',
    no_courses_available: 'သင်တန်းမရှိပါ။',
    no_courses_baskets: 'ခြင်းတွင် သင်တန်းမရှိပါ။',
    no_mazes_baskets: 'ခြင်းတွင် မေ့စ်များမရှိပါ။',
    no_scroms_baskets: 'ခြင်းတွင် SCORM မရှိပါ။',
    no_events_baskets: 'ခြင်းတွင် ပွဲများမရှိပါ။',
    sorry: 'စိတ်မသန်ပါ!',
    option_1: 'ရွေးချယ်မှု ၁',
    option_2: 'ရွေးချယ်မှု ၂',
    enter_number_words: 'အများဆုံး စာလုံးအရေအတွက်ထည့်ပါ။',
    summarize: 'အကျဉ်းချုပ်ပြပါ',
    answer: 'အဖြေ',
    hold_tight_one_minute:
      'တစ်ခဏစောင့်ပါ။ ပြင်ဆင်နေဆဲဖြစ်သည်။ တစ်မိနစ်အထိကြာနိုင်သည်။',
    enter_question: 'မေးခွန်းထည့်ပါ။',
    enter_relevant_documents: 'သက်ဆိုင်ရာစာရွက်စာတမ်းအရေအတွက်ထည့်ပါ။',
    please_input_relevant_documents: 'သက်ဆိုင်ရာစာရွက်စာတမ်းအရေအတွက်ထည့်ပါ!',
    please_wait_loading_results:
      'ရလဒ်များကို Loading ပြုလုပ်နေသည်၊ ခဏစောင့်ပါ...',
    proceed_to_add_voice: 'အသံထည့်ရန် ဆက်လက်လုပ်ဆောင်ပါ',
    results: 'ရလဒ်များ',
    no_result_found_try_asking_questions:
      'ရလဒ်မရှိပါ။ မေးခွန်းအများကြီး မေးကြည့်ပါ။',
    eg: 'ဥပမာ၊',
    what_make_sales_manager:
      'ဘယ်အရာတွေက မိမိကို ရောင်းအားမန်နေဂျာဖြစ်အောင်လုပ်နိုင်သလဲ?',
    please_select_lang: 'ကျေးဇူးပြု၍ ဘာသာစကားတစ်ခုရွေးပါ!',
    search: 'ရှာဖွေရန်',
    please_copy_desired_content:
      'ဘယ်ဘက် box မှ ညာဘက် box သို့လိုသည့်အကြောင်းအရာကို ကူးပါ။',
    rating_req: 'အဆင့်သတ်မှတ်မှုလိုအပ်ပါသည်။',
    review_req: 'ပြန်လည်သုံးသပ်ချက် လိုအပ်ပါသည်။',
    rating_review_req:
      'အဆင့်သတ်မှတ်မှုနှင့် ပြန်လည်သုံးသပ်ချက်နှစ်ခုစလုံးပေးရန် လိုအပ်ပါသည်။',
    how_rate_this: 'ဤအရာကို သင်ဘယ်လိုအဆင့်သတ်မှတ်မလဲ?',
    amazing_above_expectations: 'အံ့ဩစရာကောင်းတယ်! မျှော်လင့်ချက်ထက်ကောင်းတယ်!',
    certificates: 'လက်မှတ်များ',
    you_no_certificates: 'လက်ရှိတွင် သင်ဆိုင်ရာ လက်မှတ်များမရှိပါ။',
    please_add_review:
      'အဆင့်သတ်မှတ်မှုနှင့်အတူ ပြန်လည်သုံးသပ်ချက်တင်ပြပါ။ ကျေးဇူးတင်ပါသည်။',
    post: 'တင်ပြပါ',
    rate: 'အဆင့်သတ်မှတ်ပါ',
    avg_rating: 'ပျမ်းမျှအဆင့်',
    no_review_found: 'ပြန်လည်သုံးသပ်ချက် မတွေ့ပါ',
    are_sure_to_disale_zoom_integration:
      'Zoom ပေါင်းစည်းမှုကိုပိတ်လိုသည်မှာ သေချာပါသလား?',
    badges: 'ဘတ်ဂျ်များ',
    you_no_badge_available: 'လက်ရှိတွင် ဘတ်ဂျ် မရှိပါ။',
    download_certificate: 'လက်မှတ်ဒေါင်းလုဒ်လုပ်ပါ',
    loading: 'ဖတ်ဆဲ...',
    no_file_attached: 'ဖိုင် မတွဲထားပါ',
    you_do_not_have_any_notes: 'သင်တွင် မှတ်စုမရှိပါ။',
    question: 'မေးခွန်း',
    score: 'အမှတ်',
    alert_score_message: 'အမှတ်များ တင်ပြပြီးပါပြီ။',
    alert_question_message: 'လတ်တလောတွင် မေးခွန်းများ မထည့်ရသေးပါ။',
    button_submit: 'တင်ပြပါ',
    button_allScores: 'အမှတ်အားလုံး တင်ပြပြီးပါပြီ။',
    record_wait: 'မှတ်တမ်းတင်ခြင်းစတင်နေပါပြီ။ ခဏစောင့်ပါ...',
    buttonSubmit_warning: 'တင်ပြရန်မတိုင်မီ အမှတ်အားလုံး ထည့်သွင်းပါ။',
    upload_ar_assets: 'AR အက်ဆက်များတင်ရန်',
    edit_ar_assets: 'AR အက်ဆက်များတည်းဖြတ်ရန်',
    edit_maze_assets: 'MetaMaze အက်ဆက်များတည်းဖြတ်ရန်',
    upload_assets: 'အက်ဆက်များတင်ရန်',
    upload_maze_assets: 'MetaMaze အက်ဆက်များတင်ရန်',
    trigger_title: 'Trigger ခေါင်းစဉ်',
    model_title: 'မော်ဒယ် ခေါင်းစဉ်',
    trigger_description: 'Trigger ဖော်ပြချက်',
    model_description: 'မော်ဒယ် ဖော်ပြချက်',
    please_type_target_description: 'အရာအတည်ဖော်ပြချက် ရိုက်ထည့်ပါ။',
    please_type_model_description: 'မော်ဒယ်ဖော်ပြချက် ရိုက်ထည့်ပါ။',
    trigger_image: 'Trigger ပုံ*',
    model_image: 'မော်ဒယ် ပုံ*',
    upload_trigger_image: 'Trigger ပုံတင်ပါ',
    upload_model_image: 'မော်ဒယ် ပုံတင်ပါ',
    drag_n_drop: 'ဆွဲချပြီး မျှချရန်',
    file_size_should_not_exceed:
      '(ပုံဖိုင် (JPEG) အရွယ်အစားသည် 512 KB ကျော်မသင့်ပါ။)',
    zip_size_should_not_exceed: '(Zip ဖိုင် အရွယ်အစား 60 MB ကျော်မသင့်ပါ။)',
    ar_content: 'AR မာတိကာ*',
    model_content: '3D မော်ဒယ်*',
    upload_3d_zip: 'ZIP / ဗီဒီယို တင်ပါ',
    upload_3d_maze_zip: 'ZIP တင်ပါ',
    audio_content: 'အသံ မာတိကာ',
    _mp3: '(.mp3)',
    content_attached: 'Zip တစ်ခုတွဲထားပါသည်။',
    video_attached: 'ဗီဒီယို တစ်ခုတွဲထားပါသည်။',
    audio_attached: 'အသံ တစ်ခုတွဲထားပါသည်။',
    enter_trigger_image_title: 'Trigger ပုံခေါင်းစဉ် ရိုက်ထည့်ပါ။',
    enter_model_title: 'MetaMaze မော်ဒယ်ခေါင်းစဉ် ရိုက်ထည့်ပါ။',
    ar_preview_image: 'AR မျှော်ကြည့်ပုံ',
    upload_preview_image: 'မျှော်ကြည့်ပုံ တင်ပါ',
    upload_audio: 'အသံတင်ပါ',
    creating___: 'ဖန်တီးနေသည်...',
    updating___: 'အသစ်ပြင်နေသည်...',
    create: 'ဖန်တီးမည်',
    update: 'ပြင်ဆင်မည်',
    ar_assets: '3D ပုံ',
    _3d_files_mp4: '(Zipped .obj, .fbx သို့မဟုတ် .mp4 ဗီဒီယို)',
    _3d_files_mp4_ar: '(Zipped .obj, .fbx)',
    maze_3d_files_mp4: '(Zipped .obj, .fbx)',
    _jpg_files: '.jpg ပုံများသာထောက်ခံသည်',
    persons_have_submitted_their_scores:
      'လူများသည် မိမိတို့၏အမှတ်များတင်ပြပြီးပါပြီ။',
    no_questions_added_till_now: 'မေးခွန်းများကို ယခုအချိန်ထိ မထည့်ရသေးပါ။',
    submit: 'တင်သွင်းမည်',
    all_scores_submitted: 'အမှတ်အားလုံး တင်ပြီးပါပြီ။',
    recording_is_starting: 'မှတ်တမ်းတင်ခြင်း စတင်နေပါသည်။ ခဏစောင့်ပါ...',
    please_input_scores_before_submitting:
      'တင်သွင်းရန်မတိုင်မီ အမှတ်အားလုံး ထည့်ပါ။',
    end_for_all: 'အားလုံးအတွက်အဆုံးသတ်မည်',
    full_screen: 'အပြည့်မျက်နှာပြင်',
    breakout_room: 'ခွဲထွက်ခန်း',
    send_invitations: 'ဖိတ်ကြားစာ(များ)ပေးပို့ပါ',
    add_participants: 'တက်ရောက်သူ(များ) ထည့်ပါ',
    create_breakout_room: 'ခွဲထွက်ခန်း ဖန်တီးပါ',
    connecting: 'ချိတ်ဆက်နေသည်...',
    currently_broadcaster_unavailable: 'လက်ရှိတွင် ထုတ်လွှင့်သူ မရနိုင်ပါ။',
    how_many_breakout_room_to_create: 'ခွဲထွက်ခန်းဘယ်နှခန်း ဖန်တီးချင်ပါသလဲ?',
    create_upto_three_breakout_rooms:
      '*အများဆုံး ခွဲထွက်ခန်း ၃ ခန်း ဖန်တီးနိုင်သည်',
    allow: 'ခွင့်ပြုပါ',
    additional: 'အပို',
    attachment: 'ဖိုင်တွဲပါ',
    no_description_available: 'ဖော်ပြချက် မရှိပါ။',
    people: 'လူများ',
    waiting: 'စောင့်နေသည်',
    hand_raising_users: 'လက်မြှောက်ထားသော အသုံးပြုသူများ',
    invite: 'ဖိတ်ကြားမည်',
    create_room: 'ခန်းဖန်တီးမည်',
    create_live_event: 'Live Event ဖန်တီးမည်',
    support_upto_fivethousand_participants: 'အများဆုံး 5,000 ဦးပါဝင်နိုင်သည်',
    support_upto_ten_participants: 'Live video တက်ရောက်သူ 10 ဦးအထိ ပံ့ပိုးသည်',
    support_upto_twohundred_participants:
      'Event တစ်ခုအတွက် 200 ဦးအထိ ပါဝင်နိုင်သည်',
    supprt_upto_five_participants: 'Live video တက်ရောက်သူ 5 ဦးအထိ ပံ့ပိုးသည်',
    support_upto_twentyfive_participants:
      'Event တစ်ခုအတွက် 25 ဦးအထိ live video ပါဝင်နိုင်သည်',
    two_live_video_participants:
      'Live video တက်ရောက်သူ ၂ ဦး (host နှင့် attendee) ရှိသည်',
    you_can_have_upto_five_examinees: 'အများဆုံး စစ်ဆေးသူ ၅ ဦး ရှိနိုင်သည်။',
    you_can_have_upto_twentyfive_participants:
      'အများဆုံး တက်ရောက်သူ ၂၅ ဦး ရှိနိုင်သည်။',
    you_can_have_upto_five_participants:
      'အများဆုံး တက်ရောက်သူ ၅ ဦး ရှိနိုင်သည်။',
    you_can_have_upto_ten_participants:
      'အများဆုံး တက်ရောက်သူ ၁၀ ဦး ရှိနိုင်သည်။',
    select_hosts_email: 'Host Email ရွေးချယ်ပါ',
    send_invite_email: 'ဖိတ်ကြားစာ ပေးပို့ပါ',
    do_not_send_invite_email: 'ဖိတ်ကြားစာ မပေးပို့ပါနဲ့',
    error: 'အမှား',
    max_twentyfive_users_allowed: 'အသုံးပြုသူ ၂၅ ဦးအထိသာ ရွေးနိုင်သည်',
    max_five_users_allowed: 'အသုံးပြုသူ ၅ ဦးအထိသာ ရွေးနိုင်သည်',
    max_ten_users_allowed: 'အသုံးပြုသူ ၁၀ ဦးအထိသာ ရွေးနိုင်သည်',
    no_user_found: 'အသုံးပြုသူ မတွေ့ပါ',
    transcribe_to: 'ဘာသာပြန်ရန်',
    integrate_zoom_to_start_meeting:
      'Zoom တွင် ချိတ်ဆက်ပြီး Zoom အစည်းအဝေးစတင်ပါ။',
    zoom_is_not_integrated: 'Zoom မချိတ်ဆက်ရသေးပါ။',
    delete_poll: 'မဲဖျက်ရန်',
    add_poll: 'မဲထည့်ရန်',
    live_now: 'LIVE!',
    average_rating: 'ပျမ်းမျှအဆင့်သတ်မှတ်ချက်',
    review: 'သုံးသပ်ချက်',
    time_spent: 'အသုံးချချိန်',
    total: 'စုစုပေါင်း',
    mins: 'မိနစ်များ',
    no_data: 'ဤကွစ်အတွက် ဒေတာ မရှိပါ။',
    total_score: 'စုစုပေါင်းအမှတ်',
    pass_score: 'အောင်မြင်အမှတ်',
    point: 'အမှတ်',
    wrong: 'မှား',
    response: 'တုံ့ပြန်ချက်',
    submitted: 'တင်သွင်းပြီး',
    average: 'ပျမ်းမျှ',
    total_play: 'စုစုပေါင်းကစားမှု',
    view_graph: 'ဇယားကြည့်ရန်',
    time_spent_mins: 'အသုံးချချိန် (မိနစ်)',
    play: 'ကစားမည်',
    ideal_path: 'အကောင်းဆုံးလမ်းကြောင်း',
    user_incorrect_path: 'အသုံးပြုသူမှမှားသောလမ်းကြောင်း',
    ideal_path_taken: 'အသုံးပြုသူက အသုံးပြုသည့် အကောင်းဆုံးလမ်းကြောင်း',
    scenario: 'အခြေအနေ',
    option: 'ရွေးချယ်စရာ',
    spend: 'အသုံးချရန်',
    average_spending_time: 'ပျမ်းမျှအသုံးချချိန်',
    activity_overview: 'လှုပ်ရှားမှုအနှစ်ချုပ်',
    live_event: 'Live Event',
    live_assessment: 'Live စစ်ဆေးမှု',
    report_download: 'အစီရင်ခံစာဒေါင်းလုပ်',
    all_workshops: 'Workshop အားလုံး',
    overview_average_activity: 'ပျမ်းမျှလှုပ်ရှားမှုအနှစ်ချုပ်',
    overview_workshop_graph: 'Workshop ဇယားအနှစ်ချုပ်',
    mazes: 'Maze များ',
    correct_feedback: 'မှန်ကန်သော တုံ့ပြန်ချက်',
    incorrect_feedback: 'မှားသော တုံ့ပြန်ချက်',
    checkin_checkout: 'Check-In - Checkout',
    minutes: 'မိနစ်များ',
    incorrect_path: 'မှားသောလမ်းကြောင်း',
    answer_not_available: 'အဖြေ မရှိပါ',
    views: 'ကြည့်ရှုမှု',
    item: 'အရာဝတ္ထု',
    questions: 'မေးခွန်းများ',
    total_points: 'စုစုပေါင်းအမှတ်များ',
    total_attempts: 'စုစုပေါင်းကြိုးစားမှု',
    created_date: 'ဖန်တီးသည့်ရက်စွဲ',
    host_name: 'Host နာမည်',
    host_section: 'Host အပိုင်း',
    choose_products: 'ထုတ်ကုန်များ ရွေးပါ',
    add_to_basket: 'ခြင်းထဲထည့်မည်',
    basket: 'ခြင်း',
    times: 'အကြိမ်',
    scorms: 'SCORMs',
    skill_journey_overview: 'ကျွမ်းကျင်မှုခရီးစဉ်အနှစ်ချုပ်',
    how_to_use: 'အသုံးပြုနည်း',
    live_broadcast_description:
      'လွယ်ကူစွာအသုံးပြုနိုင်သော သင်ခန်းစာဖန်တီးသူတွင် LIVE VIDEO ပေါင်းစည်းထားပါသည်။',
    live_broadcast_subdescription:
      'ShareLook ၏ ပိုင်နက်ဖြစ်သည့် live broadcast စနစ်ဖြင့် သင် စိတ်ဝင်စားမှုဖန်တီးနိုင်ပြီး သင်ကြားမှုများကို အလိုအလျောက်လုပ်ဆောင်ပြီး အသိပညာမျှဝေမှုကို အများဆုံးဖြစ်စေနိုင်ပါသည်။',
    disclaimer: `ကျွန်ုပ်၏ ကျွမ်းကျင်မှုခရီးစဉ်သည် မျှော်မှန်းချက်များကို မကျော်လွန်ကြောင်း အာမခံပါသည် - 
- တတိယပါတီ၏အခွင့်အရေးများ မဖောက်ဖျက်ပါ
- ဥပဒေဖောက်ဖျက်မှုဖြစ်သောအရာများ (ပြောဆိုဖော်ပြချက်, အရွက်ပြောင်မှု, ဗျာမှန်မှု, အကြမ်းဖက်မှု၊ လူမဆန်မှုအပြင်အဆင်များကိုအပါအဝင်) ပါဝင်မည်မဟုတ်ပါ
- တခြားသူများအပေါ်ကိုယ်ရေးကိုယ်တာတိုက်ခိုက်မှုများ မပါဝင်ပါ
- တခြားသူများကို တမင်အတုယူခြင်း မပါဝင်ပါ
- တစ်ဦးဦး၏ကိုယ်ရေးအချက်အလက်ကို ခွင့်ပြုချက်မရှိဘဲ မှတ်တမ်းတင်ခြင်း မပါဝင်ပါ
- ရောင်းချမှုအမျိုးမျိုး သို့မဟုတ် spam မပါဝင်ပါ`,
    price: 'စျေးနှုန်း',
    video_link: 'ဗီဒီယိုလင့်ခ်',
    category: 'အမျိုးအစား',
    objectives: 'ရည်ရွယ်ချက်များ',
    marketplace_description: 'Marketplace ဖော်ပြချက်',
    live_discussion: 'LIVE ဆွေးနွေးမှု',
    poll: 'မဲ',
    hide_grid: 'ဇယားဖျောက်ပါ',
    show_grid: 'ဇယားပြပါ',
    stop_screen_share: 'မျက်နှာပြင်မျှဝေမှုရပ်မည်',
    screen_share: 'မျက်နှာပြင်မျှဝေမည်',
    mute: 'အသံပိတ်ပါ',
    unmute: 'အသံဖွင့်ပါ',
    raise_hand: 'လက်မြှောက်ရန်',
    waiting__: 'စောင့်နေသည်...',
    audio_active: 'အသံ ဖွင့်ထားသည်'
  },
  general: {
    save: 'သိမ်းဆည်းပါ',
    autosaved: 'အလိုအလျောက် သိမ်းဆည်းပါ',
    back_to: 'နောက်သို့',
    by: 'အားဖြင့်',
    chat: 'စကားစမြည် ပြောသည်',
    completed: 'ပြီးစီးခဲ့သည်',
    canceled: 'ဖျက်သိမ်းသည်',
    component: 'အစိတ်အပိုင်း',
    confirm: 'အတည်ပြုသည်',
    course: 'သင်တန်း',
    skill: 'ကျွမ်းကျင်မှု ခရီး',
    maze: 'မက်တာမေ့ဇ်',
    channel: 'ချန်နယ်',
    podcast: 'podcast',
    date: 'နေ့စွဲ',
    details: 'အသေးစိတ်',
    empty: 'ဗလာ',
    enrolled: 'စာရင်းသွင်းပြီး',
    free: 'အခမဲ့',
    graph: 'ဂရပ်/သရုပ်ပြဇယား',
    loading: 'ဒေတာရွှေ့ပြောင်းနေသည်...',
    lesson: 'သင်ခန်းစာ',
    lessons: 'သင်ခန်းစာများ',
    live_assessment: 'တိုက်ရိုက် ကြည့်ရှု အကဲဖြတ် သုံးသတ်ချက်',
    live_event: 'တိုက်ရိုက်ထုတ်လွှင့် အစီအစဉ်',
    no: 'မဟုတ်ဘူး',
    of: '၏',
    or: 'သို့မဟုတ်',
    organization: 'အဖွဲ့အစည်း',
    page: 'စာမျက်နှာ',
    pages: 'စာမျက်နှာများ',
    personal: 'ကိုယ်ရေးကိုယ်တာ',
    poll: 'မဲ စစ်တမ်းကောက်ယူခြင်း',
    rating: 'အဆင့်သတ်မှတ်ချက်',
    reset: 'အစမှပြန်စသည်',
    signin: 'မှတ်ပုံတင် ဝင်ရောက်ပါ',
    signup: 'စာရင်းသွင်းပါ',
    soon: 'မကြာမီ',
    type: 'အမျိုးအစား',
    uploading: 'ဒေတာ အင်တာနက်ပေါ် တင်နေခြင်း...',
    yes: 'ဟုတ်တယ်',
    something_went_wrong: 'တစ်စုံတစ်ခု မှားယွင်းနေပါသည်!',
    view_all: 'အားလုံးကို ကြည့်ပါ',
    upload_successful: 'အင်တာနက်ပေါ် ဒေတာတင်မှု အောင်မြင်ပါသည်',
    upload_successful_message:
      'သင့် အိပ်ဆဲလ်စာရွက်စာတမ်းများကို အင်တာနက်ပေါ်တွင် အောင်မြင်စွာ တင်ပြီး၍ လောလောဆယ် လုပ်ဆောင်နေပါသည်။ ဤအရာအတွက် အချိန် နည်းနည်း ကြာပါမည်။ ',
    check_email_upload_successful:
      'ကျေးဇူးပြု၍  <0>သင့် အီးမေးလ် ကို စစ်ပါ</0> အတွက် <1>အစီရင်ခံခြင်းကို</1> အင်တာနက်ပေါ်တွင် တင်ထားသော အသုံးပြုသူ စာရင်းအတွက်',
    is_private: 'သီးသန့် ကိုယ်ပိုင်ဖြစ်သည်'
  },

  account: {
    title: 'အကောင့်',
    subtitle:
      'သင့်၏ ချိန်ညှိချက် ဆက်တင်များနှင့် အကောင့် အချက်အလက်များကို စီမံခန့်ခွဲပါ.',
    saved: 'အကောင့် ကို အောင်မြင်စွာ ပြောင်းပြီးပြီ'
  },

  assessments: {
    title: 'အကဲဖြတ် သုံးသပ်ချက်များ',
    subtitle: 'အကဲဖြတ် သုံးသပ်မှု ဖန်တီးပါ',
    finished: 'အကဲဖြတ် သုံးသပ်ခြင်း ပြီးသွားပါပြီ',
    countdown: 'တိုက်ရိုက် အကဲဖြတ် သုံးသပ်ခြင်း ကို ထုတ်လွှင့်တော့ပါမည် ',
    create: 'အကဲဖြတ် သုံးသပ်မှု ဖန်တီးပါ',
    list_title: 'သင့်၏ အကဲဖြတ် သုံးသပ်ချက်များ',
    delete_warning: 'ဤ ဖိုင်ကို ပယ်ဖျက်လိုသည်မှာ သေချာပါသလား?',
    details_title: 'အကဲဖြတ် သုံးသပ်မှု အသေးစိတ်ကို ပေါင်းထည့်ပါ',
    details_subtitle:
      'သင့်၏ အကဲဖြတ် သုံးသပ်မှုကို နာမည်ပေးပြီး ပရိသတ်ကို သူတို့ဘာတွေသင်ယူနိုင်မည်ဆိုတာကို ပြောပြပါ။',
    disclaimer: `ကျွန်ုပ်၏ မှတ်တမ်းတင်ထားသော အရာသည် အာမခံပါသည်:
    - မည်သည့် တတိယပါတီ၏ အခွင့်အရေးကို မဆို ချိုးဖောက်မည် မဟုတ်ကြောင်း
    - အသရေဖျက်သော၊ ညစ်ညမ်းသော၊ မကြားဝံ့ မနာသာဖြစ်သော၊ မတရားသော၊ ကာမရာဂစိတ်ဖြစ်စေသော၊ ကြမ်းကြုတ်သော၊ ရုန့်ရင်းကြမ်းတမ်းသော၊ စော်ကားသော၊ ခြိမ်းခြောက်သော၊ သို့မဟုတ် တဘက်စောင်းနင်းနိုင်သော အကြောင်းအရာများ အစရှိသည်ဖြင့် တရားမမျှတမှုများ မပါဝင်ကြောင်း အကြောင်းအရာများကို အက်စတာရစ် ကြယ် သင်္ကေတ ဖြင့်တောင် မသိသာအောင် မပြုလုပ်ထားကြောင်း
    - တခြားလူများအပေါ်တွင် မည်သည်ပုဂ္ဂိုလ် ရေး တိုက်ခိုက်မှု မှ မပါဝင်ကြောင်း
    - တခြားပါဝင်သူများ၊ ထင်ရှား ကျော်ကြားသော သို့မဟုတ် လူသိများသော လူများအား အယောင်ဆောင်ခြင်းများ မပါဝင်ကြောင်း
    - တစ်ဦးချင်းစီ၏ ခွင့်ပြုချက် မရှိပဲ မည်သည့်တစ်ဦးချင်းစီ  အပေါ်တွင် မှတ်တမ်းတင်ခြင်း သို့မဟုတ် ပုဂ္ဂိုလ်ရေး သတင်းအချက်အလက်များ ရယူခြင်းတို့ မပြုလုပ်၍ ကမ္ဘာ့ မည်သည့် အစိတ်အပိုင်းတွင်ရှိသော မည်သည့် အချက်အလက်ဒေတာ ကာကွယ်သည့် စည်းမျဉ်းကိုမှ  မချိုးဖောက်ထားပါကြောင်း
    - မည်သည့် စီးပွားဖြစ် တောင်းဆိုခြင်း သို့မဟုတ် မည်သည့် တောင်းဆို ခွင့်ပြုခြင်း မရှိဘဲ ဝင်လာသော “စပမ်း” ပုံစံတစ်မျိုးမှ မပါဝင်ကြောင်း'`
  },

  buildersettings: {
    title: 'ချိန်ညှိချက် ဆက်တင်ကို ထုတ်ဝေပါ',
    subtitle:
      'သင့်၏ အစီအစဉ်ကို မည်သူကြည့်ရှုနိုင်သလဲနှင့် ပါဝင်ဆောင်ရွက်နိုင်သလဲ ဆိုသည့် ချိန်ညှိချက် ဆက်တင်ကို ပေါင်းထည့်ပါ'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'ပေါင်းထည့်ပါ',
    add_page: 'စာမျက်နှာ ပေါင်းထည့်ပါ',
    add_lesson: 'သင်ခန်းစာများ ပေါင်းထည့်ပါ',
    add_answer: 'အဖြေအသစ် ပေါင်းထည့်ပါ',
    add_group: 'အုပ်စု ပေါင်းထည့်ပါ',
    add_organization: 'အဖွဲ့အစည်း ပေါင်းထည့်ပါ',
    add_question: 'မေးခွန်း ပေါင်းထည့်ပါ',
    add_quiz: 'ဉာဏ်စမ်း ပဟေဠိ ပေါင်းထည့်ပါ',
    add_users: 'အသုံးပြုသူများ ပေါင်းထည့်ပါ',
    back: 'နောက်သို့',
    back_to_course: 'သင်တန်း ခြုံငုံ သုံးသပ်ချက် သို့ ပြန်သွားရန်',
    back_to_lesson: 'သင်ခန်းစာ ခြုံငုံ သုံးသပ်ချက် သို့ ပြန်သွားရန်',
    back_to_media: 'မီဒီယာ စာကြည့်တိုက်သို့ ပြန်သွားရန်',
    back_to_details: 'အသေးစိတ်သို့ ပြန်သွားရန်',
    cancel: 'ပယ်ဖျက်ပါ',
    clear: 'ရှင်းလင်းပါ',
    close: 'ပိတ်ပါ',
    clone: 'ပုံတူပွားပါ',
    close_lesson: 'သင်ခန်းစာကို ပိတ်ပါ',
    clone_course: 'သင်တန်းကို ပုံတူပွားပါ',
    confirm: 'အတည်ပြုပါ',
    create: 'ဖန်တီးသည်',
    download: 'ဒေါင်းလုပ်',
    download_mass_user_tamplate: 'ဒေါင်းလုပ် ပုံစံကွက်',
    add_mass_users: 'အစုလိုက် အပြုံလိုက် အသုံးပြုသူများ ပေါင်းထည့်ပါ',
    upload_excel_list: 'အိပ်စဲ စာရင်းကို အင်တာနက်ပေါ်သို့ တင်ပါ',
    delete: 'မီဒီယာကို ပယ်ဖျက်ပါ',
    edit: 'တည်းဖြတ်သည်',
    edit_course: 'သင်တန်းကို တည်းဖြတ်ပါ',
    enroll: 'စာရင်းသွင်းပါ',
    finish: 'ပြီးဆုံးသည်',
    upload_image: 'ပုံကို အင်တာနက်ပေါ်သို့ တင်ပါ',
    upload_image_video: 'ပုံ သို့မဟုတ် ဗီဒီယိိုကို အင်တာနက်ပေါ်သို့ တင်ပါ',
    select_media_library: 'မီဒီယာ စာကြည့်တိုက် ရွေးချယ်ပါ',
    make_public: 'အများပြည်သူသိအောင် လုပ်ပါ',
    make_private: 'သီးသန့်ကိုယ်ပိုင် လုပ်ပါ',
    make_org: 'အဖွဲ့အစည်း ဖွဲ့ပါ',
    media: 'မီဒီယာ စာကြည့်တိုက်',
    my_theme: 'ကျွန်ုပ်၏ ဆောင်ပုဒ်',
    next: 'နောက်တစ်ခုသို့',
    next_lesson: 'သင်ခန်းစာ နောက်တစ်ခုသို့',
    next_step: 'အဆင့် နောက်တစ်ခုသို့',
    previous_step: 'ရှေ့အဆင့်တစ်ခုသို့',
    publish: 'ထုတ်ဝေသည်',
    publish_assessment: 'သင့်၏ အကဲဖြတ် သုံးသပ်ချက် ကို ထုတ်ဝေသည်',
    publish_course: 'သင့်၏ သင်တန်းကို ထုတ်ဝေသည်',
    publish_event: 'သင့်၏ အစီအစဉ်ကို ထုတ်ဝေသည်',
    reset: 'အစမှ ပြန်စသည်',
    reset_elements: 'ပါဝင်သည့်အရာများကို အစမှပြန်စသည်',
    save: 'သိမ်းဆည်းပါ',
    creating: 'ဖန်တီးနေသည်...',
    updating: 'မွမ်းမံ အဆင့်မြင့်နေသည်...',
    saved: 'သိမ်းဆည်းထားသည်',
    save_for_later: 'နောက်ပိုင်းအတွက် သိမ်းဆည်းပါ',
    save_settings: 'ချိန်ညှိချက်များ သိမ်းဆည်းပါ',
    select_files: 'ဖိုင်များကို ရွေးချယ်ပါ',
    select_theme: 'အကြောင်းအရာ ခေါင်းစဉ် ရွေးချယ်ပါ',
    start_lesson: 'သင်ခန်းစာ စပါ',
    update: 'မွမ်းမံ အဆင့်မြင့်ပါ',
    upload: 'အင်တာနက်ပေါ် ဒေတာ တင်ပါ',
    upload_audio: 'အသံကို အင်တာနက်ပေါ် တင်ပါ',
    upload_photo: 'ကိုယ်ရေးအကျဥ်း ပရိုဖိုင် ဓာတ်ပုံ အင်တာနက်ပေါ် တင်ပါ',
    upload_video: 'ဗီဒီယို အင်တာနက်ပေါ် တင်ပါ',
    enrolled: 'စားရင်းသွင်းပြီး',
    unenroll: 'စာရင်းသွင်းထားသည်မှ ပယ်ဖျက်ပါ',
    from_library: 'မီဒီယာစာကြည့်တိုက်',
    remove: 'ဖယ်ရှားပါ',
    removed: 'ဖယ်ရှားပြီး',
    start_broadcast: 'စတင် ထုတ်လွှင့်သည်',
    end_broadcast: 'ထုတ်လွှင့်မှု အဆုံးသတ်သည်',
    camera: 'ကင်မရာ',
    screen: 'စက်ခရင် မျက်နှာပြင်',
    screen_with_camera: 'ကင်မရာ ပါသော စက်ခရင် မျက်နှာပြင်'
  },

  card: {
    quick_add: 'မြန်မြန် ထည့်ပါ',
    add: 'ပေါင်းထည့်ပါ',
    clone: 'ပုံတူပွားပါ',
    completed: 'သင်ခန်းစာများ ပြီးဆုံး'
  },

  course: {
    upcoming_course: 'နောင်လာမည့် သင်တန်း',
    unPublishEvent: 'မထုတ်လွှင့်သော အစီအစဉ်',
    unPublishAssessment: 'မထုတ်လွှင့်သော အကဲဖြတ် သုံးသပ်မှု',
    pastCourse: 'လေ့ကျင့်ရေး သင်တန်း',
    upcoming: 'လာမည့် တိုက်ရိုက် ဖြစ်ရပ်',
    pastEvent: 'ပြီးသွားသော တိုက်ရိုက် ဖြစ်ရပ်',
    pastAssessment: 'ပြီးသွားသော တိုက်ရိုက် အကဲဖြတ် သုံးသပ်မှု',
    upcomingAssessment: 'လာမည့် တိုက်ရိုက် အကဲဖြတ်သုံးသပ်မှု',
    created: 'ဖန်တီးခဲ့သော နေ့စွဲ: ',
    assignees: 'တာဝန် လွှဲအပ် ခံရသူ',
    organisations:
      ' {{ အဖွဲ့အစည်းများ }} အဖွဲ့အစည်းများ, <2> {{ အသုံးပြုသူများ }} အသုံးပြုသူများ </2>',
    event_date: 'တိုက်ရိုက် ဖြစ်ရပ် နေ့စွဲ <1> {{ နေ့စွဲ }} </1>',
    delete_warning: 'ဤအရာကို ဖျက်လိုသည်မှာ သေချာပါသလား?',
    clonning_no_lesson:
      'ဤသင်တန်းကို ပုံတူပွားရန် ကျေးဇူးပြု၍ အနည်းဆုံး သင်ခန်းစာ တစ်ခုထည့်ပါ',
    clone_warning: 'ဤအရာကို ပုံတူပွားလိုသည်မှာ သေချာပါသလား',
    clone_success: 'ပုံတူပွားနေသည့် ဖြစ်စဥ်တွင်',
    disclaimer: `ကျွန်ုပ်၏သင်တန်း သည် အာမခံပါသည်:
    - မည်သည့် တတိယပါတီ၏ အခွင့်အရေးကို မဆို ချိုးဖောက်မည် မဟုတ်ကြောင်း
    - အသရေဖျက်သော၊ ညစ်ညမ်းသော၊ မကြားဝံ့ မနာသာဖြစ်သော၊ မတရားသော၊ ကာမရာဂစိတ်ဖြစ်စေသော၊ ကြမ်းကြုတ်သော၊ ရုန့်ရင်းကြမ်းတမ်းသော၊ စော်ကားသော၊ ခြိမ်းခြောက်သော၊ သို့မဟုတ် တဘက်စောင်းနင်းနိုင်သော အကြောင်းအရာများ အစရှိသည်ဖြင့် တရားမမျှတမှုများ မပါဝင်ကြောင်း အကြောင်းအရာများကို အက်စတာရစ် ကြယ် သင်္ကေတ ဖြင့်တောင် မသိသာအောင် မပြုလုပ်ထားကြောင်း
    - တခြားလူများအပေါ်တွင် မည်သည်ပုဂ္ဂိုလ် ရေး တိုက်ခိုက်မှု မှ မပါဝင်ကြောင်း
    - တခြားပါဝင်သူများ၊ ထင်ရှား ကျော်ကြားသော သို့မဟုတ် လူသိများသော လူများအား အယောင်ဆောင်ခြင်းများ မပါဝင်ကြောင်း
    - တစ်ဦးချင်းစီ၏ ခွင့်ပြုချက် မရှိပဲ မည်သည့်တစ်ဦးချင်းစီ  အပေါ်တွင် ပုဂ္ဂိုလ်ရေး သတင်းအချက်အလက်များ ရယူခြင်းတို့ မပြုလုပ်၍ ကမ္ဘာ့ မည်သည့် အစိတ်အပိုင်းတွင်ရှိသော မည်သည့် အချက်အလက်ဒေတာ ကာကွယ်သည့် စည်းမျဉ်းကိုမှ  မချိုးဖောက်ထားပါကြောင်း
    - မည်သည့် စီးပွားဖြစ် တောင်းဆိုခြင်း သို့မဟုတ် မည်သည့် တောင်းဆို ခွင့်ပြုခြင်း မရှိဘဲ ဝင်လာသော “စပမ်း” ပုံစံတစ်မျိုးမှ မပါဝင်ကြောင်း'`
  },

  coursecreate: {
    dropzone_text: 'မီဒီယာ ထည့်သွင်းပါ',
    sidebar_text: 'ခေါင်းစဉ် ရွေးပါ <1/> အတွက် <3/> သင့်၏ သင်ခန်းစာများ',
    delete_warning: 'ဤသင်ခန်းစာကို ဖျက်လိုသည်မှာ သေချာပါသလား?'
  },

  coursepage: {
    quizview_loading: 'အဖြေများကို စစ်ဆေးနေပါသည်။ ကျေးဇူးပြု၍ စောင့်ပါ...',
    quizview_answer: 'သင့်၏ အဖြေ'
  },

  coursequiz: {
    title: 'သင်ခန်းစာ အားလုံးရှိ ဉာဏ်စမ်း ပဟေဠိများ'
  },

  dashboard: {
    tooltip_title: 'ဤဗီဒီယိုကို ထပ်မပြပါနဲ့တော့',
    page_title: 'သင့် သင်တန်းများ၏ စာရင်းအင်းများ',
    page_subtitle: 'သင်ဖန်တီးထားသော သင်တန်းများ၏ အခြေအနေ',
    profile_add_info:
      'ထည့်ပါ <1>{{သင့်၏ မပြည့်စုံသော စာသားကို}}</1> သင့်၏ ပရိုဖိုင်ကို ပြီးပြည့်စုံရန်အတွက်',
    profile_build:
      'သင့်၏ ပရိုဖိုင်ကို တည်ဆောက်ပါ <1>ဤနေရာတွင်</1>, သင်စိတ်ဝင်စားသော အရာများနှင့် ကျွမ်းကျင်သည့်အရာများကို ကျွန်တော်တို့ကို အသိပေးပါ',
    profile_title: 'ပရိုဖိုင် ခွန်အား',
    more_details: 'ပို၍ အသေးစိတ်'
  },

  errors: {
    answer: 'ကျေးဇူးပြု၍ အဖြေကို ထည့်သွင်းပါ',
    answer_correct: 'မှန်ကန်သော အဖြေကို ရွေးချယ်ပါ',
    code: 'ကျေးဇူးပြု၍ သင့်၏ ကုဒ်ကို ထည့်ပါ',
    criterion: 'ကျေးဇူးပြု၍ စံနှုန်းကို ထည့်ပါ',
    duration: 'ကြာမြင့်ချိန်ကို လိုအပ်ပါသည်',
    element: 'ကျေးဇူးပြု၍ ပါဝင်သည့်အရာများကို ထည့်ပါ',
    email: 'သင့်၏ အီးမေးလ် ကိုထည့်ပါ',
    email_invalid: 'ထည့်သွင်းလိုက်သည်မှာ မှန်ကန်သော အီးမေးလ်မဟုတ်ပါ',
    feedback_correct: 'ကျေးဇူးပြု၍ မှန်ကန်သော တုံ့ပြန်မှု ထည့်ပါ',
    feedback_incorrect: 'ကျေးဇူးပြု၍ မမှန်ကန်သော တုံ့ပြန်မှု ထည့်ပါ',
    host: 'ကျေးဇူးပြု၍ ဖြစ်ရပ်လုပ်ဆာင်သူ ထည့်ပါ ',
    host_assessment: 'ကျေးဇူးပြု၍ အကဲဖြတ် သုံးသပ်မှု လုပ်ဆောင်သူ ထည့်ပါ',
    image: 'ကျေးဇူးပြု၍ ပုံတစ်ခကို အင်တာနက်ပေါ်သို့ တင်ပါ',
    location: 'ကျေးဇူးပြု၍ သင့်၏ တည်နေရာကို ထည့်ပါ',
    live_location: 'ကျေးဇူးပြု၍ ထုတ်လွှင့်သည့်နေရာကို ရွေးပါ',
    limit:
      'ကျေးဇူးပြု၍ တိုက်ရိုက် ဒေတာ ပို့လွှတ်လက်ခံခြင်း မိနစ်များကို ထည့်သွင်းပါ ',
    min_3char: 'အနည်းဆုံး အက္ခရာ စာလုံး ၃လုံး',
    number: 'ကျေးဇူးပြု၍ အပေါင်း ကိန်းကို ထည့်ပါ',
    host_email_require: `လုပ်ဆောင်သူ၏ အီးမေးလ်များကို လိုအပ်ပါသည်`,
    attendee_email_require: `တက်ရောက်သူများ၏ အီးမေးလ်ကို လိုအပ်ပါသည်`,
    name: 'ကျေးဇူးပြု၍ သင့် နာမည်ကို ထည့်ပါ',
    not_found_course: 'သင်တန်းကို ရှာမတွေ့ပါ',
    not_found_event: 'ဖြစ်ရပ်ကို ရှာမတွေ့ပါ',
    not_found_assessment: 'အကဲဖြတ် သုံးသပ်မှုကို ရှာမတွေ့ပါ',
    password: 'ကျေးဇူးပြု၍ သင့်၏ စကားဝှက် ကို ထည့်ပါ',
    password_digit: 'အနည်းဆုံး ဂဏန်းတသ်ခု',
    password_short:
      'စကားဝှက် သည် တိုလွန်းနေပါသည်၊ အနည်းဆုံး အက္ခရာ စာလုံး ၁၀လုံး',
    password_special: 'အနည်းဆုံး အထူး အက္ခရာ တစ်လုံး',
    password_uppercase: 'အနည်းဆုံး စာလုံးအကြီး တစ်လုံး',
    password_lowercase: 'အနည်းဆုံး စာလုံးအသေးတစ်လုံး',
    phone: 'ကျေးဇူးပြု၍ သင့်၏ ဖုန်းကို ထည့်ပါ',
    phone_invalid: 'တရားမဝင် မမှန်ကန်သော ဖုန်းနံပတ်',
    position: 'ကျေးဇူးပြု၍ သင့်၏ ရာထူးကို ထည့်သွင်းပါ',
    question: 'ကျေးဇူးပြု၍ မေးခွန်းကို ထည့်သွင်းပါ',
    start_date: 'စတင်သည့် နေ့စွဲနှင့် အချိန်ကို လိုအပ်ပါသည်',
    tag: 'ချိတ်ဆွဲရန် ကတ်ပြားကို ရွေးချယ်ပါ',
    topics: 'ကျေးဇူးပြု၍ အနည်းဆုံး ခေါင်းစဉ် တစ်ခု ရွေးပါ။',
    live_topics: 'ကျေးဇူးပြု၍ ခေါင်းစဉ်များ ပေါင်းထည့်ပါ',
    title: 'ကျေးဇူးပြု၍ ခေါင်းစီး ထည့်သွင်းပါ',
    title_assessment: 'ကျေးဇူးပြု၍ အကဲဖြတ်သုံးသပ်မှု ခေါင်းစဉ် ထည့်သွင်းပါ',
    title_course: 'ကျေးဇူးပြု၍ သင်တန်းခေါင်းစဉ် ထည့်သွင်းပါ',
    title_empty: 'ခေါင်းစဉ်ကို အလွတ်ထား၍ မရနိုင်ပါ။',
    title_event: 'ကျေးဇူးပြု၍ ​ဖြစ်ရပ်ခေါင်းစဉ်ကို ထည့်သွင်းပါ',
    title_lesson: 'ကျေးဇူးပြု၍ သင်ခန်းစာ ခေါင်းစဉ် ကို ထည့်သွင်းပါ',
    title_quiz: 'ကျေးဇူးပြု၍ ဉာဏ်စမ်း ပဟေဠိ နာမည်ကို ထည့်သွင်းပါ',
    username: 'ကျေးဇူးပြု၍ သင့်၏ အသုံးပြုသူ နာမည်ကို ထည့်သွင်းပါ',
    upload_error: 'အမှား - ဖိုင်သည် သဟဇာတ မဖြစ်ပါ',
    upload_more_than_10:
      'သင်သည် အများဆုံး တစ်ကြိမ်လျှင် ၁၀ဖိုင်ကို အင်တာနက်ပေါ်သို့ တင်နိုင်ပါသည်',
    topics_max: 'ကျေးဇူးပြု၍ အများဆုံး ခေါင်းစဉ် ၃ ခု ပေါင်းထည့်ပါ။',
    upload_excel:
      'ကျေးဇူးပြု၍ မှန်ကန်သော ဖိုင်ကိုအင်တာနက်ပေါ် တင်ခဲ့သည်ကို သေချာအောင် ပြုလုပ်ပါ။',
    title_excel: 'အမှား အင်တာနက်ပေါ်သို့ တင်နေသော ပုံစံကွက်:',
    file_size_exceed: 'ဖိုင် အရွယ်အစား ကျော်လွန်နေပါသည်',
    subtitle_excel:
      'ကျေးဇူးပြု၍ ပေးထားသော ပုံစံကွက်ကို အသုံးပြုပြီးတော့ ကော်လံများကို မှန်မှန်ကန်ကန် ဖြည့်ထားခြင်းများကို သေချာအောင် ပြုလုက်ပါ။',
    select_broadcast_option:
      'ကျေးဇူးပြု၍ ဤဖြစ်ရပ်ကို ထုတ်လွှင့်နိုင်ရန် ရွေးချယ်စရာတစ်ခုကို ရွေးပါ',
    multi_hosts_number_error:
      'အစီအစဉ် တင်ဆက်သူ အရေအတွက်သည် ဤပွဲအတွက် သတ်မှတ်ထားသည့် အရေအတွက်ထက် ကျော်လွန်၍ မရနိုင်ပါ။ ',
    conference_people_number_error: `တက်ရောက်သူ အရေအတွက်သည် ဤပွဲအတွက် သတ်မှတ်ထားသည့် အရေအတွက်ထက် ကျော်လွန်၍ မရနိုင်ပါ။`,
    select_max_host: 'ပွဲအတွက် အနည်းဆုံး အစီအစဉ် တင်ဆက်သူ ၁ ယောက် ရွေးချယ်ပါ။',
    select_max_conference: 'ပွဲအတွက် အနည်းဆုံး တက်ရောက်သူ ၁ ယောက် ရွေးချယ်ပါ။',
    stream_stop_error: 'ဒေတာ ပို့လွှတ်လက်ခံခြင်း မထင်မှတ်ဘဲ ရပ်တန့်သွားပါသည်!',
    unsecure_context:
      'ဆိုးဝါးသော အမှားအပြစ်:ဘရောက်ဇာ သည် လုံခြုံမှုမရှိသော အရာများကြောင့် ကင်မရာနှင့် မိုက်ခ်ကို အသုံးပြုခွင့်မရနိုင်တော့ပါ။ ကျေးဇူးပြု၍ အက်စ်အက်စ်အယ်လ်(SSL) ကို အင်စတောလုပ်၍ https မှတဆင့် ဝင်ရောက် အသုံးပြုပါ။',
    ws_not_supported:
      'ဆိုးဝါးသော အမှားအပြစ်:websocket ကို ဤဘရောက်ဇာတွင် အထောက်အပံ့ မပေးထားပါ'
  },

  events: {
    title: 'တိုက်ရိုက် ပွဲစဉ် အသေးစိတ် ပေါင်းထည့်ပါ',
    change_host: 'တည်ဆောက်သူ ပြောင်းပါ',
    finished: 'ပွဲစဉ် ပြီးသွားပါပြီ',
    countdown: 'တိုက်ရိုက် ပွဲစဉ် ထုတ်လွှင့် ပါတော့မည်။ ',
    subtitle:
      'သင့်၏ တိုက်ရိုက် ပွဲစဉ် နာမည်ပေးပြီး ပရိသတ်ကို ဤပွဲမှ မည်သည့်အရာများ လေ့လာနိုင်သည်ကို ပြောပြပါ',
    poll_disabled: 'ဤပွဲတွင် မဲဆန္ဒပေးခြင်း မရရှိပါ',
    disclaimer: `ကျွန်ုပ်၏ မှတ်တမ်းတင်ထားသော အရာသည် အာမခံပါသည်:
    - မည်သည့် တတိယပါတီ၏ အခွင့်အရေးကို မဆို ချိုးဖောက်မည် မဟုတ်ကြောင်း
    - အသရေဖျက်သော၊ ညစ်ညမ်းသော၊ မကြားဝံ့ မနာသာဖြစ်သော၊ မတရားသော၊ ကာမရာဂစိတ်ဖြစ်စေသော၊ ကြမ်းကြုတ်သော၊ ရုန့်ရင်းကြမ်းတမ်းသော၊ စော်ကားသော၊ ခြိမ်းခြောက်သော၊ သို့မဟုတ် တဘက်စောင်းနင်းနိုင်သော အကြောင်းအရာများ အစရှိသည်ဖြင့် တရားမမျှတမှုများ မပါဝင်ကြောင်း အကြောင်းအရာများကို အက်စတာရစ် ကြယ် သင်္ကေတ ဖြင့်တောင် မသိသာအောင် မပြုလုပ်ထားကြောင်း
    - တခြားလူများအပေါ်တွင် မည်သည်ပုဂ္ဂိုလ် ရေး တိုက်ခိုက်မှု မှ မပါဝင်ကြောင်း
    - တခြားပါဝင်သူများ၊ ထင်ရှား ကျော်ကြားသော သို့မဟုတ် လူသိများသော လူများအား အယောင်ဆောင်ခြင်းများ မပါဝင်ကြောင်း
    - တစ်ဦးချင်းစီ၏ ခွင့်ပြုချက် မရှိပဲ မည်သည့်တစ်ဦးချင်းစီ  အပေါ်တွင် မှတ်တမ်းတင်ခြင်း သို့မဟုတ် ပုဂ္ဂိုလ်ရေး သတင်းအချက်အလက်များ ရယူခြင်းတို့ မပြုလုပ်၍ ကမ္ဘာ့ မည်သည့် အစိတ်အပိုင်းတွင်ရှိသော မည်သည့် အချက်အလက်ဒေတာ ကာကွယ်သည့် စည်းမျဉ်းကိုမှ  မချိုးဖောက်ထားပါကြောင်း
    - မည်သည့် စီးပွားဖြစ် တောင်းဆိုခြင်း သို့မဟုတ် မည်သည့် တောင်းဆို ခွင့်ပြုခြင်း မရှိဘဲ ဝင်လာသော “စပမ်း” ပုံစံတစ်မျိုးမှ မပါဝင်ကြောင်း'`,
    prompt_message:
      'ဤစာမျက်နှာမှ ထွက်ခွာခြင်းသည် သင့်ပွဲကို ပြီးဆုံးစေမည်ဖြစ်သည်။ ဤစာမျက်နှာမှ ထွက်လိုသည်မှာ သေချာပါသလား?',
    duration_exceed_message:
      ' သင့်၏ ထုတ်လွှင့်မှု အချိန်သည် သတ်မှတ်ထားသည်ထက် ကျော်လွန်သွားပါပြီ၊ အက်ပလီကေးရှင်းသည် ထုတ်လွှင့်မှုကို ရပ်တန့်တော့ပါမည်။',
    before_schedule_message:
      'သင်စီမံထားသော အစီအစဉ်အချိန် မတိုင်မီ သင်သည် ထုတ်လွှင့်မှု စတင်တော့မည်ဖြစ်သည်။ ထုတ်လွှင့်မှုကို ရပ်လိုက်ခြင်းသည် အစီအစဉ် အဆုံးသတ်စေမည်ဖြစ်ကြောင်း ကျေးဇူးပြု၍ သတိပြုစေလိုပါသည်။',
    browser_unsupportive_message:
      'သင့်၏ ဘရောက်ဇာ သည် စက်ခရင် မျက်နှာပြင် မျှဝေခြင်းကို မထောက်ပံ့ပေးထားပါ။ ဤ လင့်ခ်တွင် ထောက်ပံ့ပေးသော ဘရောက်ဇာများကို တွေ့နိုင်ပါသည်',
    cancel_switch_host_message:
      'ပြုလုပ်သူ မရနိုင်သေးပါ။ သင့် ဘက် အခြမ်းမှ ပွဲစဉ်ကို ဆက်လက် လုပ်ဆောင်သွားပါမည်။',
    coaching_prompt_message:
      'သင်သည် ပွဲစဉ် မပြီးသေးသရွေ့ ဤစာမျက်နှာမှ ထွက်ခွာ၍ မရနိုင်ပါ။',
    event_modal_warn: ' ဤပွဲစဉ် ထွက်ခွာလိုပါသလား?',
    confirm_message: 'အကယ်၍ အိုကေကို နှိပ်ပါက သင့်၏ ပွဲစဉ် ပြီးသွားပါမည်။',
    screen_share_denied:
      'သင့်၏ စက်ခရင် မျက်နှာပြင်ကို မျှဝေရန် သင်ငြင်းဆန်ထားပါသည်',
    media_not_found:
      'ကင်မရာ သို့မဟုတ် မိုက်ခ် ကို သင့်၏ စက်ကိရိယာတွင် ခွင့်မပြုထား သို့မဟုတ် ရှာမတွေ့ပါ။',
    media_not_access:
      'ကင်မရာ သို့မဟုတ် မိုက်ခ် ကို ကိရိယာတွေကို ပေးမဖတ်သော အခြား ဖြစ်စဉ်အချို့က အသုံးပြုနေသောကြောင့်လည်း ဖြစ်တယ်',
    constraint_error:
      'သင့်၏ ဗီဒီယို နှင့် အသံ ကန့်သတ်ထားမှုများဖြင့် ကိုက်ညီသော ကိရိယာ မရှိပါ။ ဗီဒီယို နှင့် အသံ ကန့်သတ်မှုများကို ပြောင်းလဲနိုင်ပါသည်',
    media_access_denied: 'ကင်မရာနှင့် မိုက်ခ်ကို အသုံးပြုရန် ခွင့်မပြုထားပါ။'
  },

  filters: {
    days7: 'နောက်ဆုံး ၇ ရက်',
    days15: 'နောက်ဆုံး ၁၅ ရက်',
    days30: 'နောက်ဆုံး ၃၀ ရက်',
    days365: 'နောက်ဆုံး ၃၆၅ ရက်',
    date: 'ဖန်တီးထားသော နေ့စွဲ',
    relevance: 'ဆက်စပ်ပတ်သက်မှု',
    popularity: 'ထင်ပေါ် ကျော်ကြားခြင်း',
    name: ' နာမည်',
    group: 'အုပ်စု',
    Newest_to_Oldest: 'အသစ်ဆုံးမှ အဟောင်းဆုံးသို့',
    Oldest_to_Newest: 'အဟောင်းဆုံးမှ အသစ်ဆုံးသို့',
    A_Z: 'A မှ Z',
    Z_A: 'Z မှ A'
  },

  helpers: {
    password:
      'သင့် အကောင့် လုံခြုံရေး အတွက် သင့်၏ စကားဝှက်တွင် အနည်းဆုံးစာလုံးအသေးတစ်လုံး၊ နံပါတ် တစ်ခု လိုအပ်သည်။ အနည်းဆုံးအက္ခရာ စာလုံး ၁၀ လုံး ရှိရန်လည်း လိုအပ်ပါသည်။',
    phone: 'ကျေးဇူးပြု၍ သင့် ဖုန်း နိုင်ငံကုဒ် ပါ ထည့်ပေးပါ၊ ဥပမာ +၆၅ ',
    username:
      'သင့်၏ အသုံးပြုသူနာမည်ကို အများပြည်သူနှင့်ဆိုင်သော အချက်အလက်အဖြစ် သတ်မှတ်ထား၍ လိုအပ်သကဲ့သို့ အခြားသော အသုံးပြုသူများနှင့် မျှဝေမည် ဖြစ်ပါသည်။ သို့ဖြစ်ပါ၍ သင့်၏ အသုံးပြုသူနာမည်တွင် ပုဂ္ဂိုလ်ရေး အချက်အလက်များ အသုံးမပြုပါရန် အကြံပေးအပ်ပါသည်။',
    public_description_normal:
      'သင့်၏ <0><0/></0> သိမ်းဆည်းထားပြီး ပုံမှန်အားဖြင့် သီးသန့်ဖြစ်သည်ဟု မှတ်ယူသည်။ ဆိုလိုသည်မှာ သင်တစ်ဦးတည်းသာ ပါဝင်သည့် အကြောင်းအရာများ ကို ကြည့်နိုင်ပါသည်။ ဤပါဝင် အကြောင်းအရာများကို ထုတ်ဝေလိုပါက အောက်တွင်ဖော်ပြထားသော ရွေးချယ်မှုများ ထဲမှ တစ်ခုကို သင် ရွေးချယ်နိုင်ပါသည်။ သင့်၏ သင်တန်းကို အများပြည်သူသို့ ထုတ်ဝေသည် ဆိုသည်မှာ ၎င်းသည် ပလက်ဖောင်းရှိ သုံးစွဲသူများ အားလုံးအတွက် ရရှိနိုင်မည်ဖြစ်သည်။ သတ်သတ်မှတ်မှတ် အသုံးပြုသူများ ရွေးချယ်စရာသည် ShareLook အကောင့် နှင့် ချိတ်ဆက်ထားသော အီးမေးလ် လိပ်စာသုံးထားသော သတ်မှတ်ထားသည့် အသုံးပြုသူနှင့် သင့်၏ သင်တန်းကို မျှဝေနိုင်ပါလိမ်မည်။',
    public_description_admin:
      'ဤ <0><0/></0> သိမ်းဆည်းထားပြီး ပုံမှန်အားဖြင့် သီးသန့်ဖြစ်သည်ဟု မှတ်ယူသည်။ ဆိုလိုသည်မှာ သင်တစ်ဦးတည်းသာ(အကြောင်းအရာ ကို ဖန်တီးသူနှင့် )  ပါဝင်သည့် အကြောင်းအရာများ ကို ကြည့်နိုင်ပါသည်။ ဤပါဝင် အကြောင်းအရာများကို ထုတ်ဝေလိုပါက အောက်တွင်ဖော်ပြထားသော ရွေးချယ်မှုများ ထဲမှ တစ်ခုကို သင် ရွေးချယ်နိုင်ပါသည်။ သင်၏သင်တန်းကိုအများပြည်သူသို့ပုံနှိပ်ထုတ်ဝေခြင်းသည်ဆိုလိုသည်မှာသင်၏အဖွဲ့အစည်းပြင်ပရှိသူများအပါအ ၀ င်ပလက်ဖောင်းရှိသုံးစွဲသူများအားလုံးရရှိနိုင်မည်ဖြစ်သည်။အဖွဲ့အစည်းသို့ထုတ်ဝေခြင်းဆိုသည်မှာအဖွဲ့အစည်းအတွင်းရှိသုံးစွဲသူများအားလုံးသည်၎င်းကိုမြင်နိုင်လိမ့်မည်ဟုဆိုလိုသည်။ ၎င်းကိုအုပ်စု ၁ ခုသို့မဟုတ်ထိုထက်ပိုသောအုပ်စုများသို့လည်းထုတ်ဝေနိုင်သည်။ ဆိုလိုသည်မှာထိုအုပ်စုများအတွင်းရှိသုံးစွဲသူများသာ၎င်းကိုမြင်နိုင်လိမ့်မည်။ နောက်ဆုံးအနေနဲ့၊ သင့်ရဲ့ Sharelook အကောင့်အီးမေးလ်လိပ်စာကိုအသုံးပြုပြီးသင့်အဖွဲ့အစည်းအတွင်းနှင့်ပြင်ပရှိသုံးစွဲသူများအား၎င်းကိုထုတ်ပြန်ရန်ရွေးစရာရှိတယ်'
  },

  labels: {
    add: 'ပေါင်းထည့်',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'အဖြေ အမျိုးအစား',
    answers: 'အဖြေများ',
    back_to_quiz: 'ဉာဏ်စမ်း ပဟေဠိ စာရင်း သို့ ပြန်သွားပါ',
    back_to_question: 'မေးခွန်းစာရင်းသို့ ပြန်သွားပါ',
    chat: 'Chat စကားစမြည်ပြောခြင်း',
    chat_available: 'စကားစမြည် ပြောခြင်းကို ဤပွဲစဉ်တွင် မရရှိပါ',
    chat_report: 'စကားစမြည် ပြောခြင်း အစီရင်ခံစာ',
    choice_single: 'ရွေးချယ်မှု တစ်ခုတည်း',
    choice_multiple: 'များစွာသော ရွေးချယ်မှု',
    choice_free: 'လွတ်လွတ်လပ်လပ်" ရွေးချယ်မှု',
    choice_sorting: '"အစီအစဉ် တကျ" ရွေးချယ်မှု',
    choice_matrix: '"မက်ထရစ် မျိုးတူစုခြင်း" ရွေးချယ်မှု',
    clone_lesson_permission: 'ပုံတူပွားမှု ခွင့်ပြုချက်',
    code: 'ကုဒ်',
    correct: 'မှန်သည်',
    created: 'ဖန်တီးထားသော နေ့စွဲ',
    clone_modal: 'ပုံတူပွားသော သင်တန်း',
    cloning_course: 'ပုံတူပွားနေသော သင်တန်း...',
    cloning: 'ပုံတူပွားနေသော',
    cloning_course_desc:
      'ဤဖြစ်စဉ် အချိန် နည်းနည်း ယူပါမည်။ ကျေးဇူးပြု၍ စိတ်ရှည်ပေးပါ',
    cloning_success: 'သင်တန်း "<0/>" အောင်မြင်စွာ ပုံတူပွားထားပြီးဖြစ်တယ်။! ',
    description: 'ဖော်ပြချက်',
    disclaimer: 'ငြင်းဆိုချက်',
    drop_file: 'ဖိုင်ကို ဤနေရာတွင် ချထားပါ...',
    duration: 'ကြာမြင့်ချိန်',
    edit: 'တည်းဖြတ်သည်',
    email: 'အီးမေးလ်',
    event: 'ပွဲစဉ်',
    event_all: 'သူ၏ ပွဲစဉ် အားလုံး',
    event_date: 'တိုက်ရိုက် ပွဲစဉ် ဒေသ နေ့စွဲ /အချိန်',
    event_this: 'ဤပွဲစဉ်',
    expire: 'သက်တမ်းကုန်ဆုံးသည်',
    expiry_date: 'သက်တမ်းကုန်သည့် နေ့စွဲ',
    forgot: 'စကားဝှက် မေ့နေပါသလား?',
    group: 'အုပ်စု',
    groups_list: 'အုပ်စုများ စာရင်း',
    host: 'အစီအစဉ် ပြုလုပ်သူ',
    id_annotation: 'မှတ်ချက် အိုင်ဒီ',
    id_quiz: 'ဉာဏ်စမ်း ပဟေဠိ အိုင်ဒီ',
    incorrect: 'မမှန်ကန်ပါ',
    interests: 'စိတ်ဝင်စားသော အရာများ',
    invited: 'ဖိတ်ခေါ်ပြီး',
    live_chat: 'တိုက်ရိုက် ဆွေးနွေးတိုင်ပင်ခြင်း',
    live_stream_limit: 'တိုက်ရိုက် ဒေတာပို့လွှတ်လက်ခံခြင်း မိနစ်များ',
    contact_text:
      'သင့်၏ လစဉ် တိုက်ရိုက် ဒေတာပို့လွှတ်လက်ခံခြင်း အကန့်အသတ်ကို ပြောင်းလဲရန် ကျေးဇူးပြု၍ ဆက်သွယ်ပေးပါ',
    contact_admin:
      '<0>အကယ်၍ သင့်၏ လစဉ် တိုက်ရိုက် ဒေတာပို့လွှတ်လက်ခံခြင်း အကန့်အသတ်ကို ပြောင်းလဲလိုပါက ကျေးဇူးပြု၍ ဆက်သွယ်ပေးပါ </0><1>admin@sharelook.com</1>',
    limit_stream_text:
      'ကျန်ရှိသော တိုက်ရိုက် ဒေတာ ပို့လွှတ်လက်ခံခြင်း မိနစ်များ: <0>{{ အကန့်အသတ်}}</0>  မိနစ်များ <1/><2/> <3> သင့်၏ လစဉ် တိုက်ရိုက် ဒေတာပို့လွှတ်လက်ခံခြင်း အကန့်အသတ်ကို ပြောင်းလဲလိုပါက ကျေးဇူးပြု၍ ဆက်သွယ်ပေးပါ </3> <4>admin@sharelook.com</4>',
    location: 'တည်နေရာ',
    lessons: 'သင်ခန်းစာများ',
    location_broadcast: 'တည်ထောင်သူ ဆာဗာ တည်နေရာ',
    location_broadcast_subtitle:
      'အသံရုပ်မြင် နှောင့်နှေးမှုကို လျှော့ချရန် မူလ ပင်ရင်းထုတ်လွှင့်သော နေရာနှင့် အနီးဆုံး ဖြစ်သော တည်နေရာကို ပေါင်းထည့်ပါ',
    media_manager: 'မီဒီယာ မန်နေဂျာ',
    minutes: 'မိနစ်များ',
    name: 'နာမည်',
    online_quiz: 'အွန်လိုင်း ဉာဏ်စမ်း ပဟေဠိ',
    organiser: 'စာရေးသူ',
    organization: 'အဖွဲ့အစည်း',
    overall_emotion: ' ခြုံငုံ အတွေ့အကြုံ:',
    organizations_list: 'အဖွဲ့အစည်းများ စာရင်း',
    password: 'စကားဝှက်',
    participants: 'ပါဝင်သူများ',
    picture: 'ဓာတ်ပုံ (၁၆:၉)',
    phone: 'ဖုန်း',
    photo: 'ဓါတ်ပုံ',
    poll: 'မဲကောက်ခံမှု ',
    position: 'ရာထူး',
    processing: 'ဆောင်ရွက်နေသည်',
    privacy_settings: 'ကိုယ်ရေးလုံခြုံမှု ဆက်တင်များ',
    question: 'မေးခွန်း',
    quiz_create: 'ဉာဏ်စမ်း အသစ် ဖန်တီးပါ',
    quiz_name: 'ဉာဏ်စမ်း ပဟေဠိ နာမည်',
    quiz_update: 'ဉာဏ်စမ်း ပဟေဠိ မွမ်းမံ အဆင့်မြှင့်ပါ',
    select_organization: 'အဖွဲ့အစည်း တစ်ခု ရွေးချယ်ပါ',
    settings: 'ချိန်ညှိချက် ဆက်တင်များ',
    show: 'ပြပါ',
    show_graph: 'ဂရပ်ဖ် ရလဒ် ပြပါ',
    signin: 'မှတ်ပုံတင် ဝင်ရောက်ပါ',
    signup: 'စာရင်းသွင်းပါ',
    sort_by: 'အလိုက် စဉ်သည်',
    start_date: 'စတင်သည့် နေ့စွဲ',
    tags: 'ချိတ်ဆွဲရန် ကတ်ပြားများ',
    terms: 'ကျွန်ုပ်သည် သဘောတူပါသည် <1> ဤ စည်းကမ်းနှင့်သတ်မှတ်ချက်များ ကို</1>',
    title: 'ခေါင်းစီး',
    topics: 'ခေါင်းစဉ်များ',
    topic: 'ခေါင်းစဉ်',
    total_comments: 'မှတ်ချက်များ စုစုပေါင်း',
    username: 'အသုံးပြုသူ နာမည်',
    users_list: 'အသုံးပြုသူများ စာရင်း',
    users_emails: 'သတ်သတ်မှတ်မှတ် အသုံးပြုသူများ၏ အီးမေးလ်များကို ထည့်သွင်းပါ',
    description_specifiction_email:
      'အသုံးပြုသူ မျိုးစုံနှင့် မျှဝေနိုင်ရန် ကျေးဇူးပြု၍ တစ်ကြောင်းလျှင် အီးမေးလ်လိပ်စာ ၁ ခု ရိုက်ထည့်ပါ။',
    message_specific_email:
      'ကျေးဇူးပြု၍ သတ်သတ်မှတ်မှတ် ဖြစ်သော အသုံးပြုသူ၏ အီးမေးလ်များ ကို ထည့်သွင်းပါ',
    viewers: 'ကြည့်ရှုသူများ',
    edit_course: 'တည်းဖြတ်ပါ',
    edit_assessment: 'တည်းဖြတ်ပါ',
    edit_event: 'တည်းဖြတ်ပါ',
    delete_course: 'ပယ်ဖျက်သည်',
    delete_event: 'ပယ်ဖျက်သည်',
    delete_assessment: 'ပယ်ဖျက်သည်',
    view_course: 'ကြည့်ရှုသည်',
    view_event: 'ကြည့်ရှုသည်',
    view_assessment: 'ကြည့်ရှုသည်',
    date_event: 'တိုက်ရိုက် ပွဲစဉ် နေ့စွဲ',
    date_assessment: 'တိုက်ရိုက် အကဲဖြတ် သုံးသပ်မှု နေ့စွဲ',
    clone_of: 'ပုံတူပွားပါ',
    clone_course:
      'သင်ခန်းစာများနှင့် စာမျက်နှာများ အားလုံး ပါဝင်သော မူရင်းကို လွတ်လွတ်လပ်လပ် ပြင်ဆင်နိုင်ရန် ဤသင်တန်း၏ ပုံတူပွားခြင်းကို ဖန်တီးပါ။',
    make: 'ပြုလုပ်ပါ',
    available_to: 'မည်သည့် ShareLook အသုံးပြုသူမဆို ရရှိနိုင်ပါသည်',
    uploaded_by: 'အင်တာနက်ပေါ်သို့ ဒေတာ တင်ပြီးပါပြီ:',
    course: 'သင်တန်း',
    assessment: 'အကဲဖြတ် သုံးသပ်မှု',
    user_not_exist: 'အသုံးပြုသူသည် မတည်ရှိပါ၊ ဖိတ်စာပို့ချင်ပါသလား?',
    check_user: 'အသိပေးစာ',
    user_not_exist_in_org:
      'အသုံးပြုသူသည် ဤအဖွဲ့အစည်းတွင် မတည်ရှိပါ၊ ဖိတ်စာပို့ချင်ပါသလား?',
    title_modal_stream:
      'အဖွဲ့အစည်း တိုက်ရိုက် ဒေတာ ပို့လွှတ်လက်ခံခြင်း အကန့်အသတ် ပြောင်းလဲပါ',
    des_warning_stream: 'သင်သည် ပြောင်းပါတော့မည်',
    monthly_stream: 'လစဉ် တိုက်ရိုက် ဒေတာ ပို့လွှတ်လက်ခံခြင်း အကန့်အသတ်',
    min_per_month: 'မိနစ်များ/လ',
    broadcast_label: 'ပြုလုပ်လိုပါသည်:',
    hosts_emails: `သတ်သတ်မှတ်မှတ် တည်ထောင်သူ၏ အီးမေးလ်များကို ထည့်သွင်းပါ`,
    attendee_emails: `သတ်သတ်မှတ်မှတ် တက်ရောက်သူ၏ အီးမေးလ်များကိုထည့်သွင်းပါ`,
    description_host_specifiction_email:
      'ကျေးဇူးပြု၍ တစ်ကြောင်းလျှင် အီးမေးလ်လိပ်စာ ၁ ခု ရိုက်ထည့်ပါ။',
    presenter_label: 'အစီအစဉ် တင်ဆက်သူ',
    presenter_label_conference: 'လူအရေအတွက်',
    event_privacy: 'ညီလာခံ မုဒ်'
  },

  broadcastOptions: {
    stream_from_phone: 'မိမိဖုန်းဖြင့် တိုက်ရိုက် ထုတ်လွှင့်မှု',
    other_webrtc:
      'ကျွန်ုပ်၏ ကွန်ပြူတာမှ အင်တာနက်ပေါ်တွင်လုပ်သော တွေ့ဆုံဟောပြောပွဲ',
    multihost:
      'ကျွန်ုပ်၏ ကွန်ပြူတာမှ အများနှင့်ချိတ်ဆက်ထားသော ကွန်ပြူတာမှ အင်တာနက်ပေါ်တွင်လုပ်သော တွေ့ဆုံဟောပြောပွဲ',
    peer2peer: 'နည်းပြ အစည်းအဝေး’',
    conference: 'တိုက်ရိုက် ထုတ်လွှင့် ညီလာခံ'
  },

  lessoncreate: {
    title: 'သင်ခန်စာ အသေးစိတ်ကို ပေါင်းထည့်ပါ',
    subtitle:
      'သင့်၏ သင်ခန်းစာကို နာမည်ပေးပြီး ဘာတွေ လေ့လာ သင်ယူနိုင်သည်ကို သင်တန်းသားများကို ပြောပြပါ။',
    input_label_title: 'သင်ခန်းစာ ခေါင်းစီး',
    input_label_topics: 'သင်ခန်းစာ ခေါင်းစဉ်များ',
    input_label_description: 'သင်ခန်းစာ ဖော်ပြချက်',
    delete_warning: 'ဤစာမျက်နှာကို ဖျက်လိုသည်မှာ သေချာပါသလား?'
  },

  lessonoverview: {
    title: 'သင်ခန်းသာ ပေါင်းထည့်ပါ',
    subtitle: 'လက်ရှိ သင်ခန်းစာကို ပေါင်းထည့်ပါ သို့မဟုတ် အသစ်တစ်ခု ဖန်တီးပါ',
    new_lesson: 'သင်ခန်းစာအသစ် တစ်ခုကို ဖန်တီးပါ',
    new_lesson_sub: 'သင်ခန်းစာ အသစ်စက်စက် တစ်ခုကို အကြမ်းထည် မှစ၍ ဖန်တီးပါ!',
    existing_lesson: 'လက်ရှိ သင်ခန်းစာကို ရွေးပါ',
    existing_lesson_sub:
      'လက်ရှိသင်ခန်းစာနှင့် ချိတ်ဆက်ထားသည်၊ အဆိုပါ သင်ခန်းစာတွင် ပြောင်းလဲထားသောအရာများသည် အခြားသင်တန်းများ အပေါ်တွင်လည်း သက်ရောက်စေမှု ရှိပါသည်။',
    clone_lesson: 'လက်ရှိ သင်ခန်းစာကို ပုံတူပွားပါ',
    clone_lesson_sub:
      'ဤသင်တန်းတွင်ရှိသော သင်ခန်းစာနှင့်ထပ်တူညီသော ကော်ပီတစ်ခု ပြုလုပ်ပါ၊ အဆိုပါသင်ခန်းစာတွင် ပြောင်းလဲထားသောအရာများသည် မူရင်းသင်ခန်းစာအပေါ် သက်ရောက်စေမှု မရှိပါ။',
    clone_lesson_modal_sub:
      'သင့်၏ သင်တန်းသို့ ပေါင်းထည့်လိုသော သင်ခန်းစာအောက်ရှိ ပုံတူပွားပါ ခလုပ်ကို ကျေးဇူးပြု၍ နှိပ်ပါ။'
  },

  management: {
    groups_title: 'အုပ်စုများကို စီမံခန့်ခွဲပါ',
    delete_warning: 'သေချာပါသလား?',
    organizations_title: 'ကျွန်ုပ်၏ အဖွဲ့အစည်းများ',
    organizations_subtitle: 'သင့်၏ စာရင်းတွင် အဖွဲ့အစည်းများကို ပေါင်းထည့်ပါ',
    users_title: 'အသုံးပြုသူများကို စီမံခန့်ခွဲပါ',
    users_position: 'စီနီယာ အကောင့် မန်နေဂျာ',
    user_not_found: 'အသုံးပြုသူ ရှာမတွေ့ပါ',
    select_org:
      'ကျေးဇူးပြု၍ အသုံးပြုသူများကို စီမံ ခန့်ခွဲရန် အဖွဲ့အစည်းတစ်ခုကို ရှာ၍ ရွေးချယ်ပါ'
  },

  audio: {
    modal_title: 'အသံကို ထည့်သွင်းပါ',
    list_view: 'ကြည့်ရှုမှု စာရင်း',
    create_audio_modal_title: 'အသံကို ဖန်တီးပါ',
    edit_audio_modal_title: 'အသံ တည်းဖြတ်ပါ',
    public_audio_not_found: 'အသံ ရှာမတွေ့ပါ',
    private_audio_not_found: 'မည်သည့် အသံကိုမှ အင်တာနက်ပေါ်သို့ မတင်ရသေးပါ',
    are_you_sure_to_delete: 'ဖျက်လိုသည်မှာ သေချာပါသလား?',
    type_something: 'တစ်စုံတစ်ခု စာရိုက်ပါ',
    select_voice: 'ရွေးချယ်ပါ',
    file_name: 'ဖိုင်နာမည်',
    description: 'ဖော်ပြချက်',
    topic: 'ခေါင်းစီး',
    key_words_tag: 'သော့ချက်စာလုံးများ ချိတ်ဆွဲရန်စာတန်း',
    mp3_audio: 'အမ်ပီ၃ အသံ',
    created: 'ဖန်တီးပြီး',
    duration: ' ကြာမြင့်ချိန်',
    close: 'ပိတ်ပါ'
  },

  image: {
    modal_title: ' ပုံ ထည့်သွင်းပါ',
    image: 'ပုံ',
    pixel: 'ပစ်စယ်',
    dimension: 'အတိုင်းအတာ',
    public_image_not_found: 'ပုံကို ရှာမတွေ့ပါ။',
    private_image_not_found: 'မည်သည့်ပုံမှ အင်တာနက်ပေါ်သို့ မတင်ရသေးပါ'
  },

  annotation: {
    modal_title: 'မှတ်ချက်'
  },

  text: {
    modal_title: 'စာသား တည်းဖြတ်သူ'
  },

  video: {
    modal_title: 'ဗီဒီယို ထည့်သွင်းပါ',
    image: 'ဗီဒီယို',
    mp4_video: 'အမ်ပီ၄ ဗီဒီယို',
    public_video_not_found: 'ဗီဒီယို ရှာမတွေ့ပါ',
    private_video_not_found: 'မည်သည့် ဗီဒီယိုမှ အင်တာနက်ပေါ်သို့ မတင်ရသေးပါ'
  },

  media: {
    title: 'မီဒီယာ စာကြည့်တိုက်',
    subtitle: 'သင့် ဖိုင်များအတွက် စာကြည့်တိုက်',
    modal_title: 'မီဒီယာကို အင်တာနက်ပေါ်သို့ င်ပါ',
    delete_warning: 'ဖျက်သည်ကို အတည်ပြုပါ',
    delete_message:
      'ဖျက်ထားသောမီဒီယာသည် သူတို့ကိုအသုံးပြုထားသော စာမျက်နှာတွင် ပေါ်နေပါဦးမည်',
    dropzone_text: 'သို့မဟုတ် ဆွဲ၍ ချပါ',
    delete_success: 'မီဒီယာကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ',
    upload_file: 'ဖိုင်ကို အင်တာနက်ပေါ်သို့ တင်ပါ',
    drag_drop: 'သို့မဟုတ် ဆွဲ၍ ချပါ',
    import_file: 'သင့်၏ ကွန်ပြူတာမှ ဖိုင်များကို တင်သွင်းပါ',
    no_media: 'သင် မည်သည့်မီဒီယာကိုမှ အင်တာနက်ပေါ်သို့ မတင်ရသေးပါ',
    media_type: 'မီဒီယာ အမျိုးအစား',
    video: 'ဗီဒီယို',
    image: 'ပုံ',
    audio: 'အသံ',
    gif: ' ဂျီအိုင်အက်ဖ်',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'မီဒီယာ ရှာမတွေ့ပါ',
    of: '၏',
    disclaimer: `ကျွန်ုပ်၏မီဒီယာ သည် အာမခံပါသည်:
    - မည်သည့် တတိယပါတီ၏ အခွင့်အရေးကို မဆို ချိုးဖောက်မည် မဟုတ်ကြောင်း
    - အသရေဖျက်သော၊ ညစ်ညမ်းသော၊ မကြားဝံ့ မနာသာဖြစ်သော၊ မတရားသော၊ ကာမရာဂစိတ်ဖြစ်စေသော၊ ကြမ်းကြုတ်သော၊ ရုန့်ရင်းကြမ်းတမ်းသော၊ စော်ကားသော၊ ခြိမ်းခြောက်သော၊ သို့မဟုတ် တဘက်စောင်းနင်းနိုင်သော အကြောင်းအရာများ အစရှိသည်ဖြင့် တရားမမျှတမှုများ မပါဝင်ကြောင်း အကြောင်းအရာများကို အက်စတာရစ် ကြယ် သင်္ကေတ ဖြင့်တောင် မသိသာအောင် မပြုလုပ်ထားကြောင်း
    - တခြားလူများအပေါ်တွင် မည်သည်ပုဂ္ဂိုလ် ရေး တိုက်ခိုက်မှု မှ မပါဝင်ကြောင်း
    - တခြားပါဝင်သူများ၊ ထင်ရှား ကျော်ကြားသော သို့မဟုတ် လူသိများသော လူများအား အယောင်ဆောင်ခြင်းများ မပါဝင်ကြောင်း
    - တစ်ဦးချင်းစီ၏ ခွင့်ပြုချက် မရှိပဲ မည်သည့်တစ်ဦးချင်းစီ  အပေါ်တွင် မှတ်တမ်းတင်ခြင်း သို့မဟုတ် ပုဂ္ဂိုလ်ရေး သတင်းအချက်အလက်များ ရယူခြင်းတို့ မပြုလုပ်၍ ကမ္ဘာ့ မည်သည့် အစိတ်အပိုင်းတွင်ရှိသော မည်သည့် အချက်အလက်ဒေတာ ကာကွယ်သည့် စည်းမျဉ်းကိုမှ  မချိုးဖောက်ထားပါကြောင်း
    - မည်သည့် စီးပွားဖြစ် တောင်းဆိုခြင်း သို့မဟုတ် မည်သည့် တောင်းဆို ခွင့်ပြုခြင်း မရှိဘဲ ဝင်လာသော “စပမ်း” ပုံစံတစ်မျိုးမှ မပါဝင်ကြောင်း'`
  },

  navigation: {
    account: 'အကောင့်',
    assessments: 'အကဲဖြတ် သုံးသပ်မှုများ',
    dashboard: 'အသုံးပြုသူ မျက်နှာပြင်',
    groups: 'အုပ်စု စီမံခန့်ခွဲမှု',
    logout: 'ထွက်သည်',
    organisations: 'အဖွဲ့အစည်းများ',
    organizations_users: ' အဖွဲ့အစည်းများနှင့် အသုံးပြုသူများ',
    reports: 'အစီရင်ခံစာများ',
    schedule: 'အချိန်ဇယား',
    nowLive: 'ထုတ်လွှင့်သည်',
    training: 'လေ့ကျင့်ရေး',
    users: 'Users အသုံးပြုသူများ',
    workshop: 'ကျွန်ုပ်၏ အလုပ်ရုံ'
  },

  onboarding: {
    step1_title: 'အဆင့်၁:သင့် အကြောင်း ကျွန်တော်တို့ကို နည်းနည်း ပြောပြပါလား',
    step1_subtitle: 'နာမည် ဘယ်လို ခေါ်လဲ? ဘယ်ကလာတာလဲ? အလုပ်ရာထူးက ဘာပါလဲ?',
    step2_title: 'အဆင့်၂:သင် တိုးတက်နိုင်သေးသော ကျွမ်းကျင်မှု အချို့ကို ရွေးပါ',
    step2_subtitle:
      'နောက်ပြီး သင်နောက်ထပ် ပိုပြီးနားလည်ချင်တာ ရှိပါသေးသလဲ? သင်နားလည်ဖို့လိုအပ်နေတဲ့ တစ်ခုခုလား? လေ့လာမှု နယ်ပယ် အသစ်တစ်ခုလား? သင်ချစ်တဲ့သူ ဘာတွေလုပ်နေသလဲ?'
  },

  pagebuilder: {
    title: 'သင်ခန်းစာ ဖန်တီးပါ',
    subtitle:
      'သင့်၏ သင်တန်းသားများ သင့် ထံမှ သင်ယူနိုင်ရန် သင်ကြားမည့် အကြောင်းအရာ ကို ဖန်တီးရန် အချိန်ရောက်ပါပြီ၊ ပုံများ၊ ဗီဒီယိုများ နှင့် သရုပ်ပြပုံများလည်း ပေါင်းထည့်နိုင်ပါသည်',
    select_layout: 'စာမျက်နှာ အပြင်အဆင် ရွေးချယ်ပါ',
    template1: 'ဗလာ',
    template2: 'ခေါင်းစဉ် နှင့် စာတန်းထိုး',
    template3: 'ခေါင်းစဉ် နှင့် စာသား',
    template4: 'ခေါင်းစဉ်၊ မီဒီယာ နှင့် စာသား',
    template5: 'ခေါင်းစဉ် နှင့် မီဒီယာ',
    template6: 'ခေါင်းစဉ် နှင့် ဉာဏ်စမ်း ပဟေဠိ'
  },

  pageconstructor: {
    title: 'သင်ခန်းသာကို ဖန်တီး၍ ပုံတူပွားပါ',
    subtitle:
      'သင့်၏ သင်တန်းသားများ သင့် ထံမှ သင်ယူနိုင်ရန် သင်ကြားမည့် အကြောင်းအရာ ကို ဖန်တီးရန် အချိန်ရောက်ပါပြီ၊ ပုံများ၊ ဗီဒီယိုများ နှင့် သရုပ်ပြပုံများလည်း ပေါင်းထည့်နိုင်ပါသည်'
  },

  passwordreset: {
    success_coded:
      'အတည်ပြုသည့် ကုဒ်ကို သင်ပေးထားသော လိပ်စာသို့ အီးမေးလ် ပို့လိုက်ပါပြီ၊ စကားဝှက် အသစ် ရယူရန် ကုဒ်ကို အောက်တွင်ရှိသော နေရာတွင် ကော်ပီကူးပါ ',
    success_changed:
      'စကားဝှက် အသစ်ကို အောင်မြင်စွာ ပြုလုပ်ပြီးပါပြီ။ သင်ယခု မှတ်ပုံတင် ဝင်ရောက်နိုင်ပါပြီ။'
  },

  placeholders: {
    search: 'ရှာဖွေပါ',
    answer: 'အဖြေ',
    chat: 'တစ်ခုခု ပြောပါ...',
    code: 'ကုဒ်',
    criterion: 'စံနှုန်း',
    date_event: 'နေ့စွဲ နှင့် အချိန် ရွေးပါ',
    date_start: 'စတင်သည့် အချိန်',
    date_expire: 'သက်တမ်းကုန်ဆုံးရက်',
    description: 'ဖော်ပြချက်',
    elements: 'ပါဝင်သည့်အရာများကို အစဥ်လိုက်စီပါ',
    email: 'အီးမေးလ်',
    feedback_correct: 'တုံ့ပြန်ချက် မှန်ကန်',
    feedback_incorrect: 'တုံ့ပြန်ချက် မမှန်ကန်',
    host: 'တည်ဆောက်သူ',
    keywords: 'သော့ချက်စာလုံး(များ) ရှာပါ',
    lesson_description: 'သင်ခန်းစာ ဖော်ပြချက်',
    location: 'တည်နေရာ',
    minutes: 'မိနစ်များ',
    name: 'နာမည်',
    organiser: 'စာရေးသူ',
    organization: 'အဖွဲ့အစည်း',
    password: 'စကားဝှက်',
    phone: 'ဖုန်း',
    photo: 'ဓာတ်ပုံ',
    picture: 'ရုပ်ပုံ',
    point: 'အမှတ်',
    position: 'ရာထူး',
    question: 'မေးခွန်း',
    quiz: 'ဉာဏ်စမ်း ပဟေဠိ',
    search_course: 'သင်တန်းဖြင့် ရှာဖွေခြင်း',
    search_media: 'မီဒီယာ ရှာပါ',
    search_name: 'နာမည်ဖြင့် ရှာပါ',
    search_title: 'ခေါင်းစီးဖြင့် ရှာပါ',
    search_training: 'လေ့ကျင့်ရေး ဖြင့် ရှာပါ',
    settings: 'ဆက်တင်များ',
    tags: 'ချိတ်ဆွဲရန် ကတ်ပြားများ',
    title: 'ခေါင်းစီး',
    topics: 'ခေါင်းစဉ်များ',
    username: 'အသုံးပြုသူနာမည်',
    keyword: 'သော့ချက်စာလုံးများ',
    max_500_characters: 'အများဆုံး အက္ခရာ စာလုံး ၅၀၀',
    no_description: 'ဤဖိုင်တွင် ဖော်ပြချက် မပါရှိပါ',
    no_keyword: 'ဤဖိုင်တွင် မည်သည့် သော့ချက်စာလုံးများ မှ မရှိပါ',
    no_topics: 'ဤဖိုင်တွင် ခေါင်းစဉ် အစု မရှိပါ',
    feedback: 'သတင်း',
    contact: 'ဘယ်လို အကူအညီ ပေးရမလဲ?'
  },

  publishsettings: {
    title: 'ဆက်တင်များ ထုတ်ဝေသည်',
    event_subtitle:
      'သင့်ပွဲကို မည်သူ ကြည့်ရှုနိုင်ပြီး ပါဝင်ပတ်သက်နိုင်သနည်း ဆိုသော ဆက်တင်ကို ပေါင်းထည့်ပါ',
    assessment_subtitile:
      'သင့်၏ အကဲဖြတ် သုံးသပ်မှု ကိုနာမည်ပေး၍ သင်တန်သားများကို ဘာတွေလေ့လာ သင်ယူနိုင်မည်ဆိုသလဲကို ပြောပြပါ',
    course_subtitle:
      'သင့် သင်တန်းကို မည်သူ ကြည့်ရှုနိုင်ပြီး ပါဝင်ပတ်သက်နိုင်သနည်း ဆိုသော ဆက်တင်ကို ပေါင်းထည့်ပါ',
    /* disclaimer:

  1.	မှတ်ပုံတင်ခြင်း

  အသုံးပြုသူအဖြစ်မှတ်ပုံတင်ခြင်း၊ အကောင့်တစ်ခုဖွင့်ခြင်းအားဖြင့်ကျွန်ုပ်တို့ [အသုံးပြုသူသဘောတူညီချက်ကို] သဘောတူပြီးကျွန်ုပ်တို့၏ [သီးသန့်တည်ရှိမှုမူဝါဒ]ကိုဖတ်ခြင်းအားဖြင့်သင်သဘောတူသည်

  2.	သင်တန်းဖန်တီးပါ

  ကျွန်ုပ်တို့၏ကိရိယာများကို သုံး၍ သင်တန်းအကြောင်းအရာကိုဖန်တီးခြင်းအားဖြင့်ကျွန်ုပ်တို့၏ [အသုံးပြုသူသဘောတူညီချက်] ကိုသင်သဘောတူပြီးကျွန်ုပ်တို့၏ [သီးသန့်လုံခြုံရေးပေါ်လစီ] ကိုဖတ်ခြင်းအားဝန်ခံသည်

  3.	Create event

  ကျွန်ုပ်တို့၏ကိရိယာများကို သုံး၍ သင်တန်းအကြောင်းအရာကိုဖန်တီးခြင်းအားဖြင့်ကျွန်ုပ်တို့၏ [အသုံးပြုသူသဘောတူညီချက်] ကိုသင်သဘောတူပြီးကျွန်ုပ်တို့၏ [သီးသန့်လုံခြုံရေးပေါ်လစီ] ကိုဖတ်ခြင်းအားဝန်ခံသည်

  4.	Create assessment

  ကျွန်ုပ်တို့၏ကိရိယာများကို သုံး၍ သင်တန်းအကြောင်းအရာကိုဖန်တီးခြင်းအားဖြင့်ကျွန်ုပ်တို့၏ [အသုံးပြုသူသဘောတူညီချက်] ကိုသင်သဘောတူပြီးကျွန်ုပ်တို့၏ [သီးသန့်လုံခြုံရေးပေါ်လစီ] ကိုဖတ်ခြင်းအားဝန်ခံသည်
    , */
    dates_validation_error: 'နေ့စွဲ နှစ်ခုလုံးကို ဖြည့်ပါ။',
    emails_validation_error: 'အီးမေးလ် စာရင်း သည် မမှန်ကန်ပါ။',
    specific_email_validation_error: 'အီးမေးလ် တစ်ခုတည်းသာ ခွင့်ပြုထားပါသည်။',
    i_agree_to_these: 'ကျွန်ုပ် သဘောတူပါသည်',
    terms_and_conditions: 'စည်းကမ်းနှင့်သတ်မှတ်ချက်များ ကို',
    PublicDescription:
      'အခမဲ့လွတ်လပ်သောသုံးစွဲသူမျာ: (ပုဂ္ဂလိကနှင့်အများပိုင်ရွေးချယ်မှုများ)သင်၏ [သင်တန်း | အဖြစ်အပျက် | အကဲဖြတ်ခြင်း]ကိုသိမ်းဆည်းပြီးပုံမှန်အားဖြင့်လျှို့ဝှက်သည်ဟုမှတ်ယူသည်။ဆိုလိုသည်မှာသင်သည်သာဤအကြောင်းအရာမြင်နိုင်သည်။ဤအကြောင်းအရာကိုထုတ်ဝေရန်သင်အောက်တွင်ဖော်ပြထားသောလူသိရှင်ကြားဖြစ်စေရန်ရွေးချယ်နိုင်သည်။ဆိုလိုသည်မှာသင်တန်းကိုပလက်ဖောင်းရှိအသုံးပြုသူများအားလုံးရရှိနိုင်မည်ဖြစ်သည်။',
    OrganisationsDescription:
      'အဖွဲ့အစည်းအသုံးပြုသူများ: ("ပြီးပြီ" အစား "ထုတ်ဝေသည်" "ကိုသုံးပြီး ထိုအရာများကို အခြားအသုံးပြုသူများကဲ့သို့  မည်သည့်ထုတ်ဝေရန် ရွေးချယ်ခွင့်မျှ မရှိသော်လည်း ထုတ်ဝေစာမျက်နှာသို့ ဆောင်ခဲ့ရမည်။) သင်၏ [သင်တန်း | အဖြစ်အပျက် | အကဲဖြတ်ခြင်း] ကိုသိမ်းဆည်းပြီး လျှို့ဝှက်သည်ဟု မှတ်ယူသည်။ ဆိုလိုသည်မှာသင်နှင့်သင်၏အဖွဲ့အစည်းမှအုပ်ချုပ်ရေးမှူးများသာယင်းကိုမြင်တွေ့နိုင်သည်။အသုံးပြုသူအနေဖြင့်သင်၏အုပ်ချုပ်ရေးဆိုင်ရာအခွင့်အရေးများလိုအပ်သည့်အတွက်သင်၏အဖွဲ့အစည်းအတွင်း၌သင်၏အကြောင်းအရာများကိုကိုယ်တိုင်ထုတ်ဝေရန်မစွမ်းနိုင်ပါ။ကျေးဇူးပြု၍သင်၏အုပ်ချုပ်ရေးမှူးတစ်ဦးကိုဆက်သွယ်ပြီးသင်၏အကြောင်းအရာကိုလူအများသိအောင်၊အဖွဲ့အစည်းတစ်ခုလုံး၊သင့်အဖွဲ့အစည်းအတွင်းရှိတိကျသောအုပ်စုများသို့မဟုတ်တိကျသောအသုံးပြုသူများကိုထုတ်ဝေရန်ပြောပါ။.',
    OrganisationGroupsDescription:
      'အဖွဲ့အစည်းအုပ်ချုပ်ရေးမှူးများ: (အဖွဲ့အစည်းအတွင်းလုပ်သောအကြောင်းအရာများအတွက် - ပုဂ္ဂလိက၊ အများပြည်သူ၊အဖွဲ့အစည်း၊အုပ်စုများ၊သတ်သတ်မှတ်မှတ်သုံးစွဲသူများအတွက်): ဒီ [သင်တန်း | ဖြစ်ရပ်|အကဲဖြတ်ခြင်း]ကိုသိမ်းဆည်းထားပြီးပုံမှန်အားဖြင့်လျှို့ဝှက်သည်ဟုမှတ်ယူသည်။ ဆိုလိုသည်မှာဤအကြောင်းအရာကိုသင်(နှင့်အကြောင်းအရာဖန်တီးသူ) သာလျှင်တွေ့နိုင်သည်။ဤအကြောင်းအရာကိုထုတ်ပြန်ရန်သင်သည်အောက်ဖော်ပြပါရွေးချယ်စရာများကိုရွေးချယ်နိုင်သည်။ သင်၏သင်တန်းကိုအများပြည်သူသို့ပုံနှိပ်ထုတ်ဝေခြင်းသည်ဆိုလိုသည်မှာသင်၏အဖွဲ့အစည်းပြင်ပရှိသူများအပါအ ၀င်ပလက်ဖောင်းရှိသုံးစွဲသူများအားလုံးရရှိနိုင်မည်ဖြစ်သည်။  အဖွဲ့အစည်းသို့ထုတ်ဝေခြင်းဆိုသည်မှာအဖွဲ့အစည်းအတွင်းရှိသုံးစွဲသူများအားလုံးသည်၎င်းကိုမြင်နိုင်လိမ့်မည်ဟုဆိုလိုသည်။ ၎င်းကိုအုပ်စု ၁ ခုသို့မဟုတ်ထိုထက်ပိုသောအုပ်စုများသို့လည်းထုတ်ဝေနိုင်သည်။ ဆိုလိုသည်မှာထိုအုပ်စုများအတွင်းရှိသုံးစွဲသူများသာ၎င်းကိုမြင်နိုင်လိမ့်မည်။ နောက်ဆုံးအနေနဲ့၊ သင့်ရဲ့ Sharelook အကောင့်အီးမေးလ်လိပ်စာကိုအသုံးပြုပြီးသင့်အဖွဲ့အစည်းအတွင်းနှင့်ပြင်ပရှိသုံးစွဲသူများအား၎င်းကိုထုတ်ပြန်ရန်ရွေးစရာရှိတယ်။',
    SpecificUsersDescription:
      'ပေးဆောင်ထားသည့် လွတ်လပ်သောသုံးစွဲသူမျာ: (ပုဂ္ဂလိက၊ အများပိုင်နှင့်သတ်သတ်မှတ်မှတ်သုံးစွဲသူများ) သင်၏ [သင်တန်း | အဖြစ်အပျက် | အကဲဖြတ်ခြင်း] ကိုသိမ်းဆည်းပြီးပုံမှန်အားဖြင့်လျှို့ဝှက်သည်ဟုမှတ်ယူသည်။ ဆိုလိုသည်မှာသင်သည်သာဤအကြောင်းအရာမြင်နိုင်သည်။ဤအကြောင်းအရာကိုထုတ်ပြန်ရန်သင်သည်အောက်ဖော်ပြပါရွေးချယ်စရာများကိုရွေးချယ်နိုင်သည်။သင်၏သင်တန်းကိုအများပြည်သူသို့ပုံနှိပ်ထုတ်ဝေခြင်းသည်ဆိုလိုသည်မှာ၎င်းသည်ပလက်ဖောင်းရှိသုံးစွဲသူများအားလုံးရရှိနိုင်မည်ဖြစ်သည်။တိကျသောအသုံးပြုသူများရွေးချယ်မှုသည်သင်၏ Sharelook အကောင့်နှင့်သက်ဆိုင်သောအီးမေးလ်လိပ်စာကို သုံး၍ တိကျသောအသုံးပြုသူများနှင့်သင်၏သင်တန်းကိုမျှဝေရန်ကူညီလိမ့်မည်။'
  },

  quiz: {
    quiz_empty: 'ဉာဏ်စမ်း ပဟေဠိ မဖန်တီးရသေးပါ',
    questions_empty: 'မေးခွန်းတစ်ခု မဖန်တီးရသေးပါ'
  },

  regions: {
    asia_pacific_australia: 'သြစတြေးလျ',
    asia_pacific_india: 'အိန္ဒိယ',
    asia_pacific_japan: 'ဂျပန်',
    asia_pacific_s_korea: 'တောင်ကိုရီးယား',
    asia_pacific_singapore: 'စင်ကာပူ',
    asia_pacific_taiwan: 'ထိုင်ဝမ်',
    eu_belgium: 'ဘယ်လဂျီယမ်',
    eu_germany: 'ဂျာမနီ',
    eu_ireland: 'အိုင်ယာလန်',
    south_america_brazil: 'ဘရာဇီး',
    us_central_iowa: 'အိုင်အိုဝါ',
    us_east_s_carolina: 'တောင်ကာယိုလိုင်းနား',
    us_east_virginia: 'ဗာဂျီးနီးယား',
    us_west_california: 'ကယ်လီဖိုးနီးယား',
    us_west_oregon: 'အော်ရီဂွန်'
  },

  reports: {
    title: 'အစီရင်ခံစာများ'
  },

  signup: {
    success_step1:
      'အတည်ပြုသည့် ကုဒ်ကို သင်ပေးထားသော လိပ်စာသို့ အီးမေးလ် ပို့လိုက်ပါပြီ၊ စကားဝှက် အသစ် ရယူရန် ကုဒ်ကို အောက်တွင်ရှိသော နေရာတွင် ကော်ပီကူးပါ',
    success_step2: 'ကျေးဇူးပါ။ သင် အောင်မြင်စွာ မှတ်ပုံတင် ပြီးပါပြီ။',
    privacy: `ကျွန်ုပ်သည် ShareLook ၏ <1> စည်းကမ်းနှင့်သတ်မှတ်ချက်များ </1> နှင့် <3> ကိုယ်ရေးအချက်အလက် မူဝါဒ </3>`
  },

  stream: {
    emotion_impressive: 'အထင်ကြီးစရာကောင်းသော',
    emotion_unimpressive: 'အထင်ကြီးစရာ မကောင်းသော',
    message_not_started: 'မကြာမီ လာမည်',
    message_running: 'တိုက်ရိုက် ထုတ်လွှင့်',
    message_processing:
      'ပြန်ဖွင့်ရန်အတွက် တိုက်ရိုက် အသံသွင်းခြင်းကို လောလောဆယ် ဆောင်ရွက်နေပါသည်။ ကျေးဇူးပြု၍ ဗီဒီယိုကြည့်ရန်၊ အဆင့်သတ်မှတ်ချက်နှင့် တုံ့ပြန်မှု တို့ကို ဆက်လက်ပေါင်းထည့်ရန် နောက်မှ ပြန်စစ်ဆေးပါ'
  },

  tabs: {
    audience: 'သင်တန်းသား ပရိသတ်',
    course: 'သင်တန်း ခြုံငုံ သုံးသပ်ချက်',
    details: 'တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ် အသေးစိတ်',
    description: 'ဖော်ပြချက်',
    host: 'တည်ထောင်သူ',
    lesson: 'သင်ခန်းစာ ခြုံငုံ သုံးသပ်ချက်',
    lessons: 'သင်ခန်းစာများ',
    overview: 'ခြုံငုံ သုံးသပ်ချက်',
    page: 'စာမျက်နှာ တည်ဆောက်သူ',
    publish: 'ထုတ်ဝေသည်',
    settings: 'ဆက်တင် ထုတ်ဝေသည်',
    total_views: 'စုစုပေါင်း ကြည့်ရှုမှု',
    live_participates: 'တိုက်ရိုက် ထုတ်လွှင့် ပါဝင်သူများ',
    live_chats: 'တိုက်ရိုက် ထုတ်လွှင့် စကားစမြည် ပြောခြင်း',
    live_quiz: 'တိုက်ရိုက် ထုတ်လွှင့် မဲဆန္ဒကောက်ခြင်း',
    trainer_rating: 'သင်တန်းဆရာ အဆင့် သတ်မှတ်ချက်',
    trainer_times: 'သင်တန်းဆရာ အချိန်များ',
    courses_quizzes: 'သင်တန်း ဉာဏ်စမ်း ပဟေဠိများ',
    user_list: 'အသုံးပြုသူ စာရင်း',
    discussion: 'ဆွေးနွေးတိုင်ပင်မှု',
    notes: 'ကျွန်ုပ်၏ မှတ်စုများ'
  },

  topics: {
    SALES_TRAINING: 'အရောင်းသင်တန်း',
    NEGOTIATION_TRAINING: 'စေ့စပ် ညှိနှိုင်း သင်တန်း',
    CROSS_CULTURAL_AWARENESS: 'ယဥ်ကျေးမှု အပြန်အလှန် နားလည်သဘောပေါက်မှု',
    NETWORKING_SKILLS: 'ကွန်ရက် ကျွမ်းကျင်မှု',
    SOFTWARE_ARCHITECTURE: 'ဆော့ဖ်ဝဲ ဗိသုကာ',
    PROJECT_MANAGEMENT: 'စီမံကိန်း စီမံခန့်ခွဲမှု',
    DIGITAL_TRANSFORMATION: 'ဒစ်ဂျစ်တယ် အသွင်ပြောင်း',
    IT_CONSULTING: 'အိုင်တီ အတိုင်ပင်ခံ',
    MANAGEMENT_CONSULTING: 'စီမံခန့်ခွဲမှု အတိုင်ပင်ခံ',
    HR_CONSULTING: 'လူ့စွမ်းအား အရင်းအမြစ် အတိုင်ပင်ခံ',
    INTERNET_OF_THINGS: 'အရာအားလုံးအတွက် အင်တာနက်',
    CYBERSECURITY: 'ဆိုင်ဘာ လုံခြုံရေး',
    PRIVACY_AND_GDRP:
      'ကိုယ်ရေးအချက်အလက် နှင့် အထွေထွေ ဒေတာ ကာကွယ်စောင့်ရှောက်ရေးသည်းမျဥ်း '
  },

  training: {
    title: 'လေ့ကျင့်ရေး',
    title_assessment: 'အကဲဖြတ် သုံးသပ်ချက်များ',
    subtitle: 'သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်များ',
    enrolled_title:
      'စာရင်းသွင်းပြီး သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်များ',
    enrolled_subtitle:
      'သင်စာရင်းသွင်းထားသော သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်များ ',
    enrolled_message:
      'သင်သည် လောလောဆယ် မည်သည့် သင်တန်းများနှင့် ပွဲစဥ်များတွင် စာရင်းမသွင်းထားပါ။',
    past_live_event_title: 'ပြီးခဲ့သော တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဉ်',
    past_live_event_subTitle: 'ပြီးဆုံးသွားသော တိုက်ရိုက် ထုတ်လွှင့်  ပွဲစဉ်',
    past_live_event:
      'လောလောဆယ် ပြီးခဲ့သော တိုက်ရိုက် ထုတ်လွှင့်  ပွဲစဉ် မရှိပါ။',
    recomended_title:
      'အကြံပြု ထောက်ခံသော သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့်  ပွဲစဉ်',
    now_live_event_title: 'ယခု တိုက်ရိုက်ထုတ်လွှင့်',
    now_live_event_subTitle:
      'တိုက်ရိုက် ထုတ်လွှင့် နေသော သို့မဟုတ် မကြာခင် တိုက်ရိုက် လွှင့်တော့မည့်  ပွဲစဉ်',
    now_live_event: 'လောလောဆယ် တိုက်ရိုက် ထုတ်လွှင့်  ပွဲစဉ် မရှိပါ။',
    webinar_event_title: 'အင်တာနက်ပေါ်တွင်လုပ်သော တွေ့ဆုံဟောပြောပွဲ ချန်နယ်',
    webinar_event_subTitle:
      'ပြီးသွားသော အင်တာနက်ပေါ်တွင်လုပ်သော တွေ့ဆုံဟောပြောပွဲ',
    webinar_event:
      'အင်တာနက်ပေါ်တွင်လုပ်သော တွေ့ဆုံဟောပြောပွဲ အစီအစဉ်များ မရှိပါ',
    p2p_event_title: 'နည်းပြ အစည်းအဝေး',
    p2p_event_subTitle: 'ပြီးသွားသော နည်းပြ အစည်းအဝေး',
    p2p_event: 'လောလောဆယ်နည်းပြ အစည်းအဝေး မရှိပါ',

    now_live_assessment_title: 'ယခု တိုက်ရိုက်ထုတ်လွှင့်',
    now_live_assessment_subTitle:
      'တိုက်ရိုက် ထုတ်လွှင့် နေသော သို့မဟုတ် မကြာခင် တိုက်ရိုက် လွှင့်တော့မည့် အကဲဖြတ် သုံးသပ်မှုများ',
    now_live_assessment_message:
      'လောလောဆယ် တိုက်ရိုက် လွှင့်တော့မည့် အကဲဖြတ် သုံးသပ်မှု မရှိပါ',

    upcoming_assessment_title:
      'လာမည့် တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှုများ',
    upcoming_assessment_subtitle:
      'လာမည့် တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှုများ',
    upcoming_assessment_message:
      'လောလောဆယ် လာမည့် တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှု မရှိပါ။',

    past_live_assessment_title:
      'ပြီးခဲ့သော တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှုများ',
    past_live_assessment_subTitle:
      'ပြီးဆုံးသွားသော တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှုများ',
    past_live_assessment_message:
      'လောလောဆယ် ပြီးခဲ့သော တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ်သုံးသပ်မှု မရှိပါ',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'အပေါ် အခြေခံ၍ ကျွန်ုပ်တို့သည် သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဉ် ကို ဖန်တီးထားပါသည် <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'လေ့ကျင့်ရေး ရှာဖွေပါ',
    search_assessment: 'အကဲဖြတ် သုံးသပ်မှု ရှာဖွေပါ',
    recomended_message:
      'အကြံပြု ထောက်ခံသော သင်တန်းများနှင့် ပွဲစဥ်များ လောလောဆယ် မရှိပါ။'
  },

  warnings: {
    delete: 'သေချာပါသလား?'
  },

  workshop: {
    title: 'ကျွန်ုပ်၏ အလုပ်ရုံ',
    subtitle:
      'သင်တန်းတစ်ခု ဖန်တီးပါ သို့မဟုတ် သင့်ကိုယ်ပိုင် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ် တစ်ခုကို တည်ဆောက်ပါ',
    new_course: 'သင်တန်းအသစ်တစ်ခု ဖန်တီးပါ',
    new_event: 'တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ် အသစ်တစ်ခု ဖန်တီးပါ',
    new_assessment:
      'တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှု အသစ်တစ်ခု ဖန်တီးပါ',
    courses_title:
      'ဖန်တီးထားသော သင်တန်းများနှင့် တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်များ',
    courses_subtitle:
      'သင် ဖန်တီးထားသော သင်တန်းနှင့် စီစဉ်ထားသော တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်များကို တည်းဖြတ်၍ ထုတ်ဝေပါ',
    tags_course: 'သင်တန်း',
    tags_live: 'တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ်',
    tags_assessment: 'တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ် သုံးသပ်မှု'
  },

  help_center: {
    sidebar: {
      title: 'ဘယ်လို ကူညီရပါမလဲ?',
      back_to: 'အသုံးပြုသူ မျက်နှာပြင်'
    },
    menu: {
      help_center: 'အကူအညီ စင်တာ',
      whats_new: 'ဘာထူးသလဲ',
      feedback: 'တုံ့ပြန်မှု',
      feedback_title: 'ShareLook သို့ တုံ့ပြန်မှု ပို့ပါ',
      terms_and_conditions: 'စည်းကမ်းနှင့်သတ်မှတ်ချက်များ ',
      privacy_policy: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ ',
      contact_us: 'ကျွန်ုပ်တို့ကို ဆက်သွယ်ပါ'
    },
    get_started: {
      title: 'ShareLook စတင် အသုံးပြုခြင်း',
      description: {
        main:
          'တိုက်ရိုက် ထုတ်လွှင့် ဗီဒီယိုကို အသုံးပြုရန် လွယ်ကူသော သင်တန်းတည်ဆောက်သူ အဖြစ် ပေါင်းစပ် တည်ဆောက်ထားပါတယ်',
        tagline:
          'ShareLook ၏ မူပိုင်ခွင့်ရထားသော တိုက်ရိုက် ထုတ်လွှင့် စနစ်နှင့်အတူ သင်သည် ထိတွေ့ဆက်ဆံမှုကို ဖန်တီးနိုင်ခြင်း၊ အလိုအလျောက် လေ့လာခြင်းနှင့် အသိပညာ မျှဝေမှု အမြင့်ဆုံး ပြုလုပ်နိုင်ခြင်း စသည်တို့ကို ပြုလုပ်နိုင်ပါသည်။'
      }
    },
    whats_new: {
      title: 'ShareLook ကို စတင် အသုံးပြုခြင်း',
      description: {
        main:
          'ပုံပြောသည့် စနစ်ဖြင့် လေ့လာခြင်းကို အချိန်အနည်းငယ်အတွင်းတွင် ဖန်တီးနိုင်ခြင်းနှင့် စျေးလည်း သိပ်မကြီးသည်ကို သင်သိပါသလား? သင်သည် ShareLook ၏ သင်တန်းတည်ဆောက်သူ နှင့် သက်ဆိုင်သော ပါရမီရှင်များ ကို ပေါင်းစပ်သင့်ပါသည်။ "မည်သို့လဲ" ဆိုသည်ကို ကျွန်ုပ်တို့ကို မေးနိုင်ပါသည်။',
        tagline: ''
      }
    },
    create_workshop: 'အလုပ်ရုံတစ်ခု မည်သို့ ဖန်တီးပါသနည်း',
    create_course: 'သင်တန်းတစ်ခု မည်သို့ ဖန်တီးပါသနည်း',
    create_user: 'အသုံးပြုသူ တစ်ယောက် မည်သို့ ဖန်တီးပါ သနည်း',
    create_group: 'အုပ်စု တစ်ခု မည်သို့ ဖန်တီးပါ သနည်း',
    create_webinar:
      'အင်တာနက်ပေါ်တွင် ပြုလုပ်သော တွေ့ဆုံပွဲ မည်သို့ ဖန်တီးပါ သနည်း',
    create_live_event:
      'တိုက်ရိုက် ထုတ်လွှင့် ပွဲစဥ် ကို မည်သို့ ဖန်တီးပါ သနည်း',
    create_live_assessment:
      'တိုက်ရိုက် ထုတ်လွှင့် အကဲဖြတ်သုံးသပ်မှု မည်သို့ ဖန်တီးပါ သနည်း',
    create_live_on_mobile:
      'မိုလ်ဘိုင်းဖုန်းတွင် တိုက်ရိုက် ထုတ်လွှင့်မှု ဖန်တီးခြင်း',
    personalize_profile: 'ပရိုဖိုင်ကို ကိုယ်ပိုင်ပြုလုပ်ပါ',
    manage_group: 'အုပ်စု ကို စီမံခန့်ခွဲပါ',
    report: 'အစီရင်ခံသည်',
    add_annotations: 'မှတ်ချက်များ/ပေါ့အပ်များ မည်သို့ ပေါင်းထည့်ပါ သနည်း',
    add_audio: 'အသံကို မည်သို့ ပေါင်းထည့်ပါ သနည်း',
    add_header_and_footer: 'ခေါင်းစဉ် နှင့်အောက်ခြေ ပေါင်းထည့်ခြင်း',
    add_image: 'ပုံ မည်သို့ ပေါင်းထည့်ပါ သနည်း',
    add_quiz_content: 'ပဟေဠိ ပါအ​ကြာင်းအရာကို မည်သို့ ပေါင်းထည့်ပါ သနည်း',
    add_text_content: 'စာသားပါ အကြောင်းအရာ ကို မည်သို့ပေါင်းထည့်ပါ သနည်း',
    add_user: 'အသုံးပြုသူ မည်သို့ ပေါင်းထည့်ပါ သနည်း',
    add_video: 'ဗီဒီယို မည်သို့ပေါင်းထည့်ပါ သနည်း',
    clone_course: 'သင်တန်းကို မည်သို့ ပုံတူပွား ပါသနည်း',
    find_live_broadcast: 'တိုက်ရိုက် ထုတ်လွှင့်မှု ကို မည်သို့ ရှာဖွေပါ သနည်း',
    contact_us: {
      title: 'ကျွန်ုပ်တို့ကို ဆက်သွယ်ပေးပါ။',
      subject_placeholder: 'အကြောင်းအရာ* ရိုက်ထည့်ပါ',
      content_placeholder: 'မက်ဆေ့ချ်* တစ်ခု ရိုက်ထည့်ပါ',
      subject_required: '*အကြောင်းအရာ လိုအပ်ပါသည်',
      content_required: '*မက်ဆေ့ချ် လိုအပ်ပါသည်',
      submit: 'ပို့သည်',
      cancel: 'ပယ်ဖျက်သည်',
      sent: 'ပို့ပြီး'
    },
    feedback: {
      title: 'ShareLook သို့ တုံ့ပြန်မှု ပို့ပါ',
      attach_title: 'ဖိုင်တစ်ခု တွဲပါ',
      choose: 'ဖိုင် ရွေးချယ်ပါ',
      detail: 'အထောက်အပံ့ အဖွဲ့နှင့် ဖိုင်ကို မျှဝေထားပါသည်',
      content_placeholder: 'မက်ဆေ့ချ်* တသ်ခု ရိုက်ထည့်ပါ',
      content_required: '*မက်ဆေ့ချ် လိုအပ်သည်',
      submit: 'ပို့သည်',
      cancel: 'ပယ်ဖျက်သည်',
      sent: 'ပိုပြီး'
    }
  },
  discussion: {
    join_discussion: 'ဆွေးနွေးမှုတွင် ပါဝင်ပါ'
  },
  notes: {
    title: 'ကျွန်ုပ်၏ မှတ်စုများ',
    add_note: 'မှတ်စုအသစ် ပေါင်းထည့်ပါ'
  }
}
